<!-- 
  kpi POR DIRECTOR

  CADA DEPARTAMENTO TIENE SU PROPIO KPI, EL CUAL SE DIVIDIRA POR ESCUELA

  DEPARTAMENTO: RH, COMERCIAL, FINANZAS, TI, OPERACIONES

  ESCUELA: FAST, INBI

  Agregar colorimetría
  Amarillo: 70% - 80%
  Verde: > 80%  
  Rojo: 0% - 70%
-->
<template>
  <v-container class="mt-5 ml-2" fluid >
    <v-row>
      <v-col cols="12">
        <v-card class="transparent elevation-0">
          <v-card-title primary-title class="text-subtitle-1">
            Kpi por departamento
            <v-spacer></v-spacer>

            <v-btn 
            	color="primary"
            	@click="initialize()" 
            	small
            	tile
            >
          		Consultar
          	</v-btn>
          </v-card-title>


          <!-- Contenido de la pagina -->
          <v-card-text>

          	<!-- Filtros -->
          	<v-row v-if="kpiDashboardSinKpiAsignado">
              <v-col cols="12">
                <v-alert type="warning" dense outlined class="mb-0">
                  Su puesto no tiene un panel KPI asignado en esta vista. Si requiere acceso, contacte a sistemas.
                </v-alert>
              </v-col>
            </v-row>

            <v-row v-if="mostrarControlCardsKpi" class="mb-2">
              <v-col cols="12">
                <v-card outlined tile class="pa-3">
                  <div class="text-subtitle-2 mb-2">Control de cards KPI</div>
                  <v-row dense>
                    <v-col cols="12" sm="6" md="4" lg="3"><v-checkbox hide-details dense v-model="cardsVisibles.operacionesNI" label="Op. Inscritos NI" /></v-col>
                    <v-col cols="12" sm="6" md="4" lg="3"><v-checkbox hide-details dense v-model="cardsVisibles.operacionesRI" label="Operaciones - %RI" /></v-col>
                    <v-col cols="12" sm="6" md="4" lg="3"><v-checkbox hide-details dense v-model="cardsVisibles.operacionesMoney" label="Operaciones - $$" /></v-col>
                    <v-col cols="12" sm="6" md="4" lg="3"><v-checkbox hide-details dense v-model="cardsVisibles.rhOcupacion" label="RH - %Ocupación" /></v-col>
                    <v-col cols="12" sm="6" md="4" lg="3"><v-checkbox hide-details dense v-model="cardsVisibles.comercialConversion" label="Comercial" /></v-col>
                    <v-col cols="12" sm="6" md="4" lg="3"><v-checkbox hide-details dense v-model="cardsVisibles.tiTickets" label="TI" /></v-col>
                    <v-col cols="12" sm="6" md="4" lg="3"><v-checkbox hide-details dense v-model="cardsVisibles.finanzasEgreso" label="Finanzas" /></v-col>
                    <v-col cols="12" sm="6" md="4" lg="3"><v-checkbox hide-details dense v-model="cardsVisibles.operacionesClases" label="Operaciones - Clases" /></v-col>
                    <v-col cols="12" sm="6" md="4" lg="3"><v-checkbox hide-details dense v-model="cardsVisibles.controlInternoVentas" label="Control I. - Procesos" /></v-col>
                    <v-col cols="12" sm="6" md="4" lg="3"><v-checkbox hide-details dense v-model="cardsVisibles.mantenimientoTickets" label="Mantenimiento" /></v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>

          	<v-row>
              <v-col cols="12" sm="4" lg="3" xl="2">
                <v-text-field
                  label="Fecha de incio"
                  filled
                  dense
                  clearable
                  v-model="fechaini"
                  type="date"
                ></v-text-field>
              </v-col>

              <v-col cols="12" sm="4" lg="3" xl="2">
                <v-text-field
                  label="Fecha final"
                  filled
                  dense
                  clearable
                  v-model="fechafin"
                  type="date"
                ></v-text-field>
              </v-col>
            </v-row>

          	<v-row>
          		<v-col cols="12">
		            <v-row>

                  <!-- Operaciones ventas -->
		            	<v-col v-if="kpiAreas.operaciones && canShowCard('operacionesNI')" cols="12" md="4">
		            		<v-card color="white" class="text-center black--text fill-height d-flex flex-column">

                      <v-system-bar
                        min-height="44"
                        color="#08273B"
                        class="white--text px-2 card-system-bar"
                      >
                        <v-spacer></v-spacer>
                        <span class="card-title-responsive ma-2">Op. Inscritos NI  <v-icon :small="$vuetify.breakpoint.smAndDown" color="white">mdi-check</v-icon> </span>
                        <v-spacer></v-spacer>
                      </v-system-bar>
                      <v-progress-linear v-if="kpiLoaders.operacionesNI" indeterminate color="primary" height="4" />
                      
                      <v-card-text class="black--text text-h6 pt-1">
                        {{ ciclo }}
		            		  </v-card-text>

		            		  <v-card-text>
                        <v-row>
                          <v-col cols="12" md="6" lg="6">
                            <v-card color="white" class="text-center black--text fill-height d-flex flex-column">
                              <v-card-title primary-title>
                                <v-spacer></v-spacer>
                                <div><v-chip color="red" dark>Fast</v-chip></div>
                                <v-spacer></v-spacer>
                              </v-card-title>
                              <v-card-text class="d-flex flex-column flex-grow-1">
                                <div class="gauge-markers-wrap">
                                  <v-progress-circular class="kpi-progress-circular"
                                    :rotate="90"
                                    :size="160"
                                    :width="15"
                                    color="grey"
                                    :value="avanceActualesFast"
                                    @click="tablaVentasCiclo = tablaFast, dialogVentasCiclo = true, tablaVentaCicloInbi = false "
                                  >
                                    <span class="text-h4 black--text"><b>{{ totalVentasFast - ( ventasCambiosFast + 1 )}}</b></span>
                                  </v-progress-circular>
                                  <span
                                    v-for="(marker, niFastIdx) in niFastMarkers"
                                    :key="`ni-fast-${marker.value}`"
                                    class="gauge-marker"
                                    :style="markerStyle(marker.value, 160, 90, niFastIdx === 4 ? marker.color : '#bdbdbd', null, 15)"
                                  />
                                </div>
                                <v-row class="align-center mt-4 text-subtitle-1 black--text">
                                  <v-col cols="6">
                                    <div>NI</div>
                                    <div>{{ metaFast }}</div>
                                  </v-col>

                                  <v-col cols="6">
                                    <div>Faltan</div>
                                    <div> {{ metaFast - (totalVentasFast - ventasCambiosFast) }} </div>
                                  </v-col>

                                  <v-col cols="12" class="text-subtitle-1 pb-0">Cambios: {{ ventasCambiosFast + 1 }}</v-col>
                                  <v-col cols="12" class="text-subtitle-1 pt-0">Total: {{ totalVentasFast }}</v-col>
                                </v-row>
                                <div
                                  v-if="getSemaforoEstado(avanceActualesFast)"
                                  class="kpi-semaforo-h kpi-card-semaforo-actions"
                                  aria-hidden="true"
                                >
                                  <span class="kpi-semaforo-h__dot" :class="{ 'kpi-semaforo-h__dot--activo': getSemaforoEstado(avanceActualesFast) === 'red' }" style="background-color: #E53935" />
                                  <span class="kpi-semaforo-h__dot" :class="{ 'kpi-semaforo-h__dot--activo': getSemaforoEstado(avanceActualesFast) === 'yellow' }" style="background-color: #FDD835" />
                                  <span class="kpi-semaforo-h__dot" :class="{ 'kpi-semaforo-h__dot--activo': getSemaforoEstado(avanceActualesFast) === 'green' }" style="background-color: #43A047" />
                                </div>

                              </v-card-text>
                            </v-card>
                          </v-col>

                          <v-col cols="12" md="6" lg="6">
                            <v-card color="white" class="text-center black--text fill-height d-flex flex-column">
                              <v-card-title primary-title>
                                <v-spacer></v-spacer>
                                <div><v-chip color="blue" dark>Inbi</v-chip></div>
                                <v-spacer></v-spacer>
                              </v-card-title>

                              <v-card-text class="d-flex flex-column flex-grow-1">
                                <div class="gauge-markers-wrap">
                                  <v-progress-circular
                                    @click="tablaVentasCiclo = tablaInbi, dialogVentasCiclo = true, tablaVentaCicloInbi = true "
                                    :rotate="90"
                                    :size="160"
                                    :width="15"
                                    :value="avanceActualesInbi"
                                    color="grey"
                                  >
                                    <span class="text-h4 black--text"><b>{{ totalVentasInbi - ventasCambiosInbi }}</b></span>
                                  </v-progress-circular>
                                  <span
                                    v-for="(marker, niInbiIdx) in niInbiMarkers"
                                    :key="`ni-inbi-${marker.value}`"
                                    class="gauge-marker"
                                    :style="markerStyle(marker.value, 160, 90, niInbiIdx === 4 ? marker.color : '#bdbdbd', null, 15)"
                                  />
                                </div>
                                <v-row class="align-center mt-4 text-subtitle-1 black--text">
                                  <v-col cols="6">
                                    <div>NI</div>
                                    <div>{{ metaInbi }}</div>
                                  </v-col>

                                  <v-col cols="6">
                                    <div>Faltan</div>
                                    <div>{{ metaInbi - (totalVentasInbi - ventasCambiosInbi) }} </div>
                                  </v-col>
                                  <v-col cols="12" class="text-subtitle-1 pb-0">Cambios: {{ ventasCambiosInbi }}</v-col>
                                  <v-col cols="12" class="text-subtitle-1 pt-0">Total: {{ totalVentasInbi }}</v-col>

                                </v-row>
                                <div
                                  v-if="getSemaforoEstado(avanceActualesInbi)"
                                  class="kpi-semaforo-h kpi-card-semaforo-actions"
                                  aria-hidden="true"
                                >
                                  <span class="kpi-semaforo-h__dot" :class="{ 'kpi-semaforo-h__dot--activo': getSemaforoEstado(avanceActualesInbi) === 'red' }" style="background-color: #E53935" />
                                  <span class="kpi-semaforo-h__dot" :class="{ 'kpi-semaforo-h__dot--activo': getSemaforoEstado(avanceActualesInbi) === 'yellow' }" style="background-color: #FDD835" />
                                  <span class="kpi-semaforo-h__dot" :class="{ 'kpi-semaforo-h__dot--activo': getSemaforoEstado(avanceActualesInbi) === 'green' }" style="background-color: #43A047" />
                                </div>

                              </v-card-text>

                            </v-card>
                          </v-col>
                        </v-row>
                      </v-card-text>
		            		  <v-card-text class="mt-auto">
		            		    Valor aceptable:
		            		    <v-btn small text color="primary" @click="abrirComparativa('Op. Inscritos NI')" class="ml-1">
		            		      <v-icon small left>mdi-compare</v-icon>
		            		      Comparativa
		            		    </v-btn>
		            		  </v-card-text>
		            		  <v-btn color="blue" absolute top right icon @click="abrirFormulaInfo('Op. Inscritos NI')">
		            		    <v-icon>mdi-information-outline</v-icon>
		            		  </v-btn>
		            		</v-card>
		            	</v-col>

                  <!-- Operaciones - %RI -->
                  <v-col v-if="kpiAreas.operaciones && canShowCard('operacionesRI')" cols="12" md="4">
		            		<v-card color="white" class="text-center black--text fill-height d-flex flex-column">

                      <v-system-bar
                        min-height="44"
                        color="#08273B"
                        class="white--text card-system-bar"
                      >
                        <v-spacer></v-spacer>
                        <span class="card-title-responsive ma-2">Operaciones - %RI <v-icon :small="$vuetify.breakpoint.smAndDown" color="white">mdi-check</v-icon> </span>
                        <v-spacer></v-spacer>
                      </v-system-bar>
                      <v-progress-linear v-if="kpiLoaders.operacionesRI" indeterminate color="primary" height="4" />

                      <v-card-text class="black--text text-h6 pt-1">
                        {{ ciclo }}
		            		  </v-card-text>
		            		  <v-card-text>
                        <v-row>
                          <v-col cols="12" md="6" lg="6">
                            <v-card color="white" class="text-center black--text fill-height d-flex flex-column">
                              <v-card-title primary-title>
                                <v-spacer></v-spacer>
                                <div><v-chip color="red" dark>Fast</v-chip></div>
                                <v-spacer></v-spacer>
                              </v-card-title>
                              <v-card-text class="d-flex flex-column flex-grow-1">
                                <div v-if="resultadoRi" class="gauge-markers-wrap">
                                  <v-progress-circular
                                    :rotate="90"
                                    :size="160"
                                    :width="15"
                                    color="grey"
                                    :value="( resultadoRi.riPlantelesFast[resultadoRi.riPlantelesFast.length - 1].porcentajeAvance / 93 ) * 100"
                                  >
                                    <span class="text-h4 black--text"><b>{{ resultadoRi.riPlantelesFast[resultadoRi.riPlantelesFast.length - 1].porcentajeAvance }}</b></span>
                                  </v-progress-circular>
                                  <span
                                    v-for="(marker, riIdx) in [10, 80, 85, 90, 93]"
                                    :key="`ri-fast-${marker}`"
                                    class="gauge-marker"
                                    :style="markerStyleRi((marker / 93) * 100, 160, 90, riIdx + 1, '#e53935')"
                                  />
                                </div>
                                <v-row class="align-center mt-4 text-subtitle-1 black--text">
                                  <v-col cols="6">
                                    <div v-if="ciclo">Meta</div>
                                    <div>{{ 93 + ' %' }}</div>
                                  </v-col>

                                  <v-col cols="6">
                                    <div>Faltan</div>
                                    <div v-if="resultadoRi"> {{ ( 93 - (resultadoRi.riPlantelesFast[resultadoRi.riPlantelesFast.length - 1].porcentajeAvance)).toFixed( 2 ) + ' %' }} </div>
                                  </v-col>
                                  <v-col cols="12" class="text-subtitle-1 pb-0 kpi-spacer-placeholder">.</v-col>
                                  <v-col cols="12" class="text-subtitle-1 pt-0 kpi-spacer-placeholder">.</v-col>

                                </v-row>
                                <div
                                  v-if="resultadoRi && getSemaforoEstado(resultadoRi.riPlantelesFast[resultadoRi.riPlantelesFast.length - 1].porcentajeAvance)"
                                  class="kpi-semaforo-h kpi-card-semaforo-actions"
                                  aria-hidden="true"
                                >
                                  <span class="kpi-semaforo-h__dot" :class="{ 'kpi-semaforo-h__dot--activo': getSemaforoEstado(resultadoRi.riPlantelesFast[resultadoRi.riPlantelesFast.length - 1].porcentajeAvance) === 'red' }" style="background-color: #E53935" />
                                  <span class="kpi-semaforo-h__dot" :class="{ 'kpi-semaforo-h__dot--activo': getSemaforoEstado(resultadoRi.riPlantelesFast[resultadoRi.riPlantelesFast.length - 1].porcentajeAvance) === 'yellow' }" style="background-color: #FDD835" />
                                  <span class="kpi-semaforo-h__dot" :class="{ 'kpi-semaforo-h__dot--activo': getSemaforoEstado(resultadoRi.riPlantelesFast[resultadoRi.riPlantelesFast.length - 1].porcentajeAvance) === 'green' }" style="background-color: #43A047" />
                                </div>
                              </v-card-text>
                            </v-card>
                          </v-col>

                          <v-col cols="12" md="6" lg="6">
                            <v-card color="white" class="text-center black--text fill-height d-flex flex-column">
                              <v-card-title primary-title>
                                <v-spacer></v-spacer>
                                <div><v-chip color="blue" dark>Inbi</v-chip></div>
                                <v-spacer></v-spacer>
                              </v-card-title>

                              <v-card-text class="d-flex flex-column flex-grow-1">
                                <div v-if="resultadoRi" class="gauge-markers-wrap">
                                  <v-progress-circular
                                    :rotate="90"
                                    :size="160"
                                    :width="15"
                                    color="grey"
                                    :value="( resultadoRi.riPlantelesInbi[resultadoRi.riPlantelesInbi.length - 1].porcentajeAvance / 93 ) * 100"
                                  >
                                    <span class="text-h4 black--text"><b>{{ resultadoRi.riPlantelesInbi[resultadoRi.riPlantelesInbi.length - 1].porcentajeAvance }}</b></span>
                                  </v-progress-circular>
                                  <span
                                    v-for="(marker, riIdx) in [10, 80, 85, 90, 93]"
                                    :key="`ri-inbi-${marker}`"
                                    class="gauge-marker"
                                    :style="markerStyleRi((marker / 93) * 100, 160, 90, riIdx + 1, '#1e88e5')"
                                  />
                                </div>
                                <v-row class="align-center mt-4 text-subtitle-1 black--text">
                                  <v-col cols="6">
                                    <div v-if="ciclo">Meta</div>
                                    <div>{{ 93 + ' %' }}</div>
                                  </v-col>

                                  <v-col cols="6">
                                    <div>Faltan</div>
                                    <div v-if="resultadoRi"> {{ ( 93 - (resultadoRi.riPlantelesInbi[resultadoRi.riPlantelesInbi.length - 1].porcentajeAvance)).toFixed( 2 ) + ' %' }} </div>
                                  </v-col>

                                  <v-col cols="12" class="text-subtitle-1 pb-0 kpi-spacer-placeholder">.</v-col>
                                  <v-col cols="12" class="text-subtitle-1 pt-0 kpi-spacer-placeholder">.</v-col>

                                </v-row>
                                <div
                                  v-if="resultadoRi && getSemaforoEstado(resultadoRi.riPlantelesInbi[resultadoRi.riPlantelesInbi.length - 1].porcentajeAvance)"
                                  class="kpi-semaforo-h kpi-card-semaforo-actions"
                                  aria-hidden="true"
                                >
                                  <span class="kpi-semaforo-h__dot" :class="{ 'kpi-semaforo-h__dot--activo': getSemaforoEstado(resultadoRi.riPlantelesInbi[resultadoRi.riPlantelesInbi.length - 1].porcentajeAvance) === 'red' }" style="background-color: #E53935" />
                                  <span class="kpi-semaforo-h__dot" :class="{ 'kpi-semaforo-h__dot--activo': getSemaforoEstado(resultadoRi.riPlantelesInbi[resultadoRi.riPlantelesInbi.length - 1].porcentajeAvance) === 'yellow' }" style="background-color: #FDD835" />
                                  <span class="kpi-semaforo-h__dot" :class="{ 'kpi-semaforo-h__dot--activo': getSemaforoEstado(resultadoRi.riPlantelesInbi[resultadoRi.riPlantelesInbi.length - 1].porcentajeAvance) === 'green' }" style="background-color: #43A047" />
                                </div>

                              </v-card-text>

                            </v-card>
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-card-text>
		            		    Valor aceptable:
		            		    <v-btn small text color="primary" @click="abrirComparativa('Operaciones - %RI')" class="ml-1">
		            		      <v-icon small left>mdi-compare</v-icon>
		            		      Comparativa
		            		    </v-btn>
		            		  </v-card-text>
		            		  <v-btn color="blue" absolute top right icon @click="abrirFormulaInfo('Operaciones - %RI')">
		            		    <v-icon>mdi-information-outline</v-icon>
		            		  </v-btn>
		            		</v-card>
		            	</v-col>

                  <!-- Operaciones - $$ -->
                  <v-col v-if="kpiAreas.operaciones && canShowCard('operacionesMoney')" cols="12" md="4">
		            		<v-card color="white" class="text-center black--text fill-height d-flex flex-column">

                      <v-system-bar
                        min-height="44"
                        color="#08273B"
                        class="white--text card-system-bar"
                      >
                        <v-spacer></v-spacer>
                        <span class="card-title-responsive ma-2">Operaciones - $$ <v-icon :small="$vuetify.breakpoint.smAndDown" color="white">mdi-check</v-icon> </span>
                        <v-spacer></v-spacer>
                      </v-system-bar>
                      <v-progress-linear v-if="kpiLoaders.operacionesMoney" indeterminate color="primary" height="4" />

                      <v-card-text class="black--text text-h6 pt-1">
                        {{ ciclo }}
		            		  </v-card-text>
		            		  <v-card-text>
                        <v-row>
                          <v-col cols="12" md="6" lg="6">
                            <v-card color="white" class="text-center black--text fill-height d-flex flex-column">
                              <v-card-title primary-title>
                                <v-spacer></v-spacer>
                                <div><v-chip color="red" dark>Fast</v-chip></div>
                                <v-spacer></v-spacer>
                              </v-card-title>

                              {{  metamoney.avance_fast  }}
                              <v-card-text class="d-flex flex-column flex-grow-1">
                                <div class="gauge-markers-wrap">
                                  <v-progress-circular
                                    :rotate="100"
                                    :size="160"
                                    :width="15"
                                    color="grey"
                                    :value="metamoney.avance_fast"
                                  >
                                    <span class="text-h4 black--text"><b>{{ metamoney.avance_fast }}</b></span>
                                  </v-progress-circular>
                                  <span
                                    v-for="(marker, mmFastIdx) in [10, 80, 85, 90, 100]"
                                    :key="`money-fast-${marker}`"
                                    class="gauge-marker"
                                    :style="markerStyle(marker, 160, 100, mmFastIdx === 4 ? null : '#bdbdbd', mmFastIdx === 4 ? marker : null, 15)"
                                  />
                                </div>
                                <v-row class="align-center mt-4 text-subtitle-1 black--text">
                                  <v-col cols="6">
                                    <div>Meta</div>
                                    <div> 100% </div>
                                  </v-col>

                                  <v-col cols="6">
                                    <div>Faltan</div>
                                    <div> {{ metamoney.faltante_fast }}</div>
                                  </v-col>
                                  <v-col cols="12" class="text-subtitle-1 pb-0 kpi-spacer-placeholder">.</v-col>
                                  <v-col cols="12" class="text-subtitle-1 pt-0 kpi-spacer-placeholder">.</v-col>

                                </v-row>
                                <div
                                  v-if="getSemaforoEstado(metamoney.avance_fast)"
                                  class="kpi-semaforo-h kpi-card-semaforo-actions"
                                  aria-hidden="true"
                                >
                                  <span class="kpi-semaforo-h__dot" :class="{ 'kpi-semaforo-h__dot--activo': getSemaforoEstado(metamoney.avance_fast) === 'red' }" style="background-color: #E53935" />
                                  <span class="kpi-semaforo-h__dot" :class="{ 'kpi-semaforo-h__dot--activo': getSemaforoEstado(metamoney.avance_fast) === 'yellow' }" style="background-color: #FDD835" />
                                  <span class="kpi-semaforo-h__dot" :class="{ 'kpi-semaforo-h__dot--activo': getSemaforoEstado(metamoney.avance_fast) === 'green' }" style="background-color: #43A047" />
                                </div>
                              </v-card-text>
                            </v-card>
                          </v-col>

                          <v-col cols="12" md="6" lg="6">
                            <v-card color="white" class="text-center black--text fill-height d-flex flex-column">
                              <v-card-title primary-title>
                                <v-spacer></v-spacer>
                                <div><v-chip color="blue" dark>Inbi</v-chip></div>
                                <v-spacer></v-spacer>
                              </v-card-title>

                              <v-card-text class="d-flex flex-column flex-grow-1">
                                <div class="gauge-markers-wrap">
                                  <v-progress-circular
                                    :rotate="100"
                                    :size="160"
                                    :width="15"
                                    color="grey"
                                    :value="metamoney.avance_inbi"
                                  >
                                    <span class="text-h4 black--text"><b>{{ metamoney.avance_inbi }}</b></span>
                                  </v-progress-circular>
                                  <span
                                    v-for="(marker, mmInbiIdx) in [10, 80, 85, 90, 100]"
                                    :key="`money-inbi-${marker}`"
                                    class="gauge-marker"
                                    :style="markerStyle(marker, 160, 100, mmInbiIdx === 4 ? null : '#bdbdbd', mmInbiIdx === 4 ? marker : null, 15)"
                                  />
                                </div>
                                <v-row class="align-center mt-4 text-subtitle-1 black--text">
                                  <v-col cols="6">
                                    <div>Meta</div>
                                    <div> 100% </div>
                                  </v-col>

                                  <v-col cols="6">
                                    <div>Faltan</div>
                                    <div > {{ metamoney.faltante_inbi }}</div>
                                  </v-col>

                                  <v-col cols="12" class="text-subtitle-1 pb-0 kpi-spacer-placeholder">.</v-col>
                                  <v-col cols="12" class="text-subtitle-1 pt-0 kpi-spacer-placeholder">.</v-col>

                                </v-row>
                                <div
                                  v-if="getSemaforoEstado(metamoney.avance_inbi)"
                                  class="kpi-semaforo-h kpi-card-semaforo-actions"
                                  aria-hidden="true"
                                >
                                  <span class="kpi-semaforo-h__dot" :class="{ 'kpi-semaforo-h__dot--activo': getSemaforoEstado(metamoney.avance_inbi) === 'red' }" style="background-color: #E53935" />
                                  <span class="kpi-semaforo-h__dot" :class="{ 'kpi-semaforo-h__dot--activo': getSemaforoEstado(metamoney.avance_inbi) === 'yellow' }" style="background-color: #FDD835" />
                                  <span class="kpi-semaforo-h__dot" :class="{ 'kpi-semaforo-h__dot--activo': getSemaforoEstado(metamoney.avance_inbi) === 'green' }" style="background-color: #43A047" />
                                </div>

                              </v-card-text>

                            </v-card>
                          </v-col>
                        </v-row>
                      </v-card-text>
                      <v-card-text>
		            		    Valor aceptable:
		            		    <v-btn small text color="primary" @click="abrirComparativa('Operaciones - $$')" class="ml-1">
		            		      <v-icon small left>mdi-compare</v-icon>
		            		      Comparativa
		            		    </v-btn>
		            		  </v-card-text>
		            		  <v-btn color="blue" absolute top right icon @click="abrirFormulaInfo('Operaciones - $$')">
		            		    <v-icon>mdi-information-outline</v-icon>
		            		  </v-btn>
		            		</v-card>
		            	</v-col>

                  <!-- Departamento de Recursos Humanos -->
		            	<v-col v-if="kpiAreas.rh && canShowCard('rhOcupacion')" cols="12" md="6" lg="4">
		            		<v-card color="white" class="text-center black--text fill-height d-flex flex-column">

                      <!-- Tiulo del departamento -->
                      <v-system-bar
                        min-height="44"
                        color="#08273B"
                        class="white--text card-system-bar"
                      >
                        <v-spacer></v-spacer>
                        <span class="card-title-responsive ma-2">RH - %Ocupación <v-icon :small="$vuetify.breakpoint.smAndDown" color="white" @click="exportExcel( vacantesExcelRH  , 'RH')">mdi-microsoft-excel</v-icon> </span>
                        <v-spacer></v-spacer>
                      </v-system-bar>
                      <v-progress-linear v-if="kpiLoaders.rhOcupacion" indeterminate color="primary" height="4" />

                      <!-- Porcentaje de ocupación -->
		            		  <v-card-title primary-title class="flex-column align-center">
		            		    <v-row class="ocupacion-row">
                          <v-col cols="6" class="d-flex flex-column align-center ocupacion-col">
		            		        <span class="ocupacion-label"><v-chip color="red" dark>Fast</v-chip></span>
		            		        <v-card 
                              @click="openRhDetalleRequeridos('fast')"
		            		          color="white"
		            		          class="ocupacion-card pa-4 text-center text-h4 shadowCard black--text">
		            		          {{ rhOcupacionFast.percent_ocupacion }} %
		            		        </v-card>
		            		        <span class="ocupacion-label">Ocupación</span>
		            		      </v-col>
		            		      <v-col cols="6" class="d-flex flex-column align-center ocupacion-col">
		            		        <span class="ocupacion-label"><v-chip color="blue" dark>Inbi</v-chip></span>
		            		        <v-card 
                              @click="openRhDetalleRequeridos('inbi')"
		            		          color="white"
		            		          class="ocupacion-card pa-4 text-center text-h4 shadowCard black--text">
		            		          {{ rhOcupacionInbi.percent_ocupacion }} %
		            		        </v-card>
		            		        <span class="ocupacion-label">Ocupación</span>
		            		      </v-col>
		            		    </v-row>
		            		    <v-row class="ocupacion-row">
		            		      <v-col cols="6" class="d-flex flex-column align-center ocupacion-col">
		            		        <v-card 
                              @click="openRhDetalleRequeridos('corpo')"
		            		          color="white"
		            		          class="ocupacion-card pa-4 text-center text-h4 shadowCard black--text">
		            		          {{ rhOcupacionCorpo.percent_ocupacion }} %
		            		        </v-card>
		            		        <span class="ocupacion-label">Coorporativo</span>
		            		      </v-col>
		            		      <v-col cols="6" class="d-flex flex-column align-center ocupacion-col">
		            		        <v-card 
                              @click="openRhDetalleRequeridos('todo')"
		            		          color="white"
		            		          class="ocupacion-card pa-4 text-center text-h4 shadowCard black--text">
		            		          {{ rhOcupacionTodo.percent_ocupacion }} %
		            		        </v-card>
		            		        <span class="ocupacion-label">General</span>
		            		      </v-col>
		            		    </v-row>
		            		    <v-row class="ocupacion-row kpi-dept-semaforo-row">
		            		      <v-col cols="6" class="d-flex flex-column align-center justify-end">
		            		        <div
		            		          v-if="getSemaforoEstado(rhOcupacionFast.percent_ocupacion)"
		            		          class="kpi-semaforo-h"
		            		          aria-hidden="true"
		            		        >
		            		          <span class="kpi-semaforo-h__dot" :class="{ 'kpi-semaforo-h__dot--activo': getSemaforoEstado(rhOcupacionFast.percent_ocupacion) === 'red' }" style="background-color: #E53935" />
		            		          <span class="kpi-semaforo-h__dot" :class="{ 'kpi-semaforo-h__dot--activo': getSemaforoEstado(rhOcupacionFast.percent_ocupacion) === 'yellow' }" style="background-color: #FDD835" />
		            		          <span class="kpi-semaforo-h__dot" :class="{ 'kpi-semaforo-h__dot--activo': getSemaforoEstado(rhOcupacionFast.percent_ocupacion) === 'green' }" style="background-color: #43A047" />
		            		        </div>
		            		      </v-col>
		            		      <v-col cols="6" class="d-flex flex-column align-center justify-end">
		            		        <div
		            		          v-if="getSemaforoEstado(rhOcupacionInbi.percent_ocupacion)"
		            		          class="kpi-semaforo-h"
		            		          aria-hidden="true"
		            		        >
		            		          <span class="kpi-semaforo-h__dot" :class="{ 'kpi-semaforo-h__dot--activo': getSemaforoEstado(rhOcupacionInbi.percent_ocupacion) === 'red' }" style="background-color: #E53935" />
		            		          <span class="kpi-semaforo-h__dot" :class="{ 'kpi-semaforo-h__dot--activo': getSemaforoEstado(rhOcupacionInbi.percent_ocupacion) === 'yellow' }" style="background-color: #FDD835" />
		            		          <span class="kpi-semaforo-h__dot" :class="{ 'kpi-semaforo-h__dot--activo': getSemaforoEstado(rhOcupacionInbi.percent_ocupacion) === 'green' }" style="background-color: #43A047" />
		            		        </div>
		            		      </v-col>
		            		    </v-row>
		            		  </v-card-title>
                    
		            		  <v-card-text class="mt-auto">
		            		    Valor aceptable:
		            		    <v-btn small text color="primary" @click="abrirComparativa('RH - %Ocupación')" class="ml-1">
		            		      <v-icon small left>mdi-compare</v-icon>
		            		      Comparativa
		            		    </v-btn>
		            		  </v-card-text>

		            		  <v-btn 
		            		  	color="blue"
		            		  	absolute
		            		  	top
		            		  	right
		            		  	icon
		            		  	@click="abrirFormulaInfo('RH - %Ocupación')"
		            		  >
		            				<v-icon>mdi-information-outline</v-icon>
		            			</v-btn>
		            		</v-card>
		            	</v-col>

                  <!-- Departamento de Comercial -->
		            	<v-col v-if="kpiAreas.comercial && canShowCard('comercialConversion')" cols="12" md="6" lg="4">
		            		<v-card color="white" class="text-center black--text fill-height d-flex flex-column">

                      <v-system-bar
                        min-height="44"
                        color="#08273B"
                        class="white--text card-system-bar"
                      >
                        <v-spacer></v-spacer>
                        <span class="card-title-responsive ma-2">Comercial <v-icon :small="$vuetify.breakpoint.smAndDown" color="white">mdi-check</v-icon> </span>
                        <v-spacer></v-spacer>
                      </v-system-bar>
                      <v-progress-linear v-if="kpiLoaders.comercialConversion" indeterminate color="primary" height="4" />

                      <v-card-title primary-title class="flex-column align-center">
		            		    <v-row class="ocupacion-row">
                          <v-col cols="6" class="d-flex flex-column align-center ocupacion-col">
		            		        <span class="ocupacion-label"><v-chip color="red" dark>Fast</v-chip></span>
		            		        <v-card 
		            		          color="white" 
		            		          class="ocupacion-card pa-4 text-center text-h3 shadowCard black--text">
		            		          {{ prospectosFast.length }}
		            		        </v-card>
		            		        <span class="ocupacion-label">Contactos</span>
		            		      </v-col>
		            		      <v-col cols="6" class="d-flex flex-column align-center ocupacion-col">
		            		        <span class="ocupacion-label"><v-chip color="blue" dark>Inbi</v-chip></span>
		            		        <v-card 
		            		          color="white" 
		            		          class="ocupacion-card pa-4 text-center text-h3 shadowCard black--text">
		            		          {{ prospectosInbi.length }}
		            		        </v-card>
		            		        <span class="ocupacion-label">Contactos</span>
		            		      </v-col>
		            		    </v-row>

                        <v-row class="ocupacion-row">
                          <v-col cols="6" class="d-flex flex-column align-center ocupacion-col">
		            		        <v-card 
		            		          color="white" 
		            		          class="ocupacion-card pa-4 text-center text-h4 shadowCard black--text">
		            		          {{ comercialConversion.conversionFast }} %
		            		        </v-card>
		            		        <span class="ocupacion-label">Conversión</span>
		            		      </v-col>
		            		      <v-col cols="6" class="d-flex flex-column align-center ocupacion-col">
		            		        <v-card 
		            		          color="white" 
		            		          class="ocupacion-card pa-4 text-center text-h4 shadowCard black--text">
		            		          {{ comercialConversion.conversionInbi }} %
		            		        </v-card>
		            		        <span class="ocupacion-label">Conversión</span>
		            		      </v-col>
		            		    </v-row>
		            		    <v-row class="ocupacion-row kpi-dept-semaforo-row">
		            		      <v-col cols="6" class="d-flex flex-column align-center justify-end">
		            		        <div
		            		          v-if="getSemaforoEstado(comercialConversion.conversionFast)"
		            		          class="kpi-semaforo-h"
		            		          aria-hidden="true"
		            		        >
		            		          <span class="kpi-semaforo-h__dot" :class="{ 'kpi-semaforo-h__dot--activo': getSemaforoEstado(comercialConversion.conversionFast) === 'red' }" style="background-color: #E53935" />
		            		          <span class="kpi-semaforo-h__dot" :class="{ 'kpi-semaforo-h__dot--activo': getSemaforoEstado(comercialConversion.conversionFast) === 'yellow' }" style="background-color: #FDD835" />
		            		          <span class="kpi-semaforo-h__dot" :class="{ 'kpi-semaforo-h__dot--activo': getSemaforoEstado(comercialConversion.conversionFast) === 'green' }" style="background-color: #43A047" />
		            		        </div>
		            		      </v-col>
		            		      <v-col cols="6" class="d-flex flex-column align-center justify-end">
		            		        <div
		            		          v-if="getSemaforoEstado(comercialConversion.conversionInbi)"
		            		          class="kpi-semaforo-h"
		            		          aria-hidden="true"
		            		        >
		            		          <span class="kpi-semaforo-h__dot" :class="{ 'kpi-semaforo-h__dot--activo': getSemaforoEstado(comercialConversion.conversionInbi) === 'red' }" style="background-color: #E53935" />
		            		          <span class="kpi-semaforo-h__dot" :class="{ 'kpi-semaforo-h__dot--activo': getSemaforoEstado(comercialConversion.conversionInbi) === 'yellow' }" style="background-color: #FDD835" />
		            		          <span class="kpi-semaforo-h__dot" :class="{ 'kpi-semaforo-h__dot--activo': getSemaforoEstado(comercialConversion.conversionInbi) === 'green' }" style="background-color: #43A047" />
		            		        </div>
		            		      </v-col>
		            		    </v-row>
		            		  </v-card-title>

		            		  <v-card-text class="mt-auto">
		            		    Valor aceptable:
		            		    <v-btn small text color="primary" @click="abrirComparativa('Comercial')" class="ml-1">
		            		      <v-icon small left>mdi-compare</v-icon>
		            		      Comparativa
		            		    </v-btn>
		            		  </v-card-text>

		            			<v-btn 
		            		  	color="blue"
		            		  	absolute
		            		  	top
		            		  	right
		            		  	icon
		            		  	@click="abrirFormulaInfo('Comercial')"
		            		  >
		            				<v-icon>mdi-information-outline</v-icon>
		            			</v-btn>
		            		</v-card>
		            	</v-col>

                  <!-- Departamento de TI -->
		            	<v-col v-if="kpiAreas.ti && canShowCard('tiTickets')" cols="12" md="6" lg="4">
		            		<v-card color="white" class="text-center black--text fill-height d-flex flex-column">

                      <v-system-bar
                        min-height="44"
                        color="#08273B"
                        class="white--text card-system-bar"
                      >
                        <v-spacer></v-spacer>
                        <span class="card-title-responsive ma-2">TI <v-icon :small="$vuetify.breakpoint.smAndDown" color="white">mdi-check</v-icon></span>
                        <v-spacer></v-spacer>
                      </v-system-bar>
                      <v-progress-linear v-if="kpiLoaders.tiTickets" indeterminate color="primary" height="4" />

		            		  <v-card-title primary-title class="d-block">
		            		    <div class="d-flex flex-column align-center w-100">
		            		      <v-card
		            		        color="white"
		            		        class="pa-3 pa-sm-4 text-center text-h3 shadowCard ti-kpi-pct-card black--text d-flex align-center justify-center"
		            		      >
		            		        {{ ti.kpi_ti }} %
		            		      </v-card>
		            		      <div
		            		        v-if="tiSemaforoEstado"
		            		        class="kpi-semaforo-h mt-2"
		            		        aria-hidden="true"
		            		      >
		            		        <span
		            		          class="kpi-semaforo-h__dot"
		            		          :class="{ 'kpi-semaforo-h__dot--activo': tiSemaforoEstado === 'red' }"
		            		          style="background-color: #E53935;"
		            		        />
		            		        <span
		            		          class="kpi-semaforo-h__dot"
		            		          :class="{ 'kpi-semaforo-h__dot--activo': tiSemaforoEstado === 'yellow' }"
		            		          style="background-color: #FDD835;"
		            		        />
		            		        <span
		            		          class="kpi-semaforo-h__dot"
		            		          :class="{ 'kpi-semaforo-h__dot--activo': tiSemaforoEstado === 'green' }"
		            		          style="background-color: #43A047;"
		            		        />
		            		      </div>
		            		      <span class="ocupacion-label mt-2">IUA (KPI)</span>
		            		    </div>
		            		  </v-card-title>
		            		  
		            		  <v-card-text class="mt-auto">
		            		    Valor aceptable: ≥ 90 %
		            		    <v-btn small text color="primary" @click="abrirComparativa('TI')" class="ml-1">
		            		      <v-icon small left>mdi-compare</v-icon>
		            		      Comparativa
		            		    </v-btn>
		            		  </v-card-text>

		            			<v-btn 
		            		  	color="blue"
		            		  	absolute
		            		  	top
		            		  	right
		            		  	icon
		            		  	@click="abrirFormulaInfo('TI')"
		            		  >
		            				<v-icon>mdi-information-outline</v-icon>
		            			</v-btn>
		            		</v-card>
		            	</v-col>

                  <!-- Departamento de Finanzas -->
		            	<v-col v-if="kpiAreas.finanzas && canShowCard('finanzasEgreso')" cols="12" md="6" lg="4">
		            		<v-card color="white" class="text-center black--text fill-height d-flex flex-column">

                      <v-system-bar
                        min-height="44"
                        color="#08273B"
                        class="white--text card-system-bar"
                      >
                        <v-spacer></v-spacer>
                        <span class="card-title-responsive ma-2">Finanzas</span>
                        <v-spacer></v-spacer>
                      </v-system-bar>
                      <v-progress-linear v-if="kpiLoaders.finanzasEgreso" indeterminate color="primary" height="4" />

                      <v-card-title primary-title class="flex-column align-center">

                        <v-row class="ocupacion-row">
		            		      <v-col cols="6" class="d-flex flex-column align-center ocupacion-col">
                            <span class="ocupacion-label"><v-chip color="red" dark>Fast</v-chip></span>
		            		      </v-col>
		            		      <v-col cols="6" class="d-flex flex-column align-center ocupacion-col">
		            		        <span class="ocupacion-label"><v-chip color="blue" dark>Inbi</v-chip></span>
		            		      </v-col>
		            		    </v-row>


		            		    <v-row class="ocupacion-row">
		            		      <v-col cols="6" class="d-flex flex-column align-center ocupacion-col">
		            		        <v-card 
		            		          color="white"
		            		          class="ocupacion-card pa-5 text-center text-h4 shadowCard black--text"
                              style="cursor: pointer;"
                              @click="abrirDetalleEgresoFinanzas('Fast')">
		            		          {{ finanzas.egresoFast }}
		            		        </v-card>
		            		        <span class="ocupacion-label">Egresos</span>
		            		      </v-col>
		            		      <v-col cols="6" class="d-flex flex-column align-center ocupacion-col">
		            		        <v-card 
		            		          color="white"
		            		          class="ocupacion-card pa-5 text-center text-h4 shadowCard black--text"
                              style="cursor: pointer;"
                              @click="abrirDetalleEgresoFinanzas('Inbi')">
		            		          {{ finanzas.egresoInbi }}
		            		        </v-card>
		            		        <span class="ocupacion-label">Egreso</span>
		            		      </v-col>
		            		    </v-row>

                        <v-row class="ocupacion-row">
		            		      <v-col cols="6" class="d-flex flex-column align-center ocupacion-col">
		            		        <v-card 
		            		          color="white"
		            		          class="ocupacion-card pa-5 text-center text-h4 shadowCard black--text"
                              style="cursor: pointer;"
                              @click="abrirDetalleIngresoFinanzas('Fast')">
		            		          {{ finanzas.ingresoValidadoFast }}
		            		        </v-card>
		            		        <span class="ocupacion-label">Ingreso</span>
                            <span class="ocupacion-label" v-if="diasTranscurridosFast">Días:
                              <span
                                class="font-weight-bold"
                                style="cursor: pointer; text-decoration: underline;"
                                @click="abrirDetalleDiasFinanzas('Fast')"
                              >{{ diasTranscurridosFast.dias_transcurridos }}</span>
                            </span>
		            		      </v-col>
		            		      <v-col cols="6" class="d-flex flex-column align-center ocupacion-col">
		            		        <v-card 
		            		          color="white"
		            		          class="ocupacion-card pa-5 text-center text-h4 shadowCard black--text"
                              style="cursor: pointer;"
                              @click="abrirDetalleIngresoFinanzas('Inbi')">
		            		          {{ finanzas.ingresoValidadoInbi }}
		            		        </v-card>
		            		        <span class="ocupacion-label">Ingreso</span>
                            <span class="ocupacion-label" v-if="diasTranscurridosInbi">Días:
                              <span
                                class="font-weight-bold"
                                style="cursor: pointer; text-decoration: underline;"
                                @click="abrirDetalleDiasFinanzas('Inbi')"
                              >{{ diasTranscurridosInbi.dias_transcurridos }}</span>
                            </span>
		            		      </v-col>
		            		    </v-row>
		            		    <v-row class="ocupacion-row kpi-dept-semaforo-row">
		            		      <v-col cols="6" class="d-flex flex-column align-center justify-end">
		            		        <div
		            		          v-if="getSemaforoEstado(finanzas.ingresoValidadoFast)"
		            		          class="kpi-semaforo-h"
		            		          aria-hidden="true"
		            		        >
		            		          <span class="kpi-semaforo-h__dot" :class="{ 'kpi-semaforo-h__dot--activo': getSemaforoEstado(finanzas.ingresoValidadoFast) === 'red' }" style="background-color: #E53935" />
		            		          <span class="kpi-semaforo-h__dot" :class="{ 'kpi-semaforo-h__dot--activo': getSemaforoEstado(finanzas.ingresoValidadoFast) === 'yellow' }" style="background-color: #FDD835" />
		            		          <span class="kpi-semaforo-h__dot" :class="{ 'kpi-semaforo-h__dot--activo': getSemaforoEstado(finanzas.ingresoValidadoFast) === 'green' }" style="background-color: #43A047" />
		            		        </div>
		            		      </v-col>
		            		      <v-col cols="6" class="d-flex flex-column align-center justify-end">
		            		        <div
		            		          v-if="getSemaforoEstado(finanzas.ingresoValidadoInbi)"
		            		          class="kpi-semaforo-h"
		            		          aria-hidden="true"
		            		        >
		            		          <span class="kpi-semaforo-h__dot" :class="{ 'kpi-semaforo-h__dot--activo': getSemaforoEstado(finanzas.ingresoValidadoInbi) === 'red' }" style="background-color: #E53935" />
		            		          <span class="kpi-semaforo-h__dot" :class="{ 'kpi-semaforo-h__dot--activo': getSemaforoEstado(finanzas.ingresoValidadoInbi) === 'yellow' }" style="background-color: #FDD835" />
		            		          <span class="kpi-semaforo-h__dot" :class="{ 'kpi-semaforo-h__dot--activo': getSemaforoEstado(finanzas.ingresoValidadoInbi) === 'green' }" style="background-color: #43A047" />
		            		        </div>
		            		      </v-col>
		            		    </v-row>
		            		  
		            		  </v-card-title>


		            		  
		            		  <v-card-text class="mt-auto">
		            		    Valor aceptable:
		            		    <v-btn small text color="primary" @click="abrirComparativa('Finanzas')" class="ml-1">
		            		      <v-icon small left>mdi-compare</v-icon>
		            		      Comparativa
		            		    </v-btn>
		            		    <v-btn small text color="indigo" @click="abrirReporteFinanzas()" class="ml-1">
		            		      <v-icon small left>mdi-file-table</v-icon>
		            		      Reporte detallado
		            		    </v-btn>
		            		  </v-card-text>

		            			<v-btn 
		            		  	color="blue"
		            		  	absolute
		            		  	top
		            		  	right
		            		  	icon
		            		  @click="abrirFormulaInfo('Finanzas')"
		            		  >
		            				<v-icon>mdi-information-outline</v-icon>
		            			</v-btn>
		            		</v-card>
		            	</v-col>

                  <!-- Operaciones - Clases correctas -->
		            	<v-col v-if="kpiAreas.operaciones && canShowCard('operacionesClases')" cols="12" md="6" lg="4">
		            		<v-card color="white" class="text-center black--text fill-height d-flex flex-column">

                      <v-system-bar
                        min-height="44"
                        color="#08273B"
                        class="white--text card-system-bar"
                      >
                        <v-spacer></v-spacer>
                        <span class="card-title-responsive ma-2">Operaciones - Clases</span>
                        <v-spacer></v-spacer>
                      </v-system-bar>
                      <v-progress-linear v-if="kpiLoaders.operacionesClases" indeterminate color="primary" height="4" />

                      <v-card-title primary-title class="flex-column align-center">
		            		    <v-row class="ocupacion-row">
		            		      <v-col cols="6" class="d-flex flex-column align-center ocupacion-col">
		            		        <span class="ocupacion-label"><v-chip color="red" dark>Fast</v-chip></span>
		            		        <v-card 
		            		          color="white"
		            		          class="ocupacion-card pa-5 text-center text-h4 shadowCard black--text"
                              style="cursor: pointer;"
                              @click="abrirDetalleOperacionesClases('fast')">
		            		          {{ clases.porcentaje_correcto_fast }} %
		            		        </v-card>
		            		        <span class="ocupacion-label">Clases</span>
		            		        <div
		            		          v-if="getSemaforoEstado(clases.porcentaje_correcto_fast)"
		            		          class="kpi-semaforo-h kpi-mini-semaforo-bajo-texto"
		            		          aria-hidden="true"
		            		        >
		            		          <span class="kpi-semaforo-h__dot" :class="{ 'kpi-semaforo-h__dot--activo': getSemaforoEstado(clases.porcentaje_correcto_fast) === 'red' }" style="background-color: #E53935" />
		            		          <span class="kpi-semaforo-h__dot" :class="{ 'kpi-semaforo-h__dot--activo': getSemaforoEstado(clases.porcentaje_correcto_fast) === 'yellow' }" style="background-color: #FDD835" />
		            		          <span class="kpi-semaforo-h__dot" :class="{ 'kpi-semaforo-h__dot--activo': getSemaforoEstado(clases.porcentaje_correcto_fast) === 'green' }" style="background-color: #43A047" />
		            		        </div>
		            		      </v-col>
		            		      <v-col cols="6" class="d-flex flex-column align-center ocupacion-col">
		            		        <span class="ocupacion-label"><v-chip color="blue" dark>Inbi</v-chip></span>
		            		        <v-card 
		            		          color="white"
		            		          class="ocupacion-card pa-5 text-center text-h4 shadowCard black--text"
                              style="cursor: pointer;"
                              @click="abrirDetalleOperacionesClases('inbi')">
		            		          {{ clases.porcentaje_correcto_inbi }} %
		            		        </v-card>
		            		        <span class="ocupacion-label">Clases</span>
		            		        <div
		            		          v-if="getSemaforoEstado(clases.porcentaje_correcto_inbi)"
		            		          class="kpi-semaforo-h kpi-mini-semaforo-bajo-texto"
		            		          aria-hidden="true"
		            		        >
		            		          <span class="kpi-semaforo-h__dot" :class="{ 'kpi-semaforo-h__dot--activo': getSemaforoEstado(clases.porcentaje_correcto_inbi) === 'red' }" style="background-color: #E53935" />
		            		          <span class="kpi-semaforo-h__dot" :class="{ 'kpi-semaforo-h__dot--activo': getSemaforoEstado(clases.porcentaje_correcto_inbi) === 'yellow' }" style="background-color: #FDD835" />
		            		          <span class="kpi-semaforo-h__dot" :class="{ 'kpi-semaforo-h__dot--activo': getSemaforoEstado(clases.porcentaje_correcto_inbi) === 'green' }" style="background-color: #43A047" />
		            		        </div>
		            		      </v-col>
		            		    </v-row>
		            		  </v-card-title>

		            		  <v-card-text class="mt-auto">
		            		    Valor aceptable:
		            		    <v-btn small text color="primary" @click="abrirComparativa('Operaciones - Clases')" class="ml-1">
		            		      <v-icon small left>mdi-compare</v-icon>
		            		      Comparativa
		            		    </v-btn>
		            		  </v-card-text>

		            			<v-btn 
		            		  	color="blue"
		            		  	absolute
		            		  	top
		            		  	right
                        class="mt-0"
		            		  	icon
		            		  	@click="abrirFormulaInfo('Operaciones - Clases')"
		            		  >
		            				<v-icon>mdi-information-outline</v-icon>
		            			</v-btn>
		            		</v-card>
		            	</v-col>

                  <!-- Control I. - Procesos -->
		            	<v-col v-if="kpiAreas.controlInterno && canShowCard('controlInternoVentas')" cols="12" md="6" lg="4">
		            		<v-card color="white" class="text-center black--text fill-height d-flex flex-column">

                      <v-system-bar
                        min-height="44"
                        color="#08273B"
                        class="white--text card-system-bar"
                      >
                        <v-spacer></v-spacer>
                        <span class="card-title-responsive ma-2">Control I. - Procesos</span>
                        <v-spacer></v-spacer>
                      </v-system-bar>
                      <v-progress-linear v-if="kpiLoaders.controlInternoVentas" indeterminate color="primary" height="4" />

		            		  <v-card-title primary-title class="flex-column align-center">
		            		    <v-row class="ocupacion-row">
		            		      <v-col cols="6" class="d-flex flex-column align-center ocupacion-col">
		            		        <span class="ocupacion-label"><v-chip color="red" dark>Fast</v-chip></span>
		            		        <v-card 
		            		          color="white"
		            		          class="ocupacion-card pa-4 text-center text-h4 shadowCard black--text">
		            		          {{ controlInterno.fast }} %
		            		        </v-card>
		            		        <span class="ocupacion-label">Procesos cerrados</span>
		            		        <div
		            		          v-if="getSemaforoEstado(controlInterno.fast)"
		            		          class="kpi-semaforo-h kpi-mini-semaforo-bajo-texto"
		            		          aria-hidden="true"
		            		        >
		            		          <span class="kpi-semaforo-h__dot" :class="{ 'kpi-semaforo-h__dot--activo': getSemaforoEstado(controlInterno.fast) === 'red' }" style="background-color: #E53935" />
		            		          <span class="kpi-semaforo-h__dot" :class="{ 'kpi-semaforo-h__dot--activo': getSemaforoEstado(controlInterno.fast) === 'yellow' }" style="background-color: #FDD835" />
		            		          <span class="kpi-semaforo-h__dot" :class="{ 'kpi-semaforo-h__dot--activo': getSemaforoEstado(controlInterno.fast) === 'green' }" style="background-color: #43A047" />
		            		        </div>
		            		      </v-col>
		            		      <v-col cols="6" class="d-flex flex-column align-center ocupacion-col">
		            		        <span class="ocupacion-label"><v-chip color="blue" dark>Inbi</v-chip></span>
		            		        <v-card 
		            		          color="white"
		            		          class="ocupacion-card pa-4 text-center text-h4 shadowCard black--text">
		            		          {{ controlInterno.inbi  || 32 }} %
		            		        </v-card>
		            		        <span class="ocupacion-label">Procesos cerrados</span>
		            		        <div
		            		          v-if="getSemaforoEstado(controlInterno.inbi)"
		            		          class="kpi-semaforo-h kpi-mini-semaforo-bajo-texto"
		            		          aria-hidden="true"
		            		        >
		            		          <span class="kpi-semaforo-h__dot" :class="{ 'kpi-semaforo-h__dot--activo': getSemaforoEstado(controlInterno.inbi || 33 ) === 'red' }" style="background-color: #E53935" />
		            		          <span class="kpi-semaforo-h__dot" :class="{ 'kpi-semaforo-h__dot--activo': getSemaforoEstado(controlInterno.inbi || 33 ) === 'yellow' }" style="background-color: #FDD835" />
		            		          <span class="kpi-semaforo-h__dot" :class="{ 'kpi-semaforo-h__dot--activo': getSemaforoEstado(controlInterno.inbi || 33 ) === 'green' }" style="background-color: #43A047" />
		            		        </div>
		            		      </v-col>
		            		    </v-row>
		            		  </v-card-title>
		            		  
		            		  <v-card-text class="mt-auto">
		            		    Valor aceptable:
		            		    <v-btn small text color="primary" @click="abrirComparativa('Control I. - Procesos')" class="ml-1">
		            		      <v-icon small left>mdi-compare</v-icon>
		            		      Comparativa
		            		    </v-btn>
		            		  </v-card-text>

		            			<v-btn 
		            		  	color="blue"
		            		  	absolute
		            		  	top
		            		  	right
                        class="mt-0"
		            		  	icon
		            		  	@click="abrirFormulaInfo('Control I. - Procesos')"
		            		  >
		            				<v-icon>mdi-information-outline</v-icon>
		            			</v-btn>
		            		</v-card>
		            	</v-col>

                  <!-- Mantenimiento (TI) -->
		            	<v-col v-if="kpiAreas.mantenimiento && canShowCard('mantenimientoTickets')" cols="12" md="6" lg="4">
		            		<v-card color="white" class="text-center black--text fill-height d-flex flex-column">

                      <v-system-bar
                        min-height="44"
                        color="#08273B"
                        class="white--text card-system-bar"
                      >
                        <v-spacer></v-spacer>
                        <span class="card-title-responsive ma-2">Mantenimiento</span>
                        <v-spacer></v-spacer>
                      </v-system-bar>
                      <v-progress-linear v-if="kpiLoaders.mantenimientoTickets" indeterminate color="primary" height="4" />

		            		  <v-card-title primary-title class="d-block">
		            		    <div class="d-flex flex-column align-center w-100">
		            		      <v-card
		            		        color="white"
		            		        class="pa-3 pa-sm-4 text-center text-h3 shadowCard ti-kpi-pct-card black--text d-flex align-center justify-center"
		            		      >
		            		        {{ mantenimiento.kpi_mantenimiento }} %
		            		      </v-card>
		            		      <span class="ocupacion-label mt-2">IUA (KPI)</span>
		            		      <div
		            		        v-if="mantenimientoSemaforoEstado"
		            		        class="kpi-semaforo-h kpi-mini-semaforo-bajo-texto"
		            		        aria-hidden="true"
		            		      >
		            		        <span
		            		          class="kpi-semaforo-h__dot"
		            		          :class="{ 'kpi-semaforo-h__dot--activo': mantenimientoSemaforoEstado === 'red' }"
		            		          style="background-color: #E53935;"
		            		        />
		            		        <span
		            		          class="kpi-semaforo-h__dot"
		            		          :class="{ 'kpi-semaforo-h__dot--activo': mantenimientoSemaforoEstado === 'yellow' }"
		            		          style="background-color: #FDD835;"
		            		        />
		            		        <span
		            		          class="kpi-semaforo-h__dot"
		            		          :class="{ 'kpi-semaforo-h__dot--activo': mantenimientoSemaforoEstado === 'green' }"
		            		          style="background-color: #43A047;"
		            		        />
		            		      </div>
		            		    </div>
		            		  </v-card-title>
		            		  
		            		  <v-card-text class="mt-auto">
		            		    Valor aceptable: ≥ 90 %
		            		    <v-btn small text color="primary" @click="abrirComparativa('Mantenimiento')" class="ml-1">
		            		      <v-icon small left>mdi-compare</v-icon>
		            		      Comparativa
		            		    </v-btn>
		            		  </v-card-text>

		            			<v-btn 
		            		  	color="blue"
		            		  	absolute
		            		  	top
		            		  	right
		            		  	icon
		            		  	@click="abrirFormulaInfo('Mantenimiento')"
		            		  >
		            				<v-icon>mdi-information-outline</v-icon>
		            			</v-btn>
		            		</v-card>
		            	</v-col>

		            </v-row>
          		</v-col>
          	</v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- Dialog Cómo se calcula (fórmulas por departamento) -->
    <v-dialog v-model="dialogFormulaInfo.estatus" max-width="500" persistent>
      <v-card>
        <v-card-title class="primary white--text">
          <v-icon left dark>mdi-information-outline</v-icon>
          {{ dialogFormulaInfo.titulo }}
          <v-spacer></v-spacer>
          <v-btn icon dark @click="dialogFormulaInfo.estatus = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-4 black--text text-body-1">
          <div class="font-weight-bold mb-2">¿Cómo se calcula?</div>
          <v-list dense class="py-0">
            <v-list-item
              v-for="(item, i) in dialogFormulaInfo.items"
              :key="i"
              class="px-0 align-start"
            >
              <v-list-item-icon class="mr-2 mt-1 align-self-start" min-width="24">
                <v-icon x-small color="primary">mdi-circle</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title class="text-wrap font-weight-regular">{{ item }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogOperacionesClases.estatus" max-width="760" persistent>
      <v-card>
        <v-card-title class="primary white--text">
          <v-icon left dark>mdi-school</v-icon>
          Operaciones - Clases ({{ dialogOperacionesClases.escuelaLabel || 'Escuela' }})
          <v-spacer></v-spacer>
          <v-btn icon dark @click="dialogOperacionesClases.estatus = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-4 black--text text-body-1">
          <template v-if="dialogOperacionesClases.detalle">
            <div class="mb-2"><strong>Entre semana (total):</strong> {{ dialogOperacionesClases.detalle.entreSemana.total }}</div>
            <div class="mb-1"><strong>Online:</strong> {{ dialogOperacionesClases.detalle.entreSemana.online }}</div>
            <div class="mb-1"><strong>Teens:</strong> {{ dialogOperacionesClases.detalle.entreSemana.teens }}</div>
            <div class="mb-2"><strong>Adultos:</strong> {{ dialogOperacionesClases.detalle.entreSemana.adultos }}</div>
            <div class="mb-1"><strong>Sabatinas:</strong> {{ dialogOperacionesClases.detalle.sabatinas }}</div>
            <div class="mb-2"><strong>Dominicales:</strong> {{ dialogOperacionesClases.detalle.dominicales }}</div>
            <div class="mb-2"><strong>Total clases contabilizadas:</strong> {{ dialogOperacionesClases.detalle.totalContabilizadas }}</div>
            <v-divider class="my-2" />
            <div class="mb-1"><strong>Clases correctas:</strong> {{ dialogOperacionesClases.detalle.correctas }}</div>
            <div><strong>Clases incorrectas:</strong> {{ dialogOperacionesClases.detalle.incorrectas }}</div>
            <v-divider class="my-3" />
            <div class="mb-1"><strong>Clases potenciales omitidas:</strong> {{ dialogOperacionesClases.detalle.omitidos.total }}</div>
            <div class="mb-1">Las clases sin teacher oficial ahora se contabilizan como <strong>incorrectas</strong>, no se excluyen.</div>
            <v-list
              v-if="dialogOperacionesClases.detalle.omitidos.grupos && dialogOperacionesClases.detalle.omitidos.grupos.length"
              dense
              class="py-0 mt-2"
            >
              <v-list-item
                v-for="(g, idx) in dialogOperacionesClases.detalle.omitidos.grupos"
                :key="`omitido-clase-${idx}`"
                class="px-0"
              >
                <v-list-item-content class="py-1">
                  <v-list-item-title class="text-wrap">
                    {{ g.grupo }}<span v-if="g.plantel"> - {{ g.plantel }}</span>
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    Potenciales: {{ g.potenciales }}, contabilizadas: {{ g.contabilizadas }}, omitidas: {{ g.omitidas }}
                  </v-list-item-subtitle>
                  <v-list-item-subtitle v-if="g.motivo" class="text-wrap">
                    Motivo: {{ g.motivo }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-alert v-else dense outlined type="success" class="mt-2 mb-0">
              No hay grupos omitidos para esta escuela en el periodo evaluado.
            </v-alert>
          </template>
          <v-alert v-else dense outlined type="warning" class="mb-0">
            No hay detalle disponible para esta escuela.
          </v-alert>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog detalle de ingresos validados (Finanzas) -->
    <v-dialog v-model="dialogIngresoFinanzas.estatus" max-width="700" persistent>
      <v-card>
        <v-card-title class="primary white--text">
          <v-icon left dark>mdi-cash-check</v-icon>
          Finanzas - {{ dialogIngresoFinanzas.escuela || 'Detalle de ingresos' }}
          <v-spacer></v-spacer>
          <v-btn icon dark @click="dialogIngresoFinanzas.estatus = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-4 black--text text-body-1">
          <template v-if="dialogIngresoFinanzas.detalle">
            <div class="mb-2"><strong>Ciclo:</strong> {{ dialogIngresoFinanzas.detalle.ciclo || '—' }}</div>
            <div class="mb-2"><strong>Fecha del primer pago del ciclo:</strong> {{ formatearFechaHora(dialogIngresoFinanzas.detalle.fecha_mas_antigua) }}</div>
            <template v-if="puedeVerMontosFinanzas">
              <div class="mb-2"><strong>Monto total desde el primer pago a la fecha:</strong> {{ formatearMoneda(dialogIngresoFinanzas.detalle.monto_total) }}</div>
              <div class="mb-2"><strong>Monto validado desde el primer pago a la fecha:</strong> {{ formatearMoneda(dialogIngresoFinanzas.detalle.monto_valido) }}</div>
            </template>
            <div class="mb-2"><strong>Porcentaje validación:</strong> {{ formatearPorcentaje(dialogIngresoFinanzas.detalle.porcentaje_validados) }}</div>
            <v-alert dense outlined type="info" class="mb-2">
              Regla de cálculo: primer pago del ciclo más antiguo abierto a la fecha.
            </v-alert>
            <div class="mt-3" v-if="puedeVerMontosFinanzas">
              <strong>Fórmula:</strong>
              ({{ formatearMoneda(dialogIngresoFinanzas.detalle.monto_valido) }} / {{ formatearMoneda(dialogIngresoFinanzas.detalle.monto_total) }}) x 100 =
              <strong>{{ formatearPorcentaje(calcularPorcentajeIngresoFinanzas(dialogIngresoFinanzas.detalle)) }}</strong>
            </div>
            <v-alert v-else dense outlined type="warning" class="mb-0">
              No tienes permisos para visualizar montos.
            </v-alert>
          </template>
          <v-alert v-else dense outlined type="warning" class="mb-0">
            No hay detalle disponible para esta escuela.
          </v-alert>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogEgresoFinanzas.estatus" max-width="700" persistent>
      <v-card>
        <v-card-title class="primary white--text">
          <v-icon left dark>mdi-cash-remove</v-icon>
          Finanzas - {{ dialogEgresoFinanzas.escuela || 'Detalle de egresos' }}
          <v-spacer></v-spacer>
          <v-btn icon dark @click="dialogEgresoFinanzas.estatus = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-4 black--text text-body-1">
          <template v-if="dialogEgresoFinanzas.detalle">
            <template v-if="puedeVerMontosFinanzas">
              <div class="mb-2"><strong>Egresos totales:</strong> {{ formatearMoneda(dialogEgresoFinanzas.detalle.egresosTotales) }}</div>
              <div class="mb-2"><strong>Egresos validados:</strong> {{ formatearMoneda(dialogEgresoFinanzas.detalle.egresosValidados) }}</div>
            </template>
            <div class="mb-2"><strong>Porcentaje validación:</strong> {{ formatearPorcentaje(calcularPorcentajeEgresoFinanzas(dialogEgresoFinanzas.detalle)) }}</div>
            <div class="mt-3" v-if="puedeVerMontosFinanzas">
              <strong>Fórmula:</strong>
              ({{ formatearMoneda(dialogEgresoFinanzas.detalle.egresosValidados) }} / {{ formatearMoneda(dialogEgresoFinanzas.detalle.egresosTotales) }}) x 100 =
              <strong>{{ formatearPorcentaje(calcularPorcentajeEgresoFinanzas(dialogEgresoFinanzas.detalle)) }}</strong>
            </div>
            <v-alert v-else dense outlined type="warning" class="mb-0">
              No tienes permisos para visualizar montos.
            </v-alert>
          </template>
          <v-alert v-else dense outlined type="warning" class="mb-0">
            No hay detalle disponible para esta escuela.
          </v-alert>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog reporte detallado de Finanzas (réplica del reporte del usuario final) -->
    <v-dialog v-model="dialogReporteFinanzas.estatus" max-width="1300" scrollable>
      <v-card>
        <v-card-title class="primary white--text">
          <v-icon left dark>mdi-file-table</v-icon>
          Finanzas - Reporte detallado por ciclo
          <v-spacer></v-spacer>
          <v-btn icon dark @click="dialogReporteFinanzas.estatus = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-4 black--text" style="max-height: 80vh;">
          <v-progress-linear v-if="dialogReporteFinanzas.cargando" indeterminate color="primary" class="mb-3" />

          <v-alert dense outlined type="info" class="mb-3 text-body-2">
            Replica el panel de Egresos del usuario final: solo cuenta egresos en estatus
            <strong>Sin Comprobante, Con Comprobante, Autorizado y Rechazado</strong> (excluye borradores).
            <strong>% Aut. (conteo)</strong> = egresos autorizados ÷ total de egresos (como el panel).
            <strong>% Aut. (monto)</strong> = monto autorizado ÷ monto total (como la comparativa del KPI).
          </v-alert>

          <v-tabs v-model="dialogReporteFinanzas.tab" grow class="mb-3">
            <v-tab>Egresos FAST</v-tab>
            <v-tab>Egresos INBI</v-tab>
            <v-tab>Ingresos FAST</v-tab>
            <v-tab>Ingresos INBI</v-tab>
          </v-tabs>

          <v-tabs-items v-model="dialogReporteFinanzas.tab">
            <!-- Egresos FAST -->
            <v-tab-item>
              <div class="text-subtitle-2 font-weight-bold mb-2 red--text">FINANZAS EGRESOS - FAST</div>
              <v-simple-table dense class="reporte-finanzas-tabla">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th>Ciclo</th>
                      <th class="text-right">Num. Egresos</th>
                      <th class="text-right">Total</th>
                      <th class="text-right">Sin Comp.</th>
                      <th class="text-right">Con Comp.</th>
                      <th class="text-right">Autorizado</th>
                      <th class="text-right">Rechazado</th>
                      <th class="text-right">% Aut. (conteo)</th>
                      <th class="text-right">% Aut. (monto)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="row in reporteFinanzas.egresos.fast.detalle" :key="'ef-' + row.id_ciclo">
                      <td>{{ row.ciclo }}</td>
                      <td class="text-right">{{ formatearNumero(row.num_egresos) }}</td>
                      <td class="text-right">{{ formatearMoneda(row.total) }}</td>
                      <td class="text-right">{{ row.cnt_sin_comp }} / {{ formatearMoneda(row.monto_sin_comp) }}</td>
                      <td class="text-right">{{ row.cnt_con_comp }} / {{ formatearMoneda(row.monto_con_comp) }}</td>
                      <td class="text-right font-weight-bold">{{ row.cnt_autorizado }} / {{ formatearMoneda(row.monto_autorizado) }}</td>
                      <td class="text-right">{{ row.cnt_rechazado }} / {{ formatearMoneda(row.monto_rechazado) }}</td>
                      <td class="text-right font-weight-bold">{{ formatearPorcentaje(row.porcentaje_conteo) }}</td>
                      <td class="text-right">{{ formatearPorcentaje(row.porcentaje_validacion) }}</td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr class="font-weight-bold reporte-finanzas-total">
                      <td>Total Egresos</td>
                      <td class="text-right">{{ formatearNumero(reporteFinanzas.egresos.fast.totales.num_egresos) }}</td>
                      <td class="text-right">{{ formatearMoneda(reporteFinanzas.egresos.fast.totales.total) }}</td>
                      <td class="text-right">{{ reporteFinanzas.egresos.fast.totales.cnt_sin_comp }} / {{ formatearMoneda(reporteFinanzas.egresos.fast.totales.monto_sin_comp) }}</td>
                      <td class="text-right">{{ reporteFinanzas.egresos.fast.totales.cnt_con_comp }} / {{ formatearMoneda(reporteFinanzas.egresos.fast.totales.monto_con_comp) }}</td>
                      <td class="text-right">{{ reporteFinanzas.egresos.fast.totales.cnt_autorizado }} / {{ formatearMoneda(reporteFinanzas.egresos.fast.totales.monto_autorizado) }}</td>
                      <td class="text-right">{{ reporteFinanzas.egresos.fast.totales.cnt_rechazado }} / {{ formatearMoneda(reporteFinanzas.egresos.fast.totales.monto_rechazado) }}</td>
                      <td class="text-right">{{ formatearPorcentaje(reporteFinanzas.egresos.fast.totales.porcentaje_conteo) }}</td>
                      <td class="text-right">{{ formatearPorcentaje(reporteFinanzas.egresos.fast.totales.porcentaje_validacion) }}</td>
                    </tr>
                  </tfoot>
                </template>
              </v-simple-table>
            </v-tab-item>

            <!-- Egresos INBI -->
            <v-tab-item>
              <div class="text-subtitle-2 font-weight-bold mb-2 blue--text">FINANZAS EGRESOS - INBI</div>
              <v-simple-table dense class="reporte-finanzas-tabla">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th>Ciclo</th>
                      <th class="text-right">Num. Egresos</th>
                      <th class="text-right">Total</th>
                      <th class="text-right">Sin Comp.</th>
                      <th class="text-right">Con Comp.</th>
                      <th class="text-right">Autorizado</th>
                      <th class="text-right">Rechazado</th>
                      <th class="text-right">% Aut. (conteo)</th>
                      <th class="text-right">% Aut. (monto)</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="row in reporteFinanzas.egresos.inbi.detalle" :key="'ei-' + row.id_ciclo">
                      <td>{{ row.ciclo }}</td>
                      <td class="text-right">{{ formatearNumero(row.num_egresos) }}</td>
                      <td class="text-right">{{ formatearMoneda(row.total) }}</td>
                      <td class="text-right">{{ row.cnt_sin_comp }} / {{ formatearMoneda(row.monto_sin_comp) }}</td>
                      <td class="text-right">{{ row.cnt_con_comp }} / {{ formatearMoneda(row.monto_con_comp) }}</td>
                      <td class="text-right font-weight-bold">{{ row.cnt_autorizado }} / {{ formatearMoneda(row.monto_autorizado) }}</td>
                      <td class="text-right">{{ row.cnt_rechazado }} / {{ formatearMoneda(row.monto_rechazado) }}</td>
                      <td class="text-right font-weight-bold">{{ formatearPorcentaje(row.porcentaje_conteo) }}</td>
                      <td class="text-right">{{ formatearPorcentaje(row.porcentaje_validacion) }}</td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr class="font-weight-bold reporte-finanzas-total">
                      <td>Total Egresos</td>
                      <td class="text-right">{{ formatearNumero(reporteFinanzas.egresos.inbi.totales.num_egresos) }}</td>
                      <td class="text-right">{{ formatearMoneda(reporteFinanzas.egresos.inbi.totales.total) }}</td>
                      <td class="text-right">{{ reporteFinanzas.egresos.inbi.totales.cnt_sin_comp }} / {{ formatearMoneda(reporteFinanzas.egresos.inbi.totales.monto_sin_comp) }}</td>
                      <td class="text-right">{{ reporteFinanzas.egresos.inbi.totales.cnt_con_comp }} / {{ formatearMoneda(reporteFinanzas.egresos.inbi.totales.monto_con_comp) }}</td>
                      <td class="text-right">{{ reporteFinanzas.egresos.inbi.totales.cnt_autorizado }} / {{ formatearMoneda(reporteFinanzas.egresos.inbi.totales.monto_autorizado) }}</td>
                      <td class="text-right">{{ reporteFinanzas.egresos.inbi.totales.cnt_rechazado }} / {{ formatearMoneda(reporteFinanzas.egresos.inbi.totales.monto_rechazado) }}</td>
                      <td class="text-right">{{ formatearPorcentaje(reporteFinanzas.egresos.inbi.totales.porcentaje_conteo) }}</td>
                      <td class="text-right">{{ formatearPorcentaje(reporteFinanzas.egresos.inbi.totales.porcentaje_validacion) }}</td>
                    </tr>
                  </tfoot>
                </template>
              </v-simple-table>
            </v-tab-item>

            <!-- Ingresos FAST -->
            <v-tab-item>
              <div class="text-subtitle-2 font-weight-bold mb-2 red--text">FINANZAS INGRESOS - FAST</div>
              <v-simple-table dense class="reporte-finanzas-tabla">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th>Ciclo</th>
                      <th class="text-right">Num. Pagos</th>
                      <th class="text-right">Monto Total</th>
                      <th class="text-right">Validado</th>
                      <th class="text-right">No Validado</th>
                      <th class="text-right">% Validación</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="row in reporteFinanzas.ingresos.fast.detalle" :key="'if-' + row.id_ciclo">
                      <td>{{ row.ciclo }}</td>
                      <td class="text-right">{{ formatearNumero(row.num_pagos) }}</td>
                      <td class="text-right">{{ formatearMoneda(row.monto_total) }}</td>
                      <td class="text-right font-weight-bold">{{ row.cnt_validado }} / {{ formatearMoneda(row.monto_validado) }}</td>
                      <td class="text-right">{{ row.cnt_no_validado }} / {{ formatearMoneda(row.monto_no_validado) }}</td>
                      <td class="text-right font-weight-bold">{{ formatearPorcentaje(row.porcentaje_validacion) }}</td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr class="font-weight-bold reporte-finanzas-total">
                      <td>Total Ingresos</td>
                      <td class="text-right">{{ formatearNumero(reporteFinanzas.ingresos.fast.totales.num_pagos) }}</td>
                      <td class="text-right">{{ formatearMoneda(reporteFinanzas.ingresos.fast.totales.monto_total) }}</td>
                      <td class="text-right">{{ reporteFinanzas.ingresos.fast.totales.cnt_validado }} / {{ formatearMoneda(reporteFinanzas.ingresos.fast.totales.monto_validado) }}</td>
                      <td class="text-right">{{ reporteFinanzas.ingresos.fast.totales.cnt_no_validado }} / {{ formatearMoneda(reporteFinanzas.ingresos.fast.totales.monto_no_validado) }}</td>
                      <td class="text-right">{{ formatearPorcentaje(reporteFinanzas.ingresos.fast.totales.porcentaje_validacion) }}</td>
                    </tr>
                  </tfoot>
                </template>
              </v-simple-table>
            </v-tab-item>

            <!-- Ingresos INBI -->
            <v-tab-item>
              <div class="text-subtitle-2 font-weight-bold mb-2 blue--text">FINANZAS INGRESOS - INBI</div>
              <v-simple-table dense class="reporte-finanzas-tabla">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th>Ciclo</th>
                      <th class="text-right">Num. Pagos</th>
                      <th class="text-right">Monto Total</th>
                      <th class="text-right">Validado</th>
                      <th class="text-right">No Validado</th>
                      <th class="text-right">% Validación</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="row in reporteFinanzas.ingresos.inbi.detalle" :key="'ii-' + row.id_ciclo">
                      <td>{{ row.ciclo }}</td>
                      <td class="text-right">{{ formatearNumero(row.num_pagos) }}</td>
                      <td class="text-right">{{ formatearMoneda(row.monto_total) }}</td>
                      <td class="text-right font-weight-bold">{{ row.cnt_validado }} / {{ formatearMoneda(row.monto_validado) }}</td>
                      <td class="text-right">{{ row.cnt_no_validado }} / {{ formatearMoneda(row.monto_no_validado) }}</td>
                      <td class="text-right font-weight-bold">{{ formatearPorcentaje(row.porcentaje_validacion) }}</td>
                    </tr>
                  </tbody>
                  <tfoot>
                    <tr class="font-weight-bold reporte-finanzas-total">
                      <td>Total Ingresos</td>
                      <td class="text-right">{{ formatearNumero(reporteFinanzas.ingresos.inbi.totales.num_pagos) }}</td>
                      <td class="text-right">{{ formatearMoneda(reporteFinanzas.ingresos.inbi.totales.monto_total) }}</td>
                      <td class="text-right">{{ reporteFinanzas.ingresos.inbi.totales.cnt_validado }} / {{ formatearMoneda(reporteFinanzas.ingresos.inbi.totales.monto_validado) }}</td>
                      <td class="text-right">{{ reporteFinanzas.ingresos.inbi.totales.cnt_no_validado }} / {{ formatearMoneda(reporteFinanzas.ingresos.inbi.totales.monto_no_validado) }}</td>
                      <td class="text-right">{{ formatearPorcentaje(reporteFinanzas.ingresos.inbi.totales.porcentaje_validacion) }}</td>
                    </tr>
                  </tfoot>
                </template>
              </v-simple-table>
            </v-tab-item>
          </v-tabs-items>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogDiasFinanzas.estatus" max-width="650" persistent>
      <v-card>
        <v-card-title class="primary white--text">
          <v-icon left dark>mdi-calendar-clock</v-icon>
          Finanzas - Días transcurridos ({{ dialogDiasFinanzas.escuela || 'Escuela' }})
          <v-spacer></v-spacer>
          <v-btn icon dark @click="dialogDiasFinanzas.estatus = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pt-4 black--text text-body-1">
          <template v-if="dialogDiasFinanzas.detalle">
            <div class="mb-2"><strong>Ciclo:</strong> {{ dialogDiasFinanzas.detalle.ciclo || '—' }}</div>
            <div class="mb-2"><strong>Fecha inicio del ciclo:</strong> {{ formatearFechaHora(dialogDiasFinanzas.detalle.fecha_inicio_ciclo) }}</div>
            <div class="mb-2"><strong>Fecha 3er lunes:</strong> {{ formatearFechaHora(dialogDiasFinanzas.detalle.fecha_3er_lunes) }}</div>
            <div class="mb-2"><strong>Días transcurridos:</strong> {{ formatearNumero(dialogDiasFinanzas.detalle.dias_transcurridos) }}</div>
            <v-alert dense outlined type="info" class="mb-0">
              Este total de días lo calcula backend a partir del ciclo abierto vigente y su fecha de referencia (3er lunes) hasta la fecha actual.
            </v-alert>
          </template>
          <v-alert v-else dense outlined type="warning" class="mb-0">
            No hay detalle de días disponible para esta escuela.
          </v-alert>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog Comparativa Acumulado por Semana -->
    <v-dialog
      v-if="dialogComparativa"
      v-model="dialogComparativa.estatus"
      max-width="1600"
      persistent
    >
      <v-card v-if="comparativaData && comparativaData[dialogComparativa.departamento]">
        <v-card-title class="primary white--text text-subtitle-1">
          <v-icon left dark>mdi-compare</v-icon>
          Comparativa acumulado: {{ dialogComparativa.departamento }}
          <v-spacer></v-spacer>
          <v-btn
            v-if="comparativaTieneFormulaInfo"
            icon
            dark
            @click="dialogComparativaInfo = true"
          >
            <v-icon>mdi-information</v-icon>
          </v-btn>
          <v-btn icon dark @click="exportarComparativaExcel">
            <v-icon>mdi-microsoft-excel</v-icon>
          </v-btn>
          <v-btn icon dark @click="dialogComparativa.estatus = false, dialogComparativaInfo = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0" >
          <v-row v-if="dialogComparativa.departamento === 'Operaciones - $$' || dialogComparativa.departamento === 'Op. Inscritos NI' || dialogComparativa.departamento === 'Operaciones - %RI' || dialogComparativa.departamento === 'Operaciones - Clases' || dialogComparativa.departamento === 'Comercial'" class="pa-4 pb-0">
            <v-col cols="12" md="6">
              <v-autocomplete
                v-model="dialogComparativa.ciclo"
                :items="dialogComparativa.departamento === 'Op. Inscritos NI' ? ciclosComparativaOperacionesNI : dialogComparativa.departamento === 'Operaciones - %RI' ? ciclosComparativaOperacionesRI : dialogComparativa.departamento === 'Operaciones - Clases' ? ciclosComparativaOperacionesClases : dialogComparativa.departamento === 'Comercial' ? ciclosComparativaComercial : ciclosComparativaMetamoney"
                label="Filtrar por ciclo"
                filled
                dense
                clearable
                hide-details
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-data-table
            :headers="headersComparativa"
            :items="comparativaTableItems"
            :item-class="comparativaRowClass"
            hide-default-footer
            disable-pagination
            dense
            :class="[
              'elevation-0',
              'text-h6',
              { 'comparativa-ni-color-celdas': dialogComparativa.departamento === 'Op. Inscritos NI' },
              { 'comparativa-ri-color-celdas': dialogComparativa.departamento === 'Operaciones - %RI' },
              { 'comparativa-mm-color-celdas': dialogComparativa.departamento === 'Operaciones - $$' },
              { 'comparativa-rh-color-celdas': dialogComparativa.departamento === 'RH - %Ocupación' },
              { 'comparativa-fin-color-celdas': dialogComparativa.departamento === 'Finanzas' },
              { 'comparativa-oclases-color-celdas': dialogComparativa.departamento === 'Operaciones - Clases' },
              { 'comparativa-ci-color-celdas': dialogComparativa.departamento === 'Control I. - Procesos' },
              { 'comparativa-com-color-celdas': dialogComparativa.departamento === 'Comercial' }
            ]"
          >
            <template v-slot:item.c0="{ item }">
              <!-- RI: Meta | NI: Inbi -->
              <span
                v-if="item.c0 && typeof item.c0 === 'object' && dialogComparativa.departamento === 'Operaciones - %RI'"
              >
                {{ item.c0.val != null ? item.c0.val + (comparativaEsPorcentaje ? '%' : '') : '-' }}
              </span>
              <span
                v-else-if="item.c0 && typeof item.c0 === 'object' && dialogComparativa.departamento === 'Operaciones - $$'"
              >
                {{ item.c0.val != null ? item.c0.val + (comparativaEsPorcentaje ? '%' : '') : '-' }}
              </span>
              <span
                v-else-if="item.c0 && typeof item.c0 === 'object'"
                :class="{ 'comparativa-ni-inbi': dialogComparativa.departamento === 'Op. Inscritos NI' }"
              >
                {{ item.c0.val != null ? item.c0.val + (comparativaEsPorcentaje ? '%' : '') : '-' }}
              </span>
              <span v-else :class="{ 'comparativa-ni-inbi': dialogComparativa.departamento === 'Op. Inscritos NI' }">{{ item.c0 }}</span>
            </template>
            <template v-slot:item.c1="{ item }">
              <!-- RI: Fast | NI: Semana Inbi / Comercial -->
              <span
                v-if="item.c1 && typeof item.c1 === 'object' && dialogComparativa.departamento === 'Operaciones - %RI'"
              >
                {{ item.c1.val != null ? item.c1.val + (comparativaEsPorcentaje ? '%' : '') : '-' }}
              </span>
              <span
                v-else-if="item.c1 && typeof item.c1 === 'object' && dialogComparativa.departamento === 'Operaciones - $$'"
              >
                {{ item.c1.val != null ? item.c1.val + (comparativaEsPorcentaje ? '%' : '') : '-' }}
              </span>
              <span
                v-else-if="item.c1 && typeof item.c1 === 'object'"
                :class="{ 'comparativa-ni-inbi': dialogComparativa.departamento === 'Op. Inscritos NI' }"
              >
                {{ item.c1.val != null ? item.c1.val + (comparativaEsPorcentaje ? '%' : '') : '-' }}
              </span>
              <span v-else :class="{ 'comparativa-ni-inbi': dialogComparativa.departamento === 'Op. Inscritos NI' }">{{ item.c1 }}</span>
            </template>
            <template v-slot:item.c2="{ item }">
              <!-- RI: Diferencia Fast | NI: Meta Inbi -->
              <span
                v-if="item.c2 && typeof item.c2 === 'object' && dialogComparativa.departamento === 'Operaciones - %RI'"
                class="d-inline-flex align-center flex-wrap comparativa-ri-diff"
              >
                <template v-if="item.c2.val != null">
                  <span :class="item.c2.val >= 0 ? 'success--text' : 'error--text'">
                    {{ (item.c2.val > 0 ? '+' : '') + item.c2.val + (comparativaEsPorcentaje ? '%' : '') }}
                  </span>
                  <v-icon
                    small
                    class="ml-1"
                    :color="item.c2.val >= 0 ? 'success' : 'error'"
                  >
                    {{ item.c2.val >= 0 ? 'mdi-check-circle' : 'mdi-close-circle' }}
                  </v-icon>
                </template>
                <template v-else>-</template>
              </span>
              <span
                v-else-if="item.c2 && typeof item.c2 === 'object' && dialogComparativa.departamento === 'Operaciones - $$'"
                class="d-inline-flex align-center flex-wrap"
              >
                {{ item.c2.val != null ? item.c2.val + (comparativaEsPorcentaje ? '%' : '') : '-' }}
                <v-icon
                  v-if="item.c2.val != null"
                  small
                  class="ml-1"
                  :color="item.c2.val >= 0 ? 'success' : 'error'"
                >
                  {{ item.c2.val >= 0 ? 'mdi-check-circle' : 'mdi-close-circle' }}
                </v-icon>
              </span>
              <span
                v-else-if="item.c2 && typeof item.c2 === 'object'"
                class="d-inline-flex align-center flex-wrap"
                :class="{ 'comparativa-ni-inbi': dialogComparativa.departamento === 'Op. Inscritos NI' }"
              >
                {{
                  item.c2.val != null
                    ? (((dialogComparativa.departamento === 'RH - %Ocupación' || dialogComparativa.departamento === 'TI' || dialogComparativa.departamento === 'Mantenimiento' || dialogComparativa.departamento === 'Finanzas' || dialogComparativa.departamento === 'Operaciones - Clases' || dialogComparativa.departamento === 'Control I. - Procesos')
                        ? Number(item.c2.val).toFixed(2)
                        : item.c2.val) + (comparativaEsPorcentaje ? '%' : ''))
                    : '-'
                }}
                <v-icon
                  v-if="item.c2.val != null && dialogComparativa.departamento !== 'Op. Inscritos NI'"
                  small
                  class="ml-1"
                  :color="item.c2.val >= 0 ? 'success' : 'error'"
                >
                  {{ item.c2.val >= 0 ? 'mdi-check-circle' : 'mdi-close-circle' }}
                </v-icon>
              </span>
              <span v-else :class="{ 'comparativa-ni-inbi': dialogComparativa.departamento === 'Op. Inscritos NI' }">{{ item.c2 }}</span>
            </template>
            <template v-slot:item.c3="{ item }">
              <!-- RI: Inbi | NI: Diferencia Inbi -->
              <span
                v-if="item.c3 && typeof item.c3 === 'object' && dialogComparativa.departamento === 'Operaciones - %RI'"
              >
                {{ item.c3.val != null ? item.c3.val + (comparativaEsPorcentaje ? '%' : '') : '-' }}
              </span>
              <span
                v-else-if="item.c3 && typeof item.c3 === 'object' && dialogComparativa.departamento === 'Operaciones - $$'"
              >
                {{ item.c3.val != null ? item.c3.val + (comparativaEsPorcentaje ? '%' : '') : '-' }}
              </span>
              <span
                v-else-if="item.c3 && typeof item.c3 === 'object' && dialogComparativa.departamento === 'Op. Inscritos NI'"
                class="d-inline-flex align-center flex-wrap"
                :class="{ 'comparativa-ni-inbi': true }"
              >
                {{ item.c3.val != null ? item.c3.val : '-' }}
                <v-icon
                  v-if="item.c3.val != null"
                  small
                  class="ml-1"
                  :color="item.c3.val >= 0 ? 'success' : 'error'"
                >
                  {{ item.c3.val >= 0 ? 'mdi-check-circle' : 'mdi-close-circle' }}
                </v-icon>
              </span>
              <span
                v-else-if="item.c3 && typeof item.c3 === 'object' && dialogComparativa.departamento === 'Operaciones - Clases'"
              >
                {{ item.c3.val != null ? Number(item.c3.val).toFixed(2) + '%' : '-' }}
              </span>
              <span
                v-else-if="item.c3 && typeof item.c3 === 'object'"
                :class="{ 'comparativa-ni-inbi': dialogComparativa.departamento === 'Op. Inscritos NI' }"
              >
                {{
                  item.c3.val != null
                    ? (((dialogComparativa.departamento === 'Comercial')
                        ? Number(item.c3.val).toFixed(2)
                        : item.c3.val) + ((dialogComparativa.departamento === 'Comercial' || comparativaEsPorcentaje) ? '%' : ''))
                    : '-'
                }}
              </span>
              <span v-else :class="{ 'comparativa-ni-inbi': dialogComparativa.departamento === 'Op. Inscritos NI' }">{{ item.c3 }}</span>
            </template>
            <template v-slot:item.c4="{ item }">
              <!-- RI: Diferencia Inbi | NI: Fast (conteo) -->
              <span
                v-if="item.c4 && typeof item.c4 === 'object' && dialogComparativa.departamento === 'Operaciones - %RI'"
                class="d-inline-flex align-center flex-wrap comparativa-ri-diff"
              >
                <template v-if="item.c4.val != null">
                  <span :class="item.c4.val >= 0 ? 'success--text' : 'error--text'">
                    {{ (item.c4.val > 0 ? '+' : '') + item.c4.val + (comparativaEsPorcentaje ? '%' : '') }}
                  </span>
                </template>
                <template v-else>-</template>
              </span>
              <span
                v-else-if="item.c4 && typeof item.c4 === 'object' && dialogComparativa.departamento === 'Operaciones - $$'"
              >
                {{ item.c4.val != null ? item.c4.val + (comparativaEsPorcentaje ? '%' : '') : '-' }}
              </span>
              <span
                v-else-if="item.c4 && typeof item.c4 === 'object' && dialogComparativa.departamento === 'Operaciones - Clases'"
              >
                {{ item.c4.val != null ? item.c4.val + '%' : '-' }}
              </span>
              <span
                v-else-if="item.c4 && typeof item.c4 === 'object' && dialogComparativa.departamento === 'Comercial'"
              >
                {{ item.c4.val != null ? item.c4.val + '%' : '-' }}
              </span>
              <span
                v-else-if="item.c4 && typeof item.c4 === 'object'"
                :class="{ 'comparativa-ni-fast': dialogComparativa.departamento === 'Op. Inscritos NI' }"
              >
                {{
                  item.c4.val != null
                    ? ((dialogComparativa.departamento === 'Finanzas')
                        ? Number(item.c4.val).toFixed(2) + '%'
                        : item.c4.val)
                    : '-'
                }}
                <v-icon
                  v-if="dialogComparativa.departamento === 'RH - %Ocupación' && item.c4.val != null"
                  small
                  class="ml-1"
                  color="grey darken-1"
                >
                  mdi-percent
                </v-icon>
              </span>
              <span v-else :class="{ 'comparativa-ni-fast': dialogComparativa.departamento === 'Op. Inscritos NI' }">{{ item.c4 }}</span>
            </template>
            <template v-slot:item.c5="{ item }">
              <span
                v-if="dialogComparativa.departamento === 'Operaciones - %RI' && item.c5 && typeof item.c5 === 'object'"
                class="d-inline-flex align-center flex-wrap comparativa-ri-diff"
              >
                <template v-if="item.c5.val != null">
                  <span :class="item.c5.val >= 0 ? 'success--text' : 'error--text'">
                    {{ (item.c5.val > 0 ? '+' : '') + item.c5.val + (comparativaEsPorcentaje ? '%' : '') }}
                  </span>
                  <v-icon
                    small
                    class="ml-1"
                    :color="item.c5.val >= 0 ? 'success' : 'error'"
                  >
                    {{ item.c5.val >= 0 ? 'mdi-check-circle' : 'mdi-close-circle' }}
                  </v-icon>
                </template>
                <template v-else>-</template>
              </span>
              <span
                v-else-if="item.c5 && typeof item.c5 === 'object' && dialogComparativa.departamento === 'Operaciones - $$'"
                class="d-inline-flex align-center flex-wrap"
              >
                {{ item.c5.val != null ? item.c5.val + (comparativaEsPorcentaje ? '%' : '') : '-' }}
                <v-icon
                  v-if="item.c5.val != null"
                  small
                  class="ml-1"
                  :color="item.c5.val >= 0 ? 'success' : 'error'"
                >
                  {{ item.c5.val >= 0 ? 'mdi-check-circle' : 'mdi-close-circle' }}
                </v-icon>
              </span>
              <span
                v-else-if="dialogComparativa.departamento === 'Operaciones - %RI' && item.c5 && item.c5.esRI"
                class="d-flex align-center justify-center flex-wrap comparativa-ri-cumple"
                style="gap: 10px;"
              >
                <span class="d-inline-flex align-center">
                  <v-icon small :color="item.c5.cumpleFast ? 'success' : 'error'">
                    {{ item.c5.cumpleFast ? 'mdi-check-circle' : 'mdi-close-circle' }}
                  </v-icon>
                  <span class="caption ml-1">Fast</span>
                </span>
                <span class="d-inline-flex align-center">
                  <v-icon small :color="item.c5.cumpleInbi ? 'success' : 'error'">
                    {{ item.c5.cumpleInbi ? 'mdi-check-circle' : 'mdi-close-circle' }}
                  </v-icon>
                  <span class="caption ml-1">Inbi</span>
                </span>
              </span>
              <span
                v-else-if="item.c5 && typeof item.c5 === 'object'"
                class="d-inline-flex align-center flex-wrap"
                :class="{ 'comparativa-ni-fast': dialogComparativa.departamento === 'Op. Inscritos NI' }"
              >
                {{ textoCeldaComparativaC5(item) }}
                <v-icon
                  v-if="item.c5.val != null && dialogComparativa.departamento !== 'Op. Inscritos NI' && dialogComparativa.departamento !== 'Operaciones - Clases'"
                  small
                  class="ml-1"
                  :color="item.c5.val >= 0 ? 'success' : 'error'"
                >
                  {{ item.c5.val >= 0 ? 'mdi-check-circle' : 'mdi-close-circle' }}
                </v-icon>
              </span>
              <span v-else :class="{ 'comparativa-ni-fast': dialogComparativa.departamento === 'Op. Inscritos NI' }">{{ item.c5 }}</span>
            </template>
            <template v-slot:item.c6="{ item }">
              <span
                v-if="dialogComparativa.departamento === 'Operaciones - $$' && item.c6 && item.c6.esMoney"
                class="d-flex align-center justify-center flex-wrap comparativa-ri-cumple"
                style="gap: 10px;"
              >
                <span class="d-inline-flex align-center">
                  <v-icon small :color="item.c6.cumpleFast ? 'success' : 'error'">
                    {{ item.c6.cumpleFast ? 'mdi-check-circle' : 'mdi-close-circle' }}
                  </v-icon>
                  <span class="caption ml-1">Fast</span>
                </span>
                <span class="d-inline-flex align-center">
                  <v-icon small :color="item.c6.cumpleInbi ? 'success' : 'error'">
                    {{ item.c6.cumpleInbi ? 'mdi-check-circle' : 'mdi-close-circle' }}
                  </v-icon>
                  <span class="caption ml-1">Inbi</span>
                </span>
              </span>
              <span
                v-else-if="item.c6 && typeof item.c6 === 'object' && dialogComparativa.departamento === 'Operaciones - Clases'"
                class="d-inline-flex align-center flex-wrap"
              >
                {{ item.c6.val != null ? Number(item.c6.val).toFixed(2) + '%' : '-' }}
                <v-icon
                  v-if="item.c6.val != null"
                  small
                  class="ml-1"
                  :color="item.c6.val >= 0 ? 'success' : 'error'"
                >
                  {{ item.c6.val >= 0 ? 'mdi-check-circle' : 'mdi-close-circle' }}
                </v-icon>
              </span>
              <span
                v-else-if="item.c6 && typeof item.c6 === 'object'"
                :class="{ 'comparativa-ni-fast': dialogComparativa.departamento === 'Op. Inscritos NI' }"
              >
                {{ item.c6.val != null ? item.c6.val : '-' }}
              </span>
              <span v-else :class="{ 'comparativa-ni-fast': dialogComparativa.departamento === 'Op. Inscritos NI' }">{{ item.c6 }}</span>
            </template>
            <template v-slot:item.c7="{ item }">
              <span
                v-if="item.c7 && typeof item.c7 === 'object' && dialogComparativa.departamento === 'Op. Inscritos NI'"
                class="d-inline-flex align-center flex-wrap"
                :class="{ 'comparativa-ni-fast': true }"
              >
                {{ item.c7.val != null ? item.c7.val : '-' }}
                <v-icon
                  v-if="item.c7.val != null"
                  small
                  class="ml-1"
                  :color="item.c7.val >= 0 ? 'success' : 'error'"
                >
                  {{ item.c7.val >= 0 ? 'mdi-check-circle' : 'mdi-close-circle' }}
                </v-icon>
              </span>
              <span
                v-else-if="item.c7 && typeof item.c7 === 'object' && dialogComparativa.departamento === 'Operaciones - Clases'"
              >
                {{ item.c7.val != null ? Number(item.c7.val).toFixed(2) + '%' : '-' }}
              </span>
              <span
                v-else-if="item.c7 && typeof item.c7 === 'object'"
                :class="{ 'comparativa-ni-fast': dialogComparativa.departamento === 'Op. Inscritos NI' }"
              >
                {{
                  item.c7.val != null
                    ? ((dialogComparativa.departamento === 'Finanzas')
                        ? Number(item.c7.val).toFixed(2) + '%'
                        : item.c7.val)
                    : '-'
                }}
                <v-icon
                  v-if="dialogComparativa.departamento === 'RH - %Ocupación' && item.c7.val != null"
                  small
                  class="ml-1"
                  color="grey darken-1"
                >
                  mdi-percent
                </v-icon>
              </span>
              <span v-else :class="{ 'comparativa-ni-fast': dialogComparativa.departamento === 'Op. Inscritos NI' }">{{ item.c7 }}</span>
            </template>
            <template v-slot:item.c8="{ item }">
              <span v-if="item.c8 && typeof item.c8 === 'object'" class="d-inline-flex align-center flex-wrap">
                {{
                  item.c8.val != null
                    ? ((dialogComparativa.departamento === 'RH - %Ocupación' || dialogComparativa.departamento === 'Finanzas'
                        ? Number(item.c8.val).toFixed(2)
                        : item.c8.val) + (comparativaEsPorcentaje ? '%' : ''))
                    : '-'
                }}
                <v-icon
                  v-if="item.c8.val != null && (dialogComparativa.departamento === 'Comercial' || dialogComparativa.departamento === 'RH - %Ocupación' || dialogComparativa.departamento === 'Finanzas')"
                  small
                  class="ml-1"
                  :color="item.c8.val >= 0 ? 'success' : 'error'"
                >
                  {{ item.c8.val >= 0 ? 'mdi-check-circle' : 'mdi-close-circle' }}
                </v-icon>
              </span>
              <span v-else>{{ item.c8 }}</span>
            </template>
            <template v-slot:item.c9="{ item }">
              <span v-if="item.c9 && typeof item.c9 === 'object'">
                {{
                  item.c9.val != null
                    ? (((dialogComparativa.departamento === 'Comercial')
                        ? Number(item.c9.val).toFixed(2)
                        : item.c9.val) + (comparativaEsPorcentaje ? '%' : ''))
                    : '-'
                }}
              </span>
              <span v-else>{{ item.c9 }}</span>
            </template>
            <template v-slot:item.c10="{ item }">
              <span v-if="item.c10 && typeof item.c10 === 'object'">
                {{
                  item.c10.val != null
                    ? (((dialogComparativa.departamento === 'Comercial')
                        ? Number(item.c10.val).toFixed(2)
                        : item.c10.val) + ((dialogComparativa.departamento === 'Comercial' || comparativaEsPorcentaje) ? '%' : ''))
                    : '-'
                }}
              </span>
              <span v-else>{{ item.c10 }}</span>
            </template>
            <template v-slot:item.c11="{ item }">
              <span v-if="item.c11 && typeof item.c11 === 'object'" class="d-inline-flex align-center flex-wrap">
                {{
                  item.c11.val != null
                    ? ((dialogComparativa.departamento === 'RH - %Ocupación' || dialogComparativa.departamento === 'Finanzas' || dialogComparativa.departamento === 'Comercial'
                        ? Number(item.c11.val).toFixed(2)
                        : item.c11.val) + (comparativaEsPorcentaje ? '%' : ''))
                    : '-'
                }}
                <v-icon
                  v-if="item.c11.val != null && (dialogComparativa.departamento === 'Comercial' || dialogComparativa.departamento === 'RH - %Ocupación' || dialogComparativa.departamento === 'Finanzas')"
                  small
                  class="ml-1"
                  :color="item.c11.val >= 0 ? 'success' : 'error'"
                >
                  {{ item.c11.val >= 0 ? 'mdi-check-circle' : 'mdi-close-circle' }}
                </v-icon>
              </span>
              <span v-else>{{ item.c11 }}</span>
            </template>
          </v-data-table>
          <div v-if="dialogComparativa.departamento === 'RH - %Ocupación'" class="grey--text text-caption px-4 pb-4 pt-2">
            * La semana empieza en Sábado y termina en Viernes
          </div>
          <div v-else class="grey--text text-caption px-4 pb-4 pt-2">
            * La semana empieza en lunes y termina en domingo
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogComparativaInfo" max-width="980">
      <v-card>
        <v-card-title class="primary white--text text-subtitle-1">
          <v-icon left dark>mdi-information</v-icon>
          Cálculo del KPI — {{ dialogComparativa.departamento }}
          <v-spacer></v-spacer>
          <v-btn icon dark @click="dialogComparativaInfo = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-4" style="max-height: 70vh; overflow-y: auto;">
          <v-alert
            v-if="comparativaKpiTicketsFormula"
            dense
            outlined
            type="info"
            class="text-body-2 mb-3"
          >
            <div class="font-weight-medium mb-1">Cálculo del IUA (KPI {{ comparativaKpiTicketsFormula.etiqueta }})</div>
            <div><strong>Fórmula:</strong> IUA = (Resolución × 0,5) + (Velocidad × 0,3) + (Control de backlog × 0,2).</div>
            <div class="mt-1 text-caption">
              El periodo arranca en la fecha del <strong>primer ticket activo</strong> (estatus 2, 3, 4 o 7) y corta en la fecha final del filtro. El control de backlog mide la cola acumulada desde ese inicio.
            </div>
            <div class="mt-2"><strong>Definición de componentes:</strong></div>
            <ul class="mb-2 pl-4">
              <li>Resolución = (tickets resueltos ÷ total tickets del periodo) × 100. Resuelto = estatus Respondido (5) o Cerrado (6).</li>
              <li>Velocidad = (SLA objetivo ÷ tiempo promedio de cierre formal) × 100, tope 100%. Solo tickets Cerrados (6). Si el promedio es 0 h pero hay cierres, se toma 100%.</li>
              <li>Control de backlog = (1 − (tickets pendientes ÷ total tickets)) × 100. Pendiente = estatus Asignado, Pendiente, Revisión o Rechazado (2, 3, 4, 7).</li>
            </ul>
            <div v-if="comparativaKpiTicketsFormula.periodoFmt">
              <strong>Periodo:</strong> {{ comparativaKpiTicketsFormula.periodoFmt }}
            </div>
            <div class="mt-2">
              <strong>Valores actuales (respuesta del back):</strong>
              total tickets = {{ comparativaKpiTicketsFormula.tt }}, resueltos = {{ comparativaKpiTicketsFormula.tr }}, pendientes = {{ comparativaKpiTicketsFormula.tp }}, cerrados formales (6) = {{ comparativaKpiTicketsFormula.tc }},
              SLA objetivo = {{ comparativaKpiTicketsFormula.sla }} h, tiempo promedio resolución = {{ comparativaKpiTicketsFormula.tprFmt }} h.
            </div>
            <div class="mt-2">
              <strong>Componentes (%):</strong>
              Resolución = {{ comparativaKpiTicketsFormula.resFmt }}%,
              Velocidad = {{ comparativaKpiTicketsFormula.velFmt }}%,
              Control de backlog = {{ comparativaKpiTicketsFormula.backFmt }}%.
            </div>
            <div class="mt-2">
              <strong>Sustitución en la fórmula:</strong>
              ({{ comparativaKpiTicketsFormula.resFmt }} × 0,5) + ({{ comparativaKpiTicketsFormula.velFmt }} × 0,3) + ({{ comparativaKpiTicketsFormula.backFmt }} × 0,2)
              <template v-if="comparativaKpiTicketsFormula.iuaCalcFmt !== '—'">= {{ comparativaKpiTicketsFormula.iuaCalcFmt }}%</template>
              <template v-if="comparativaKpiTicketsFormula.kpiFmt !== '—'"> — KPI reportado: <strong>{{ comparativaKpiTicketsFormula.kpiFmt }}%</strong></template>
            </div>
          </v-alert>
          <v-alert
            v-if="comparativaComercialFormula"
            dense
            outlined
            type="info"
            class="text-body-2 mb-3"
          >
            <div class="font-weight-medium mb-1">
              Comercial — prospectos y conversión
              <span v-if="comparativaComercialFormula.modo === 'soloConversion'" class="font-weight-regular">(solo % semanal)</span>
            </div>
            <div>
              <strong>Prospectos (periodo actual):</strong> conteo de prospectos activos por escuela (mismas listas que en la tarjeta).
              Fast: <strong>{{ comparativaComercialFormula.prospectosFast }}</strong>, Inbi: <strong>{{ comparativaComercialFormula.prospectosInbi }}</strong>.
            </div>
            <div class="mt-2"><strong>Fórmula de conversión:</strong> % conversión = (inscritos ÷ prospectos) × 100.</div>
          </v-alert>
          <v-alert
            v-if="comparativaFinanzasFormula && mostrarDesgloseFinanzasComparativa"
            dense
            outlined
            type="info"
            class="text-body-2 mb-3"
          >
            <div class="font-weight-medium mb-1">Finanzas — desglose de porcentajes (periodo actual)</div>
            <div class="mb-2">Los % de la tarjeta y de la fila «Actual» en la comparativa provienen del back.</div>
            <div><strong>Ingresos validados %</strong> = (suma de ingresos validados ÷ suma de ingresos totales) × 100</div>
            <div><strong>Egresos validados %</strong> = (total validado de egresos ÷ suma de egresos) × 100</div>
          </v-alert>
          <v-alert
            v-if="comparativaOperacionesMoneyFormula && mostrarDesgloseOperacionesMoneyComparativa"
            dense
            outlined
            type="info"
            class="text-body-2 mb-3"
          >
            <div class="font-weight-medium mb-1">Operaciones — ingresos vs meta (periodo actual)</div>
            <div><strong>% Avance</strong> = (suma de ingresos del ciclo ÷ meta de ingreso del ciclo) × 100</div>
            <div><strong>% Faltante</strong> = 100% − % avance</div>
            <div><strong>Faltante en monto</strong> ≈ meta − suma ingresos</div>
          </v-alert>
          <v-alert
            v-if="comparativaOperacionesClasesFormula"
            dense
            outlined
            type="info"
            class="text-body-2 mb-0"
          >
            <div class="font-weight-medium mb-1">Operaciones - Clases — cálculo de cumplimiento (periodo actual)</div>
            <div><strong>Fórmula:</strong> % cumplimiento = (clases correctas ÷ obligaciones) × 100.</div>
            <div class="mt-2"><strong>Fast:</strong> ({{ comparativaOperacionesClasesFormula.fast.correctas }} ÷ {{ comparativaOperacionesClasesFormula.fast.total }}) × 100 = <strong>{{ comparativaOperacionesClasesFormula.fast.pctFmt }}%</strong></div>
            <div class="mt-1"><strong>Inbi:</strong> ({{ comparativaOperacionesClasesFormula.inbi.correctas }} ÷ {{ comparativaOperacionesClasesFormula.inbi.total }}) × 100 = <strong>{{ comparativaOperacionesClasesFormula.inbi.pctFmt }}%</strong></div>
            <div class="mt-2"><strong>% cumplimiento de movimientos</strong> = (movimientos guardados en la semana ÷ total de clases de la semana) × 100. Cada Guardar del rol cuenta como un movimiento. Las semanas anteriores se calculan igual, con el total de clases de su propio ciclo.</div>
          </v-alert>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog de detalles de los requeridos -->
    <v-dialog
      v-model="dialogRequeridos"
      max-width="800px"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-title primary-title>
          Detalles de los requeridos
          <span v-if="rhDialogMeta" class="text-body-2 font-weight-regular ml-2">— {{ rhDialogMeta.alcance }}</span>
          <v-spacer></v-spacer>
        </v-card-title>

        <v-card-text class="black--text">
          <v-alert
            v-if="rhDialogMeta"
            dense
            outlined
            type="info"
            class="text-body-2 mb-3"
          >
            <div class="font-weight-medium mb-1">Cálculo del % de ocupación</div>
            <div>
              <strong>Fórmula:</strong> % ocupación = (plazas cubiertas ÷ plazas autorizadas) × 100.
              Las plazas cubiertas son vacantes con trabajador asignado; las autorizadas son el total de vacantes en el ámbito; las no cubiertas aparecen como «vacantes» en la tabla.
            </div>
            <div class="mt-2">
              <strong>Con los valores de esta vista:</strong>
              ({{ rhDialogMeta.plazasCubiertas }} ÷ {{ rhDialogMeta.plazasAutorizadas }}) × 100
              <template v-if="rhDialogMeta.plazasAutorizadas > 0">
                = <strong>{{ rhDialogMeta.porcentaje }}%</strong>
              </template>
              <template v-else>
                — sin plazas autorizadas no aplica el porcentaje.
              </template>
            </div>
          </v-alert>
          <v-data-table
            :headers="headersRequeridos"
            :items="vacantes_requeridos"
            class="elevation-0"
            :mobile-breakpoint="100"
            dense
          >

            <template v-slot:item.autorizados="{ item }">
              <v-chip color="green" small dark @click="dialogPersonal = true, personal = item.autorizados">{{ item.autorizados }}</v-chip>
            </template>

            <template v-slot:item.activos="{ item }">
              <v-chip color="red" small dark @click="dialogPersonal = true, personal = item.activos">{{ item.activos }}</v-chip>
            </template>

            <template v-slot:item.vacantes="{ item }">
              <v-chip color="yellow" small  @click="dialogPersonal = true, personal = item.vacantes">{{ item.vacantes }}</v-chip>
            </template>

            <template v-slot:item.percent_ocupacion="{ item }">
              <v-chip color="green"  v-if="item.percent_ocupacion >= 100" small dark >{{ item.percent_ocupacion }}%</v-chip>
              <v-chip color="yellow" v-else-if="item.percent_ocupacion >= 80" small  >{{ item.percent_ocupacion }}%</v-chip>
              <v-chip color="red"    v-else                 small dark >{{ item.percent_ocupacion }}%</v-chip>
            </template>

            <template v-slot:body.append>
              <tr v-if="rhDialogMeta" class="font-weight-medium">
                <td>Total</td>
                <td class="text-end">{{ rhRequeridosTotales.autorizados }}</td>
                <td class="text-end">{{ rhRequeridosTotales.activos }}</td>
                <td class="text-end">{{ rhRequeridosTotales.vacantes }}</td>
                <td class="text-end">
                  <v-chip color="green" v-if="Number(rhRequeridosTotales.percent_ocupacion) >= 100" small dark>{{ rhRequeridosTotales.percent_ocupacion }}%</v-chip>
                  <v-chip color="yellow" v-else-if="Number(rhRequeridosTotales.percent_ocupacion) >= 80" small>{{ rhRequeridosTotales.percent_ocupacion }}%</v-chip>
                  <v-chip color="red" v-else small dark>{{ rhRequeridosTotales.percent_ocupacion }}%</v-chip>
                </td>
              </tr>
            </template>
          </v-data-table>
          <div v-if="rhDialogMeta" class="grey--text text-caption mt-2">
            Total fila: mismos totales que la tarjeta — autorizados {{ rhRequeridosTotales.autorizados }}, cubiertos {{ rhRequeridosTotales.activos }}, sin cubrir {{ rhRequeridosTotales.vacantes }}.
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Dialog de carga -->
    <Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
    <carga                v-if="cargar"/>

  </v-container>
</template>
<script>
  import axios from 'axios';

  import { mapGetters } from 'vuex'
  // Componentes
  import Alerta                from '@/components/alertas/Alerta.vue'
  import carga                 from '@/components/alertas/carga.vue';

  import validarErrores        from '@/mixins/validarErrores'
  import funcionesExcel        from '@/mixins/funcionesExcel'

  // COMPONENTES PARA EL DESGLOSE
  import JefeRecursos          from '@/components/kpi/JefeRecursos'
  import JefeComercial         from '@/components/kpi/JefeComercial'
  import JefeFinanzas          from '@/components/kpi/JefeFinanzas'
  import JefeTI                from '@/components/kpi/JefeTI'
  import JefeOperaciones       from '@/components/kpi/JefeOperaciones'
  import JefeOperacionesClases from '@/components/kpi/JefeOperacionesClases'

  import XLSX from 'xlsx'

  /** Ven todos los KPI y todas las consultas: JEFE DE TI, DESARROLLADOR DE SOFTWARE, DIRECTOR GENERAL, JEFE DE CONTROL INTERNO */
  const KPI_PUESTO_VER_TODO = [11, 12, 43, 107]
  /** Usuarios con acceso total al dashboard (independiente del puesto). */
  const KPI_USUARIO_ACCESO_TOTAL = [966]

  function kpiUsuarioTieneAccesoTotal (u) {
    if (!u || u.iderp == null) return false
    return KPI_USUARIO_ACCESO_TOTAL.indexOf(Number(u.iderp)) !== -1
  }
  /**
   * Resto de puestos: solo el área indicada (consultas acotadas en initialize).
   * 40 JEFE DE OPERACIONES, 88 ASIST. JEFE OP., 54 JEFE COMERCIAL, 101 ASIST. JEFE COM.,
   * 56 JEFE DE ADMINISTRACION (finanzas), 68 JEFE DE RECURSOS HUMANOS
   */
  const KPI_AREA_POR_PUESTO = {
    40: ['operaciones'],
    88: ['operaciones'],
    48: ['comercial'],
    101: ['comercial'],
    56: ['finanzas'],
    68: ['rh'],
  }

  function kpiAreasVacias () {
    return {
      operaciones: false,
      rh: false,
      comercial: false,
      finanzas: false,
      ti: false,
      mantenimiento: false,
      controlInterno: false,
    }
  }

  function kpiAreasTodas () {
    return {
      operaciones: true,
      rh: true,
      comercial: true,
      finanzas: true,
      ti: true,
      mantenimiento: true,
      controlInterno: true,
    }
  }

  function idNumKpi (v) {
    if (v == null || v === '') return 0
    const raw = String(v).trim()
    const upper = raw.toUpperCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')
    if (upper === 'SIN TEACHER' || upper === 'SIN MAESTRO' || upper.includes('SINMAESTRO') || upper.includes('COMODIN')) return 0
    const n = Number(v)
    return Number.isNaN(n) ? 0 : n
  }

  function campoOficialKpi (grupo, tf) {
    if (tf === 'id_teacher') {
      return idNumKpi(grupo.id_teacher != null ? grupo.id_teacher : grupo.id_Teacher)
    }
    const alt =
      grupo.id_teacher_2 != null
        ? grupo.id_teacher_2
        : (grupo.id_Teacher_2 != null ? grupo.id_Teacher_2 : grupo.idTeacher2)
    return idNumKpi(alt)
  }

  const SABADO_NO_TEENS_POR_SEMANA_KPI = [
    [{ tf: 'id_teacher', s: 'lu1' }, { tf: 'id_teacher', s: 'ma1' }, { tf: 'id_teacher', s: 'mi1' }, { tf: 'id_teacher_2', s: 'ju1' }, { tf: 'id_teacher_2', s: 'vi1' }],
    [{ tf: 'id_teacher', s: 'lu2' }, { tf: 'id_teacher', s: 'ma2' }, { tf: 'id_teacher', s: 'mi2' }, { tf: 'id_teacher_2', s: 'ju2' }, { tf: 'id_teacher_2', s: 'vi2' }],
    [{ tf: 'id_teacher', s: 'lu3' }, { tf: 'id_teacher', s: 'ma3' }, { tf: 'id_teacher', s: 'mi3' }, { tf: 'id_teacher_2', s: 'ju3' }, { tf: 'id_teacher_2', s: 'vi3' }],
    [{ tf: 'id_teacher', s: 'lu4' }, { tf: 'id_teacher', s: 'ma4' }, { tf: 'id_teacher', s: 'mi4' }, { tf: 'id_teacher_2', s: 'ju4' }, { tf: 'id_teacher_2', s: 'vi4' }],
    [{ tf: 'id_teacher', s: 'lu5' }, { tf: 'id_teacher', s: 'ma5' }, { tf: 'id_teacher', s: 'mi5' }, { tf: 'id_teacher_2', s: 'ju5' }, { tf: 'id_teacher_2', s: 'vi5' }]
  ]

  const DOMINGO_NO_TEENS_KPI = [
    ['id_teacher', 'lu1'], ['id_teacher', 'ma1'], ['id_teacher', 'mi1'], ['id_teacher_2', 'ju1'], ['id_teacher_2', 'vi1'],
    ['id_teacher', 'lu2'], ['id_teacher_2', 'ju2'], ['id_teacher_2', 'ju3'], ['id_teacher', 'lu4'], ['id_teacher_2', 'ju4'],
    ['id_teacher', 'lu5'], ['id_teacher', 'ma5'], ['id_teacher', 'mi5'], ['id_teacher_2', 'ju5'], ['id_teacher_2', 'vi5']
  ]

  function construirChequeosOficialesKpi (grupo) {
    const checks = []
    const esTeens = /TEENS/.test(grupo.grupo || '')
    for (let sem = 1; sem <= 4; sem++) {
      if (grupo.lunes == 1) checks.push({ dia: 'lunes', tf: 'id_teacher', slot: `lu${sem}` })
      if (grupo.martes == 1) checks.push({ dia: 'martes', tf: 'id_teacher', slot: `ma${sem}` })
      if (grupo.miercoles == 1) checks.push({ dia: 'miercoles', tf: 'id_teacher', slot: `mi${sem}` })
      if (grupo.jueves == 1) checks.push({ dia: 'jueves', tf: 'id_teacher_2', slot: `ju${sem}` })
      if (grupo.viernes == 1) checks.push({ dia: 'viernes', tf: 'id_teacher_2', slot: `vi${sem}` })
    }
    if (grupo.sabado == 1) {
      if (esTeens) {
        for (let sem = 1; sem <= 4; sem++) {
          checks.push({ dia: 'sabado', tf: 'id_teacher', slot: `lu${sem}` })
          checks.push({ dia: 'sabado', tf: 'id_teacher', slot: `ma${sem}` })
        }
        checks.push({ dia: 'sabado', tf: 'id_teacher_2', slot: 'ju5' })
        checks.push({ dia: 'sabado', tf: 'id_teacher_2', slot: 'vi5' })
      } else {
        for (const slots of SABADO_NO_TEENS_POR_SEMANA_KPI) {
          for (const { tf, s } of slots) checks.push({ dia: 'sabado', tf, slot: s })
        }
      }
    }
    if (grupo.domingo == 1) {
      if (esTeens) {
        for (let sem = 1; sem <= 4; sem++) {
          checks.push({ dia: 'domingo', tf: 'id_teacher', slot: `lu${sem}` })
          checks.push({ dia: 'domingo', tf: 'id_teacher', slot: `ma${sem}` })
        }
      } else {
        for (const [tf, s] of DOMINGO_NO_TEENS_KPI) checks.push({ dia: 'domingo', tf, slot: s })
      }
    }
    return checks
  }

  function semanaDesdeSlotKpi (slot) {
    const m = String(slot).match(/(\d+)$/)
    return m ? Number(m[1]) : null
  }

  function agruparChequeosSabDomNoTeensKpi (grupo, checks) {
    const esTeens = /TEENS/.test(grupo.grupo || '')
    if (esTeens) return checks.map((c) => ({ modo: 'single', ...c }))
    const buckets = {}
    const resultado = []
    for (const c of checks) {
      if (c.dia !== 'sabado' && c.dia !== 'domingo') {
        resultado.push({ modo: 'single', ...c })
        continue
      }
      const w = semanaDesdeSlotKpi(c.slot)
      if (!w) {
        resultado.push({ modo: 'single', ...c })
        continue
      }
      const s = String(c.slot).toLowerCase()
      let kind = null
      if (/^lu\d+$|^ma\d+$|^mi\d+$/.test(s)) kind = 'lmm'
      else if (/^ju\d+$|^vi\d+$/.test(s)) kind = 'jv'
      else {
        resultado.push({ modo: 'single', ...c })
        continue
      }
      const key = `${c.dia}|${w}|${kind}`
      if (!buckets[key]) buckets[key] = []
      buckets[key].push(c)
    }
    for (const key of Object.keys(buckets)) {
      const arr = buckets[key]
      const [dia, weekStr, kind] = key.split('|')
      const tf = kind === 'lmm' ? 'id_teacher' : 'id_teacher_2'
      if (arr.length >= 2) {
        resultado.push({ modo: 'grupo', dia, semana: Number(weekStr), kind, tf, slots: arr.map((x) => x.slot) })
      } else {
        arr.forEach((c) => resultado.push({ modo: 'single', ...c }))
      }
    }
    return resultado
  }

  export default {

    components:{
      Alerta,
      carga,
      JefeRecursos,
      JefeComercial,
      JefeFinanzas,
      JefeTI,
      JefeOperaciones,
      JefeOperacionesClases,
    },

    mixins: [ validarErrores, funcionesExcel ],

    data: () => ({
      // Alertas
      parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

      respuestaAlerta:false,
      loader: true,
      cargar: false,


			ciclos:[],
      cicloInf:null,
      cicloSup:null,

      dialogAlumnos:false,

      headers: [
        { text: 'Vendedora'    , value: 'vendedora'  },
        { text: 'I completo'   , value: 'completos'  },
      ],

      vacantes_requeridos:[],
      dialogRequeridos: false,
      /** Contexto al abrir «Detalles de los requeridos» desde las cards de RH (% ocupación). */
      rhDialogMeta: null,

      headersRequeridos:[
        { text: 'Puesto',       value: 'puesto'  },
        { text: 'Autorizados',  value: 'autorizados' },
        { text: 'Activos',      value: 'activos'   },
        { text: 'Vacantes',     value: 'vacantes'   },
        { text: '% Ocupación',  value: 'percent_ocupacion', align: 'end' },
      ],

      desserts: [],

      fechaini:(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      fechafin:(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      totalInbi:0,
      totalFast:0,

      headers2: [
        { text: 'Vendedora'       , value: 'nombre_completo'       },
        { text: 'Mat. Nvas. Liq.' , value: 'matriculas_liquidadas' },
      ],

      ciclo: null,

      rh: { },
      totalFast: 0,
			totalInbi: 0,
			totalFastM: 0,
			totalInbiM: 0,

			dialogRh:{
				estatus: false
			},
			dialogComercial:{
				estatus: false
			},
			dialogFinanzas:{
				estatus: false
			},
			dialogTI:{
				estatus: false
			},

      dialogOperacionesClases:{
        estatus: false,
        escuela: '',
        escuelaLabel: '',
        detalle: null
      },
			rhAuxi:{},

			totalFastRI: 1.3,
			totalInbiRI: 1.8,

			dialogOperaciones:{
				estatus: false
			},

      prospectosInbi: [],
      prospectosFast: [],

      rhOcupacionInbi: { percent_ocupacion: 0, desglose: [] },
      rhOcupacionFast: { percent_ocupacion: 0, desglose: [] },
      rhOcupacionCorpo: { percent_ocupacion: 0, desglose: [] },
      rhOcupacionTodo: { percent_ocupacion: 0, desglose: [] },
      ti: {
        total_tickets: 0,
        tickets_resueltos: 0,
        tickets_pendientes: 0,
        tickets_cerrados: 0,
        tickets_abiertos: 0,
        sla_objetivo: 0,
        tiempo_promedio_resolucion: 0,
        componentes: null,
        periodo: null,
        kpi_ti: null
      },
      mantenimiento: {
        total_tickets: 0,
        tickets_resueltos: 0,
        tickets_pendientes: 0,
        tickets_cerrados: 0,
        tickets_abiertos: 0,
        sla_objetivo: 0,
        tiempo_promedio_resolucion: 0,
        componentes: null,
        periodo: null,
        kpi_mantenimiento: null
      },
      finanzas: {
        egresoInbi: 0,
        egresoFast: 0,
        ingresoValidadoInbi: 0,
        ingresoValidadoFast: 0,
        ingresoDetalleInbi: null,
        ingresoDetalleFast: null,
        finanzas_historial: [],
        totalValidadoInbi: null,
        sumaEgresoInbi: null,
        totalValidadoFast: null,
        sumaEgresoFast: null,
        sumaIngresosValidadosInbi: null,
        sumaIngresoInbi: null,
        sumaIngresosValidadosFast: null,
        sumaIngresoFast: null
      },
      diasTranscurridosInbi: 0,
      diasTranscurridosFast: 0,
      metamoney: { avance_fast: 0, avance_inbi: 0, faltante_fast: 0, faltante_inbi: 0 },
      comercialConversion: {
        conversionInbi: 0,
        conversionFast: 0,
        inscritos_fast: null,
        inscritos_inbi: null
      },
      controlInterno: { inbi: 0, fast: 0 },

      dialogOcupacionRh:{
        estatus: false
      },

      // Sección de operaciones
      dataTablaFastUno:[],
      dataTablaInbiUno:[],
      dataTablaFastDos:[],
      ciclo: null,
      id_ciclo: null,
      id_ciclo_relacionado: null,
      metas: [],
      resultadoRi: null,
      resultadoRiFiltro: [],
      clasesInbiHoy: [],
      clasesFastHoy: [],
      clasesInbiCorrectas: 0,
      clasesInbiTotal: 0,
      clasesFastCorrectas: 0,
      clasesFastTotal: 0,
      vacantesExcelRH:[],
      clases:{
        porcentaje_correcto_fast: 0,
        porcentaje_correcto_inbi: 0
      },
      clasesComparativaSemanal: {
        fast: { 1: 0, 2: 0, 3: 0, 4: 0 },
        inbi: { 1: 0, 2: 0, 3: 0, 4: 0 }
      },
      clasesDesgloseEscuela: {
        fast: null,
        inbi: null
      },
      /** Fija en 3: solo bloques lu3…vi3 para el KPI (tarjeta y fila «Actual»). */
      operacionesClasesSemanaActual: 2,

      // Dialog comparativa acumulado por semana (semanas en columnas, conceptos en filas)
      dialogComparativa: {
        estatus: false,
        departamento: '',
        ciclo: null
      },
      dialogComparativaInfo: false,
      dialogFormulaInfo: {
        estatus: false,
        titulo: '',
        items: []
      },
      dialogIngresoFinanzas: {
        estatus: false,
        escuela: '',
        detalle: null
      },
      dialogEgresoFinanzas: {
        estatus: false,
        escuela: '',
        detalle: null
      },
      dialogDiasFinanzas: {
        estatus: false,
        escuela: '',
        detalle: null
      },
      dialogReporteFinanzas: {
        estatus: false,
        cargando: false,
        tab: 0
      },
      reporteFinanzas: {
        egresos: {
          fast: { detalle: [], totales: {} },
          inbi: { detalle: [], totales: {} }
        },
        ingresos: {
          fast: { detalle: [], totales: {} },
          inbi: { detalle: [], totales: {} }
        }
      },
      numSemanasComparativa: 5,

      // Historiales
      historialRh:[],
      historialComercial:[],
      historialComercialConversion:[],
      historialTI:[],
      historialMantenimiento:[],
      historialControlInterno:[],
      historialOperacionesNI: [],
      /** Semanal % RI (fast/inbi vs meta); viene en la respuesta de kpi.cantactual */
      historialInscripciones: [],
      historialMetaMoney:[],
      cardsVisibles: {
        operacionesNI: false,
        operacionesRI: false,
        operacionesMoney: false,
        rhOcupacion: false,
        comercialConversion: false,
        tiTickets: false,
        finanzasEgreso: false,
        operacionesClases: false,
        controlInternoVentas: false,
        mantenimientoTickets: false,
      },
      kpiLoaders: {
        operacionesNI: false,
        operacionesRI: false,
        operacionesMoney: false,
        rhOcupacion: false,
        comercialConversion: false,
        tiTickets: false,
        finanzasEgreso: false,
        operacionesClases: false,
        controlInternoVentas: false,
        mantenimientoTickets: false,
      },
      historialOperacionesClases:[],
      movimientosRolSemana: [],
      clasesTotalesPorCiclo: {},
      clasesTotalesPorSemana: { id_ciclo: null, fast: { 1: 0, 2: 0, 3: 0, 4: 0 }, inbi: { 1: 0, 2: 0, 3: 0, 4: 0 } },
      niFastMarkers: [
        { value: 1.54, color: '#1e88e5' },
        { value: 17.14, color: '#43a047' },
        { value: 39.01, color: '#fdd835' },
        { value: 72.31, color: '#fb8c00' },
        { value: 100, color: '#e53935' }
      ],
      niInbiMarkers: [
        { value: 1.81, color: '#8e24aa' },
        { value: 17.41, color: '#00897b' },
        { value: 39.88, color: '#7cb342' },
        { value: 72.97, color: '#f4511e' },
        { value: 100, color: '#3949ab' }
      ],
      /** RI: índice 1-based de la marca objetivo (1…5 sobre 10, 80, 85, 90, 93). */
      riMarcaObjetivo: 3,
    }),

    computed: {
      ...mapGetters('login', ['getdatosUsuarioERPERP', 'getLogeado', 'getEscuela','drawer2','getEstatusLlamada','getNuevosProspectos']),

      comparativaTieneFormulaInfo () {
        return Boolean(
          this.comparativaKpiTicketsFormula ||
          this.comparativaComercialFormula ||
          (this.comparativaFinanzasFormula && this.mostrarDesgloseFinanzasComparativa) ||
          (this.comparativaOperacionesMoneyFormula && this.mostrarDesgloseOperacionesMoneyComparativa) ||
          this.comparativaOperacionesClasesFormula
        )
      },

      kpiUsuarioAccesoTotal () {
        return kpiUsuarioTieneAccesoTotal(this.getdatosUsuarioERPERP)
      },

      /** null si no hay idpuesto en sesión (compatibilidad: se trata como acceso completo). */
      kpiIdPuestoNum () {
        const u = this.getdatosUsuarioERPERP
        if (!u || u.idpuesto == null || u.idpuesto === '') return null
        const n = Number(u.idpuesto)
        return isNaN(n) ? null : n
      },

      /** Jefe TI, desarrollador de software, director general y jefe de control interno ven todo. Sin idpuesto: todo (legacy). */
      kpiVeTodoDashboard () {
        if (this.kpiUsuarioAccesoTotal) return true
        const id = this.kpiIdPuestoNum
        if (id == null) return true
        return KPI_PUESTO_VER_TODO.indexOf(id) !== -1
      },

      kpiAreas () {
        if (this.kpiVeTodoDashboard) return kpiAreasTodas()
        const id = this.kpiIdPuestoNum
        const vacias = kpiAreasVacias()
        if (id == null) return kpiAreasTodas()
        const lista = KPI_AREA_POR_PUESTO[id]
        if (!lista || !lista.length) return vacias
        const out = Object.assign({}, vacias)
        for (let i = 0; i < lista.length; i++) {
          out[lista[i]] = true
        }
        return out
      },

      kpiDashboardSinKpiAsignado () {
        if (this.kpiVeTodoDashboard) return false
        const a = this.kpiAreas
        return !(
          a.operaciones ||
          a.rh ||
          a.comercial ||
          a.finanzas ||
          a.ti ||
          a.mantenimiento ||
          a.controlInterno
        )
      },

      /** Totales de la tabla de desglose RH (suma por puesto); el % coincide con la tarjeta si los datos son consistentes. */
      rhRequeridosTotales () {
        const rows = this.vacantes_requeridos || []
        const t = rows.reduce((acc, r) => ({
          autorizados: acc.autorizados + Number(r.autorizados || 0),
          activos: acc.activos + Number(r.activos || 0),
          vacantes: acc.vacantes + Number(r.vacantes || 0)
        }), { autorizados: 0, activos: 0, vacantes: 0 })
        const pct = t.autorizados > 0
          ? ((t.activos / t.autorizados) * 100).toFixed(2)
          : '0.00'
        return { ...t, percent_ocupacion: pct }
      },

      mostrarControlCardsKpi () {
        const u = this.getdatosUsuarioERPERP || {}
        const id = Number(u.iderp)
        return [334, 3042].includes(id)
      },

      comparativaEsPorcentaje(){
        const dep = this.dialogComparativa && this.dialogComparativa.departamento
        return dep !== 'Comercial' && dep !== 'Op. Inscritos NI'
      },

      ciclosComparativaMetamoney(){
        return [...new Set(
          (this.historialMetaMoney || [])
            .map(row => row && row.nombre_ciclo_base ? row.nombre_ciclo_base : null)
            .filter(Boolean)
        )]
      },

      ciclosComparativaOperacionesNI(){
        return [...new Set(
          (this.historialOperacionesNI || [])
            .map(row => row && (row.nombre_ciclo_base || row.ciclo || row.nombre_ciclo) ? (row.nombre_ciclo_base || row.ciclo || row.nombre_ciclo) : null)
            .filter(Boolean)
        )]
      },

      ciclosComparativaOperacionesRI(){
        return [...new Set(
          (this.historialInscripciones || [])
            .map(row => row && row.ciclo ? String(row.ciclo) : null)
            .filter(Boolean)
        )]
      },

      ciclosComparativaComercial(){
        const set = new Set()
        for (const row of this.historialComercial || []) {
          const ciclo = row && (row.nombre_ciclo_base || row.ciclo || row.nombre_ciclo)
          if (ciclo != null && ciclo !== '') set.add(String(ciclo))
        }
        return [...set]
      },

      ciclosComparativaOperacionesClases () {
        const set = new Set()
        for (const row of this.historialOperacionesClases || []) {
          if (row && row.ciclo != null && row.ciclo !== '') set.add(String(row.ciclo))
        }
        if (this.ciclo && typeof this.ciclo === 'object' && this.ciclo.ciclo != null && this.ciclo.ciclo !== '') {
          set.add(String(this.ciclo.ciclo))
        } else if (typeof this.ciclo === 'string' && this.ciclo) {
          set.add(this.ciclo)
        }
        return [...set].sort((a, b) => a.localeCompare(b))
      },

      headersComparativa(){
        if (!this.dialogComparativa) return [{ text: 'Semana', value: 'semana', align: 'left' }]
        const dep = this.dialogComparativa.departamento
        const data = (this.comparativaData || {})[dep]
        if (!data) return [{ text: 'Semana', value: 'semana', align: 'left' }]
        if (data._operacionesNIDynamic || data._metamoneyDynamic || data._operacionesRIDynamic) {
          if (data._operacionesRIDynamic) {
            return [
              { text: 'Periodo', value: 'periodo', align: 'left', sortable: false },
              { text: 'Ciclo', value: 'ciclo', align: 'left', sortable: false },
              { text: 'Semana', value: 'semana', align: 'left', sortable: false },
              { text: 'Inbi', value: 'c0', align: 'center', sortable: false },
              { text: 'Meta Inbi', value: 'c1', align: 'center', sortable: false },
              { text: 'Diferencia Inbi', value: 'c2', align: 'center', sortable: false },
              { text: 'Fast', value: 'c3', align: 'center', sortable: false },
              { text: 'Meta Fast', value: 'c4', align: 'center', sortable: false },
              { text: 'Diferencia Fast', value: 'c5', align: 'center', sortable: false }
            ]
          }
          if (data._operacionesNIDynamic) {
            return [
              { text: 'Periodo', value: 'periodo', align: 'left', sortable: false },
              { text: 'Ciclo', value: 'ciclo', align: 'left', sortable: false },
              { text: 'Semana', value: 'semana', align: 'left', sortable: false },
              { text: 'Inbi', value: 'c0', align: 'center', sortable: false },
              { text: 'Meta Inbi', value: 'c2', align: 'center', sortable: false },
              { text: 'Diferencia Inbi', value: 'c3', align: 'center', sortable: false },
              { text: 'Fast', value: 'c4', align: 'center', sortable: false },
              { text: 'Meta Fast', value: 'c6', align: 'center', sortable: false },
              { text: 'Diferencia Fast', value: 'c7', align: 'center', sortable: false }
            ]
          }
          if (data._metamoneyDynamic) {
            return [
              { text: 'Periodo', value: 'periodo', align: 'left', sortable: false },
              { text: 'Ciclo', value: 'ciclo', align: 'left', sortable: false },
              { text: 'Semana', value: 'semana', align: 'left', sortable: false },
              { text: 'Inbi', value: 'c0', align: 'center', sortable: false },
              { text: 'Meta Inbi', value: 'c1', align: 'center', sortable: false },
              { text: 'Diferencia Inbi', value: 'c2', align: 'center', sortable: false },
              { text: 'Fast', value: 'c3', align: 'center', sortable: false },
              { text: 'Meta Fast', value: 'c4', align: 'center', sortable: false },
              { text: 'Diferencia Fast', value: 'c5', align: 'center', sortable: false }
            ]
          }
          return [
            { text: 'Semana', value: 'semana', align: 'left', sortable: false },
            { text: 'Ciclo', value: 'ciclo', align: 'left', sortable: false },
            { text: 'Fast', value: 'c0', align: 'center', sortable: false },
            { text: 'Inbi', value: 'c1', align: 'center', sortable: false }
          ]
        }
        if (data._rhDynamic) {
          return [
            { text: 'Semana', value: 'semana', align: 'left' },
            { text: 'Inbi', value: 'c0', align: 'center', sortable: false },
            { text: 'Meta Inbi', value: 'c1', align: 'center', sortable: false },
            { text: 'Diferencia', value: 'c2', align: 'center', sortable: false },
            { text: 'Fast', value: 'c3', align: 'center', sortable: false },
            { text: 'Meta Fast', value: 'c4', align: 'center', sortable: false },
            { text: 'Diferencia Fast', value: 'c5', align: 'center', sortable: false },
            { text: 'Corporativo', value: 'c6', align: 'center', sortable: false },
            { text: 'Meta Corpo', value: 'c7', align: 'center', sortable: false },
            { text: 'Diferencia', value: 'c8', align: 'center', sortable: false },
            { text: 'General', value: 'c9', align: 'center', sortable: false },
            { text: 'Meta General', value: 'c10', align: 'center', sortable: false },
            { text: 'Diferencia', value: 'c11', align: 'center', sortable: false }
          ]
        }
        if (data._comercialDynamic) {
          return [
            { text: 'Periodo', value: 'periodo', align: 'left' },
            { text: 'Ciclo', value: 'ciclo', align: 'left', sortable: false },
            { text: 'Semana', value: 'semana', align: 'left' },
            { text: 'Inbi', value: 'c0', align: 'center', sortable: false },
            { text: 'Meta Inbi', value: 'c1', align: 'center', sortable: false },
            { text: 'Diferencia Inbi', value: 'c2', align: 'center', sortable: false },
            { text: 'Inbi Conversión', value: 'c3', align: 'center', sortable: false },
            { text: 'Meta Inbi Conversión', value: 'c4', align: 'center', sortable: false },
            { text: 'Diferencia Inbi Conversión', value: 'c5', align: 'center', sortable: false },
            { text: 'Fast', value: 'c6', align: 'center', sortable: false },
            { text: 'Meta Fast', value: 'c7', align: 'center', sortable: false },
            { text: 'Diferencia Fast', value: 'c8', align: 'center', sortable: false },
            { text: 'Fast Conversión', value: 'c9', align: 'center', sortable: false },
            { text: 'Meta Fast Conversión', value: 'c10', align: 'center', sortable: false },
            { text: 'Diferencia Fast Conversión', value: 'c11', align: 'center', sortable: false }
          ]
        }
        if (data._operacionesClasesDynamic) {
          return [
            { text: 'Periodo', value: 'periodo', align: 'left', sortable: false },
            { text: 'Ciclo', value: 'ciclo', align: 'left', sortable: false },
            { text: 'Semana', value: 'semana', align: 'left', sortable: false },
            { text: 'Inbi', value: 'c0', align: 'center', sortable: false },
            { text: 'Meta Inbi', value: 'c1', align: 'center', sortable: false },
            { text: 'Diferencia Inbi', value: 'c2', align: 'center', sortable: false },
            { text: '% cumplimiento Inbi', value: 'c3', align: 'center', sortable: false },
            { text: 'Fast', value: 'c4', align: 'center', sortable: false },
            { text: 'Meta Fast', value: 'c5', align: 'center', sortable: false },
            { text: 'Diferencia Fast', value: 'c6', align: 'center', sortable: false },
            { text: '% cumplimiento Fast', value: 'c7', align: 'center', sortable: false }
          ]
        }
        if (data._controlInternoDynamic) {
          return [
            { text: 'Semana', value: 'semana', align: 'left' },
            { text: 'Inbi', value: 'c0', align: 'center', sortable: false },
            { text: 'Meta Inbi', value: 'c1', align: 'center', sortable: false },
            { text: 'Diferencia Inbi', value: 'c2', align: 'center', sortable: false },
            { text: 'Fast', value: 'c3', align: 'center', sortable: false },
            { text: 'Meta Fast', value: 'c4', align: 'center', sortable: false },
            { text: 'Diferencia Fast', value: 'c5', align: 'center', sortable: false }
          ]
        }
        if (data._comercialConversionDynamic) {
          return [
            { text: 'Semana', value: 'semana', align: 'left' },
            { text: 'Fast', value: 'c0', align: 'center', sortable: false },
            { text: 'Inbi', value: 'c1', align: 'center', sortable: false }
          ]
        }
        if (data._finanzasDynamic) {
          return [
            { text: 'Semana', value: 'semana', align: 'left' },
            { text: 'Inbi Ingresos', value: 'c0', align: 'center', sortable: false },
            { text: 'Meta Inbi Ingresos', value: 'c1', align: 'center', sortable: false },
            { text: 'Diferencia Inbi Ingresos', value: 'c2', align: 'center', sortable: false },
            { text: 'Inbi Egresos', value: 'c3', align: 'center', sortable: false },
            { text: 'Meta Inbi Egresos', value: 'c4', align: 'center', sortable: false },
            { text: 'Diferencia Inbi Egresos', value: 'c5', align: 'center', sortable: false },
            { text: 'Fast Ingresos', value: 'c6', align: 'center', sortable: false },
            { text: 'Meta Fast Ingresos', value: 'c7', align: 'center', sortable: false },
            { text: 'Diferencia Fast Ingresos', value: 'c8', align: 'center', sortable: false },
            { text: 'Fast Egresos', value: 'c9', align: 'center', sortable: false },
            { text: 'Meta Fast Egresos', value: 'c10', align: 'center', sortable: false },
            { text: 'Diferencia Fast Egresos', value: 'c11', align: 'center', sortable: false }
          ]
        }
        if (data._tiDynamic || data._mantenimientoDynamic) {
          return [
            { text: 'Semana', value: 'semana', align: 'left' },
            { text: 'IUA (KPI)', value: 'c0', align: 'center', sortable: false },
            { text: 'Meta', value: 'c1', align: 'center', sortable: false },
            { text: 'Diferencia', value: 'c2', align: 'center', sortable: false }
          ]
        }
        if (!data.length) return [{ text: 'Semana', value: 'semana', align: 'left' }]
        const arr = [ { text: 'Semana', value: 'semana', align: 'left' } ]
        data.forEach((item, i) => {
          arr.push({ text: item.concepto, value: 'c' + i, align: 'center', sortable: false })
        })
        return arr
      },

      comparativaTableItems(){
        if (!this.dialogComparativa) return []
        const dep = this.dialogComparativa.departamento
        const data = (this.comparativaData || {})[dep]
        if (!data) return []
        if (data._rhDynamic || data._comercialDynamic || data._comercialConversionDynamic || data._finanzasDynamic || data._tiDynamic || data._mantenimientoDynamic || data._controlInternoDynamic || data._operacionesNIDynamic || data._operacionesRIDynamic || data._metamoneyDynamic || data._operacionesClasesDynamic) {
          let semanas = data.semanas || []
          let tendencias = data.tendencias || []
          const { fields, cicloField } = data
          if ((data._metamoneyDynamic || data._operacionesNIDynamic || data._operacionesRIDynamic || data._operacionesClasesDynamic || data._comercialDynamic) && cicloField && this.dialogComparativa.ciclo) {
            const filtradas = []
            const tendenciasFiltradas = []
            semanas.forEach((sem, idx) => {
              if (sem[cicloField] === this.dialogComparativa.ciclo) {
                filtradas.push(sem)
                tendenciasFiltradas.push(tendencias[idx])
              }
            })
            semanas = filtradas
            tendencias = tendenciasFiltradas
          }
          const esTablaSemanaTrasCiclo =
            (data._operacionesNIDynamic ||
              data._operacionesRIDynamic ||
              data._metamoneyDynamic ||
              data._operacionesClasesDynamic ||
              data._comercialDynamic) === true
          return semanas.map((sem, idx) => {
            const row = {}
            if (esTablaSemanaTrasCiclo) {
              row.periodo = sem.label != null && sem.label !== '' ? sem.label : '—'
              const rawSem =
                sem.semana != null && sem.semana !== ''
                  ? sem.semana
                  : sem.numSemana != null && sem.numSemana !== ''
                    ? sem.numSemana
                    : null
              row.semana = rawSem != null && rawSem !== '' ? String(rawSem) : '—'
            } else {
              row.semana = sem.label
            }
            if (sem.fechaPeriodo != null && sem.fechaPeriodo !== '') row.fechaPeriodo = sem.fechaPeriodo
            if (cicloField) row.ciclo = sem[cicloField]
            if (sem.numSemana != null && sem.numSemana !== '') row.numSemana = sem.numSemana
            if (sem.ciclo != null && sem.ciclo !== '' && row.ciclo == null) row.ciclo = sem.ciclo
            if (sem._esFilaActualRI) row._esFilaActualRI = true
            fields.forEach((f, i) => {
              const val = sem[f] != null ? parseFloat(sem[f]) : null
              row['c' + i] = { val, trend: tendencias[idx] ? tendencias[idx][f] : null }
            })
            if (data._metamoneyDynamic && data._metamoneyFull) {
              const metaI = sem.metaInbi != null ? parseFloat(sem.metaInbi) : null
              const metaF = sem.metaFast != null ? parseFloat(sem.metaFast) : null
              const pctI = sem.inbi != null ? parseFloat(sem.inbi) : null
              const pctF = sem.fast != null ? parseFloat(sem.fast) : null
            }
            return row
          })
        }
        if (!data.length) return []
        const items = []
        for (let w = 1; w <= this.numSemanasComparativa; w++) {
          const row = { semana: 'Semana ' + w }
          data.forEach((item, i) => {
            const val = item['semana' + w]
            row['c' + i] = (val != null ? val : 0) + (item.unidad || '')
          })
          items.push(row)
        }
        return items
      },

      /** Texto de fórmula IUA con valores del back (comparativa TI / Mantenimiento). */
      comparativaKpiTicketsFormula () {
        const dep = this.dialogComparativa && this.dialogComparativa.departamento
        if (dep !== 'TI' && dep !== 'Mantenimiento') return null
        const src = dep === 'TI' ? this.ti : this.mantenimiento
        if (!src) return null
        const tt = src.total_tickets != null && src.total_tickets !== '' ? Number(src.total_tickets) : NaN
        const tr = src.tickets_resueltos != null && src.tickets_resueltos !== ''
          ? Number(src.tickets_resueltos)
          : (src.tickets_cerrados != null && src.tickets_cerrados !== '' ? Number(src.tickets_cerrados) : NaN)
        const tp = src.tickets_pendientes != null && src.tickets_pendientes !== ''
          ? Number(src.tickets_pendientes)
          : (src.tickets_abiertos != null && src.tickets_abiertos !== '' ? Number(src.tickets_abiertos) : NaN)
        const tc = src.tickets_cerrados != null && src.tickets_cerrados !== '' ? Number(src.tickets_cerrados) : NaN
        const ta = tp
        const sla = src.sla_objetivo != null && src.sla_objetivo !== '' ? Number(src.sla_objetivo) : NaN
        const tpr = src.tiempo_promedio_resolucion != null && src.tiempo_promedio_resolucion !== ''
          ? Number(src.tiempo_promedio_resolucion)
          : NaN
        const comp = src.componentes || {}
        let res = comp.resolucion != null ? Number(comp.resolucion) : null
        let vel = comp.velocidad != null ? Number(comp.velocidad) : null
        let back = comp.control_backlog != null ? Number(comp.control_backlog) : null
        if ((res == null || isNaN(res)) && !isNaN(tt) && tt > 0 && !isNaN(tr)) res = (tr / tt) * 100
        if ((vel == null || isNaN(vel)) && !isNaN(sla) && sla > 0) {
          if (!isNaN(tpr) && tpr > 0) {
            vel = Math.min(100, (sla / tpr) * 100)
          } else if (!isNaN(tc) && tc > 0) {
            vel = 100
          } else {
            vel = 0
          }
        }
        if ((back == null || isNaN(back)) && !isNaN(tt) && tt > 0 && !isNaN(tp)) back = (1 - tp / tt) * 100
        let kpi = null
        if (dep === 'TI') {
          kpi = src.kpi_ti != null ? Number(src.kpi_ti) : (src.porcentaje_resueltos != null ? Number(src.porcentaje_resueltos) : null)
        } else {
          kpi = src.kpi_mantenimiento != null ? Number(src.kpi_mantenimiento) : (src.porcentaje_resueltos != null ? Number(src.porcentaje_resueltos) : null)
        }
        const iuaCalc = res != null && vel != null && back != null &&
          !isNaN(res) && !isNaN(vel) && !isNaN(back)
          ? res * 0.5 + vel * 0.3 + back * 0.2
          : null
        const fmt = (n) => (n != null && typeof n === 'number' && !isNaN(n) ? n.toFixed(2) : '—')
        const tprFmt = !isNaN(tpr) ? Number(tpr).toFixed(3) : '—'
        const periodo = src.periodo || null
        const periodoFmt = periodo && periodo.desde_primer_ticket_activo && periodo.fecha_inicio
          ? `desde ${periodo.fecha_inicio} (1.er ticket activo) hasta ${periodo.fecha_fin || '—'}`
          : (periodo && periodo.fecha_inicio && periodo.fecha_fin
            ? (periodo.fecha_inicio === periodo.fecha_fin
              ? periodo.fecha_inicio
              : `${periodo.fecha_inicio} al ${periodo.fecha_fin}`)
            : null)
        return {
          dep,
          etiqueta: dep === 'TI' ? 'TI' : 'Mantenimiento',
          tt: !isNaN(tt) ? tt : '—',
          tr: !isNaN(tr) ? tr : '—',
          tp: !isNaN(tp) ? tp : '—',
          tc: !isNaN(tc) ? tc : '—',
          ta: !isNaN(ta) ? ta : '—',
          sla: !isNaN(sla) ? sla : '—',
          tpr,
          res,
          vel,
          back,
          resFmt: fmt(res),
          velFmt: fmt(vel),
          backFmt: fmt(back),
          kpi,
          kpiFmt: fmt(kpi),
          iuaCalc,
          iuaCalcFmt: fmt(iuaCalc),
          tprFmt,
          periodoFmt
        }
      },

      /** Semáforo TI según IUA en la card: menor a 80 rojo, 80–94 amarillo, mayor a 94 verde. */
      tiSemaforoEstado () {
        return this.getSemaforoEstado(this.ti && this.ti.kpi_ti)
      },

      /** Mismo criterio que TI para la card Mantenimiento. */
      mantenimientoSemaforoEstado () {
        return this.getSemaforoEstado(this.mantenimiento && this.mantenimiento.kpi_mantenimiento)
      },

      /** Fórmulas Comercial / Comercial - Conversión con valores actuales (prospectos + conversión del back). */
      comparativaComercialFormula () {
        const dep = this.dialogComparativa && this.dialogComparativa.departamento
        if (dep !== 'Comercial' && dep !== 'Comercial - Conversión') return null
        const pf = (this.prospectosFast || []).length
        const pi = (this.prospectosInbi || []).length
        const c = this.comercialConversion || {}
        const cf = c.conversionFast != null && c.conversionFast !== '' ? Number(c.conversionFast) : null
        const ci = c.conversionInbi != null && c.conversionInbi !== '' ? Number(c.conversionInbi) : null
        const rawIf = c.inscritos_fast != null ? c.inscritos_fast : c.inscritosFast
        const rawIi = c.inscritos_inbi != null ? c.inscritos_inbi : c.inscritosInbi
        const inscF = rawIf != null && rawIf !== '' ? Number(rawIf) : null
        const inscI = rawIi != null && rawIi !== '' ? Number(rawIi) : null
        const inscritosFastDesdeBack = inscF != null && !isNaN(inscF)
        const inscritosInbiDesdeBack = inscI != null && !isNaN(inscI)
        const estF = !inscritosFastDesdeBack && pf > 0 && cf != null && !isNaN(cf) ? (cf / 100) * pf : null
        const estI = !inscritosInbiDesdeBack && pi > 0 && ci != null && !isNaN(ci) ? (ci / 100) * pi : null
        const fmtPct = (n) => (n != null && typeof n === 'number' && !isNaN(n) ? n.toFixed(2) : '—')
        const fmtNum = (n) => {
          if (n == null || isNaN(n)) return '—'
          const x = Math.round(n * 100) / 100
          return Number.isInteger(x) ? String(x) : x.toFixed(2)
        }
        const inscritosFastFmt = inscritosFastDesdeBack
          ? fmtNum(inscF)
          : (estF != null ? fmtNum(estF) : '—')
        const inscritosInbiFmt = inscritosInbiDesdeBack
          ? fmtNum(inscI)
          : (estI != null ? fmtNum(estI) : '—')
        return {
          dep,
          modo: dep === 'Comercial' ? 'full' : 'soloConversion',
          prospectosFast: pf,
          prospectosInbi: pi,
          convFastFmt: fmtPct(cf),
          convInbiFmt: fmtPct(ci),
          inscritosFastFmt,
          inscritosInbiFmt,
          inscritosFastDesdeBack,
          inscritosInbiDesdeBack,
          tieneProspectosFast: pf > 0,
          tieneProspectosInbi: pi > 0
        }
      },

      /** Solo estos iderp ven el desglose de fórmula en la comparativa de Finanzas. */
      mostrarDesgloseFinanzasComparativa () {
        if (this.kpiUsuarioAccesoTotal) return true
        const id = Number((this.getdatosUsuarioERPERP && this.getdatosUsuarioERPERP.iderp) || 0)
        return [1, 334, 28].includes(id)
      },
      puedeVerMontosFinanzas () {
        if (this.kpiUsuarioAccesoTotal) return true
        const id = Number((this.getdatosUsuarioERPERP && this.getdatosUsuarioERPERP.iderp) || 0)
        return [1, 28, 334].includes(id)
      },

      /** Desglose Finanzas: % ingresos/egresos validados con montos del back (kpi.finanzas). */
      comparativaFinanzasFormula () {
        const dep = this.dialogComparativa && this.dialogComparativa.departamento
        if (dep !== 'Finanzas') return null
        const f = this.finanzas || {}
        const fmt = (n) => {
          if (n == null || n === '') return '—'
          const x = Number(n)
          if (isNaN(x)) return '—'
          return x.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        }
        const pct = (num, den) => {
          const a = Number(num)
          const b = Number(den)
          if (isNaN(a) || isNaN(b) || b === 0) return null
          return ((a / b) * 100).toFixed(2)
        }
        const kpiStr = (v) => {
          if (v == null || v === '') return '—'
          if (typeof v === 'string' && String(v).trim().includes('%')) return String(v).trim()
          const n = parseFloat(String(v).replace('%', '').replace(',', '.'))
          return isNaN(n) ? String(v) : `${n.toFixed(2)}%`
        }
        const hasAny =
          f.sumaIngresoFast != null ||
          f.sumaIngresoInbi != null ||
          f.sumaEgresoFast != null ||
          f.sumaEgresoInbi != null
        if (!hasAny) return null
        return {
          sumaIngresosValidadosFast: fmt(f.sumaIngresosValidadosFast),
          sumaIngresoFast: fmt(f.sumaIngresoFast),
          sumaIngresosValidadosInbi: fmt(f.sumaIngresosValidadosInbi),
          sumaIngresoInbi: fmt(f.sumaIngresoInbi),
          totalValidadoFast: fmt(f.totalValidadoFast),
          sumaEgresoFast: fmt(f.sumaEgresoFast),
          totalValidadoInbi: fmt(f.totalValidadoInbi),
          sumaEgresoInbi: fmt(f.sumaEgresoInbi),
          verifIngresoFast: pct(f.sumaIngresosValidadosFast, f.sumaIngresoFast),
          verifIngresoInbi: pct(f.sumaIngresosValidadosInbi, f.sumaIngresoInbi),
          verifEgresoFast: pct(f.totalValidadoFast, f.sumaEgresoFast),
          verifEgresoInbi: pct(f.totalValidadoInbi, f.sumaEgresoInbi),
          kpiIngresoFast: kpiStr(f.ingresoValidadoFast),
          kpiIngresoInbi: kpiStr(f.ingresoValidadoInbi),
          kpiEgresoFast: kpiStr(f.egresoFast),
          kpiEgresoInbi: kpiStr(f.egresoInbi)
        }
      },

      /** Solo estos iderp ven el desglose de fórmula en la comparativa Operaciones - $$. */
      mostrarDesgloseOperacionesMoneyComparativa () {
        if (this.kpiUsuarioAccesoTotal) return true
        const id = Number((this.getdatosUsuarioERPERP && this.getdatosUsuarioERPERP.iderp) || 0)
        return [1, 568, 334].includes(id)
      },

      /** Desglose Operaciones $$: avance y faltante con montos de kpi.metamoney. */
      comparativaOperacionesMoneyFormula () {
        const dep = this.dialogComparativa && this.dialogComparativa.departamento
        if (dep !== 'Operaciones - $$') return null
        const m = this.metamoney || {}
        const fmt = (n) => {
          if (n == null || n === '') return '—'
          const x = Number(n)
          if (isNaN(x)) return '—'
          return x.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        }
        const hasAny =
          m.sumaIngresoFast != null ||
          m.sumaIngresoInbi != null ||
          m.metaIngresoFast != null ||
          m.metaIngresoInbi != null
        if (!hasAny) return null

        const sumF = Number(m.sumaIngresoFast)
        const sumI = Number(m.sumaIngresoInbi)
        const metaF = Number(m.metaIngresoFast)
        const metaI = Number(m.metaIngresoInbi)
        const falF = m.faltanteMontoFast != null ? Number(m.faltanteMontoFast) : NaN
        const falI = m.faltanteMontoInbi != null ? Number(m.faltanteMontoInbi) : NaN

        const pct = (num, den) => {
          if (isNaN(num) || isNaN(den) || den === 0) return null
          return ((num / den) * 100).toFixed(2)
        }

        const kpiStr = (v) => {
          if (v == null || v === '') return '—'
          if (typeof v === 'string' && String(v).trim().includes('%')) return String(v).trim()
          const n = parseFloat(String(v).replace('%', '').replace(',', '.'))
          return isNaN(n) ? String(v) : `${n.toFixed(2)}%`
        }

        const verifAvanceFast = pct(sumF, metaF)
        const verifAvanceInbi = pct(sumI, metaI)

        const calcFalF = !isNaN(metaF) && !isNaN(sumF) ? metaF - sumF : NaN
        const calcFalI = !isNaN(metaI) && !isNaN(sumI) ? metaI - sumI : NaN

        const near = (a, b) => !isNaN(a) && !isNaN(b) && Math.abs(a - b) < 1.01
        const verifFaltanteMontoFast = near(falF, calcFalF)
        const verifFaltanteMontoInbi = near(falI, calcFalI)

        return {
          sumaFast: fmt(m.sumaIngresoFast),
          sumaInbi: fmt(m.sumaIngresoInbi),
          metaFast: fmt(m.metaIngresoFast),
          metaInbi: fmt(m.metaIngresoInbi),
          verifAvanceFast,
          verifAvanceInbi,
          kpiAvanceFast: kpiStr(m.avance_fast),
          kpiAvanceInbi: kpiStr(m.avance_inbi),
          kpiFaltanteFast: kpiStr(m.faltante_fast),
          kpiFaltanteInbi: kpiStr(m.faltante_inbi),
          faltanteMontoFast: fmt(m.faltanteMontoFast),
          faltanteMontoInbi: fmt(m.faltanteMontoInbi),
          faltanteMontoFastCalcFmt: !isNaN(calcFalF) ? fmt(calcFalF) : '—',
          faltanteMontoInbiCalcFmt: !isNaN(calcFalI) ? fmt(calcFalI) : '—',
          verifFaltanteMontoFast,
          verifFaltanteMontoInbi,
          idCicloFast: m.idCicloIngresoFast != null ? m.idCicloIngresoFast : null,
          idCicloInbi: m.idCicloIngresoInbi != null ? m.idCicloIngresoInbi : null
        }
      },

      /** Desglose Operaciones - Clases: % cumplimiento con valores actuales de la tarjeta. */
      comparativaOperacionesClasesFormula () {
        const dep = this.dialogComparativa && this.dialogComparativa.departamento
        if (dep !== 'Operaciones - Clases') return null
        const build = (correctas, total) => {
          const c = Number(correctas || 0)
          const t = Number(total || 0)
          const faltas = t - c
          const pct = t > 0 ? (c / t) * 100 : 0
          return {
            correctas: c,
            total: t,
            faltas: faltas < 0 ? 0 : faltas,
            pctFmt: pct.toFixed(2)
          }
        }
        const n = Number(this.operacionesClasesSemanaActual) || 3
        return {
          semanaLabel: `${n} (lu${n}, ma${n}, mi${n}, ju${n}, vi${n})`,
          fast: build(this.clasesFastCorrectas, this.clasesFastTotal),
          inbi: build(this.clasesInbiCorrectas, this.clasesInbiTotal)
        }
      },

      avanceActualesFast() {
        if( this.dataTablaFastUno.length > 0 ) {
          return (( this.dataTablaFastUno[ this.dataTablaFastUno.length - 1 ].total / this.dataTablaFastUno[ this.dataTablaFastUno.length - 1 ].meta  )*100)
        }
        else {
          return 0
        }
      },

      totalVentasFast() {
        if( this.dataTablaFastUno.length > 0 ) {
          return this.dataTablaFastUno[ this.dataTablaFastUno.length - 1 ].total
        }
        else {
          return 0
        }
      },

      totalVentasInbi() {
        if( this.dataTablaInbiUno.length > 0 ) {
          return this.dataTablaInbiUno[ this.dataTablaInbiUno.length - 1 ].total
        }
        else {
          return 0
        }
      },

      metaFast() {
        if( this.dataTablaFastUno.length > 0 ) {
          return this.dataTablaFastUno[ this.dataTablaFastUno.length - 1 ].meta
        }
        else {
          return 0
        }
      },

      metaInbi() {
        if( this.dataTablaInbiUno.length > 0 ) {
          return this.dataTablaInbiUno[ this.dataTablaInbiUno.length - 1 ].meta
        }
        else {
          return 0
        }
      },

      avanceActualesInbi() {
        if( this.dataTablaInbiUno.length > 0 ) {
          return (( this.dataTablaInbiUno[ this.dataTablaInbiUno.length - 1 ].total / this.dataTablaInbiUno[ this.dataTablaInbiUno.length - 1 ].meta  )*100)
        }
        else {
          return 0
        }
      },

      ventasCambiosFast(){
        if( this.dataTablaFastUno.length > 0 ) {
          return this.dataTablaFastUno[ this.dataTablaFastUno.length - 1 ].total_fuera_ciclo - 1
        }
        else {
          return 0
        }
      },

      ventasCambiosInbi(){
        if( this.dataTablaInbiUno.length > 0 ) {
          return this.dataTablaInbiUno[ this.dataTablaInbiUno.length - 1 ].total_fuera_ciclo - 1
        }
        else {
          return 0
        }
      },

      comparativaData(){
        return {
          'Op. Inscritos NI': this.operacionesNIComparativaDesdeHistorial(),
          'Operaciones - %RI': this.operacionesRIComparativaDesdeHistorial(),
          'Operaciones - $$': this.metamoneyComparativaDesdeHistorial(),
          'RH - %Ocupación': this.rhComparativaDesdeHistorial(),
          'Comercial': this.comercialComparativaDesdeHistorial(),
          'Comercial - Conversión': this.comercialConversionComparativaDesdeHistorial(),
          'TI': this.tiComparativaDesdeHistorial(),
          'Finanzas': this.finanzasComparativaDesdeHistorial(),
          'Operaciones - Clases': this.operacionesClasesComparativaDesdeCalculo(),
          'Control I. - Procesos': this.controlInternoComparativaDesdeHistorial(),
          'Mantenimiento': this.mantenimientoComparativaDesdeHistorial()
        }
      }
    },

    watch: {
      cicloInf () {
        if(this.cicloInf){
          var num_search = parseInt(this.cicloInf.ciclo.substr(5,3)) + 1
          for(const i in this.ciclos){
            var cadena_search = this.ciclos[i].ciclo.substr(0,8)
            if (cadena_search.search(num_search) != -1) {
              this.cicloSup = this.ciclos[i]
            }
          }

          this.fechaini = null
          this.fechafin = null
        }
      }
    },


    async created () {
      await this.initialize()
    },

    methods: {

      parsePercentageValue (raw) {
        if (raw == null || raw === '') return null
        const normalized = String(raw).replace('%', '').replace(',', '.').trim()
        const n = parseFloat(normalized)
        return isNaN(n) ? null : n
      },
      getSemaforoEstado (raw) {
        const n = this.parsePercentageValue(raw)
        if (n == null) return null
        if (n < 80) return 'red'
        if (n <= 94) return 'yellow'
        return 'green'
      },
      canShowCard (cardKey) {
        if (!this.mostrarControlCardsKpi) return true
        return !!this.cardsVisibles[cardKey]
      },
      setKpiLoader (cardKey, value) {
        if (!this.kpiLoaders || !Object.prototype.hasOwnProperty.call(this.kpiLoaders, cardKey)) return
        this.$set(this.kpiLoaders, cardKey, !!value)
      },
      async runKpiTask (cardKey, task) {
        this.setKpiLoader(cardKey, true)
        try {
          await task()
        } catch (error) {
          const msg =
            error &&
            error.response &&
            error.response.data &&
            error.response.data.message
              ? error.response.data.message
              : `Error al cargar ${cardKey}`
          this.validarError(msg)
        } finally {
          this.setKpiLoader(cardKey, false)
        }
      },

    	getCiclos () {
        this.ciclos    = []
        this.$http.get('kpi.ciclos.all').then(response=>{
          for(const i in response.data){
            if (!(response.data[i].ciclo.search('FE') != -1)) {
              if(response.data[i].ciclo.search('CICLO') != -1){
                this.ciclos.push(response.data[i])
              }
            }
          }
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { this.cargar = false })
      },

      formatearRangoSemana(fechaInicio, fechaFinal){
        if (!fechaInicio) return ''
        const partes = String(fechaInicio).substr(0, 10).split('-')
        if (partes.length < 3) return fechaInicio
        const [y1, m1, d1] = partes
        const meses = ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic']
        const mes1 = parseInt(m1, 10)
        if (!fechaFinal) {
          return `${d1} ${meses[mes1 - 1] || ''}`
        }
        const p2 = String(fechaFinal).substr(0, 10).split('-')
        if (p2.length < 3) {
          return `${d1} ${meses[mes1 - 1] || ''}`
        }
        const [y2, m2, d2] = p2
        const mes2 = parseInt(m2, 10)
        const mismoMesYAnio = y1 === y2 && mes1 === mes2
        if (mismoMesYAnio) {
          return `${d1}-${d2} ${meses[mes1 - 1] || ''}`
        }
        // Semana que cruza mes (u año): mostrar ambos para no dejar el mes solo del inicio
        return `${d1} ${meses[mes1 - 1] || ''} - ${d2} ${meses[mes2 - 1] || ''}`
      },
      markerStyle (percent, size, rotate, colorOverride = null, colorKey = null, strokeWidth = 15) {
        const radius = size / 2
        const w = Number(strokeWidth)
        const track = !isNaN(w) && w > 0 ? w : 15
        // Misma convención que Vuetify: el SVG rota `rotate`° y el arco arranca ahí (sentido horario).
        const angleDeg = ((Number(percent) / 100) * 360) + Number(rotate || 0)
        const p = Number(colorKey != null ? colorKey : percent)
        const markerColors = {
          10: '#1e88e5',
          80: '#43a047',
          85: '#fdd835',
          90: '#fb8c00',
          93: '#e53935',
          94: '#e53935'
        }
        const markerColor = colorOverride || markerColors[p] || '#1e88e5'
        // Tick transversal al arco: segmento radial que cruza el grosor del ring (no tangencial).
        const tickLen = track + 8
        const midR = radius - track / 2
        const rad = (angleDeg * Math.PI) / 180
        const dx = Math.cos(rad) * midR
        const dy = Math.sin(rad) * midR
        return {
          // +90°: alinea el largo del tick con el radio (cruza el grosor del ring), no con la tangente del arco.
          transform: `translate(calc(-50% + ${dx}px), calc(-50% + ${dy}px)) rotate(${angleDeg + 90}deg)`,
          backgroundColor: markerColor,
          width: '2px',
          height: `${tickLen}px`,
          boxShadow: `0 0 0 1px rgba(255, 255, 255, 0.95), 0 0 6px ${markerColor}55`,
          borderRadius: '1px'
        }
      },
      /** RI: solo la marca objetivo (`riMarcaObjetivo`, 1…5) lleva color; el resto gris. */
      markerStyleRi (percentVisual, size, rotate, marcaIndex1Based, accentColor) {
        const inactive = '#bdbdbd'
        const active =
          Number(marcaIndex1Based) === Number(this.riMarcaObjetivo)
        const c = active ? accentColor : inactive
        return this.markerStyle(percentVisual, size, rotate, c, null)
      },
      operacionesNIComparativaDesdeHistorial(){
        const h = (this.historialOperacionesNI || [])
          .filter(row => row && (row.INBI != null || row.FAST != null))
          .sort((a, b) => {
            const cicloA = a && (a.nombre_ciclo_base || a.ciclo || a.nombre_ciclo) ? (a.nombre_ciclo_base || a.ciclo || a.nombre_ciclo) : ''
            const cicloB = b && (b.nombre_ciclo_base || b.ciclo || b.nombre_ciclo) ? (b.nombre_ciclo_base || b.ciclo || b.nombre_ciclo) : ''
            if (cicloA !== cicloB) return cicloA.localeCompare(cicloB)
            const fechaA = String((a && a.fecha_inicio) || '')
            const fechaB = String((b && b.fecha_inicio) || '')
            return fechaA.localeCompare(fechaB)
          })
        const fields = ['inbi', 'niSemanalInbi', 'metaInbiSemana', 'diferenciaInbi', 'fast', 'niSemanalFast', 'metaFastSemana', 'diferenciaFast']
        const conceptos = ['Inbi', 'Semana Inbi', 'Meta Inbi', 'Diferencia Inbi', 'Fast', 'Semana Fast', 'Meta Fast', 'Diferencia Fast']
        const semanas = h.map(row => {
          const ciclo = row.nombre_ciclo_base || row.ciclo || row.nombre_ciclo || ''
          const semanaRaw = row.semana != null && row.semana !== '' ? row.semana : null
          const semanaStr = semanaRaw != null && String(semanaRaw).trim() !== '' ? String(semanaRaw).trim() : null
          return {
            label: this.formatearRangoSemana(row.fecha_inicio, row.fecha_final || row.fecha_fin),
            semana: semanaStr,
            ciclo,
            fast: row.FAST != null ? parseFloat(row.FAST) : 0,
            inbi: row.INBI != null ? parseFloat(row.INBI) : 0,
            niSemanalInbi: row.ni_semanal_inbi != null ? parseFloat(row.ni_semanal_inbi) : 0,
            niSemanalFast: row.ni_semanal_fast != null ? parseFloat(row.ni_semanal_fast) : 0,
            metaInbiSemana: row.meta_inbi_semana != null ? parseFloat(row.meta_inbi_semana) : 0,
            metaFastSemana: row.meta_fast_semana != null ? parseFloat(row.meta_fast_semana) : 0,
            diferenciaInbi: row.diferencia_meta_inbi != null ? parseFloat(row.diferencia_meta_inbi) : 0,
            diferenciaFast: row.diferencia_meta_fast != null ? parseFloat(row.diferencia_meta_fast) : 0
          }
        })
        const ultimoPorCiclo = {}
        const tendencias = semanas.map(sem => {
          const prev = ultimoPorCiclo[sem.ciclo]
          const calc = (p, c) => p != null && c != null ? (c > p ? 'up' : c < p ? 'down' : 'equal') : null
          const trend = {
            fast: prev ? calc(prev.fast, sem.fast) : null,
            inbi: prev ? calc(prev.inbi, sem.inbi) : null,
            niSemanalInbi: prev ? calc(prev.niSemanalInbi, sem.niSemanalInbi) : null,
            niSemanalFast: prev ? calc(prev.niSemanalFast, sem.niSemanalFast) : null,
            metaInbiSemana: prev ? calc(prev.metaInbiSemana, sem.metaInbiSemana) : null,
            metaFastSemana: prev ? calc(prev.metaFastSemana, sem.metaFastSemana) : null,
            diferenciaInbi: prev ? calc(prev.diferenciaInbi, sem.diferenciaInbi) : null,
            diferenciaFast: prev ? calc(prev.diferenciaFast, sem.diferenciaFast) : null
          }
          ultimoPorCiclo[sem.ciclo] = sem
          return trend
        })
        return { _operacionesNIDynamic: true, semanas, tendencias, conceptos, fields, cicloField: 'ciclo' }
      },

      operacionesRIComparativaDesdeHistorial(){
        const h = (this.historialInscripciones || [])
          .filter(row => row && (row.fast != null || row.inbi != null))
          .sort((a, b) => {
            const cicloA = a && a.ciclo ? String(a.ciclo) : ''
            const cicloB = b && b.ciclo ? String(b.ciclo) : ''
            if (cicloA !== cicloB) return cicloA.localeCompare(cicloB)
            const fechaA = String((a && a.fecha_inicio) || '')
            const fechaB = String((b && b.fecha_inicio) || '')
            return fechaA.localeCompare(fechaB)
          })
        const fields = ['inbi', 'metaInbi', 'diferenciaInbi', 'fast', 'metaFast', 'diferenciaFast']
        const conceptos = ['Inbi', 'Meta Inbi', 'Diferencia Inbi', 'Fast', 'Meta Fast', 'Diferencia Fast']
        const r2 = (n) => n != null && typeof n === 'number' && !isNaN(n) ? Math.round(n * 100) / 100 : null
        /* Diferencia = avance − meta: positivo o cero si cumple (avance ≥ meta), negativo si no */
        const semanas = h.map(row => {
          const ciclo = row.ciclo != null ? String(row.ciclo) : ''
          const meta = row.meta != null ? r2(parseFloat(row.meta)) : null
          const fast = row.fast != null ? r2(parseFloat(row.fast)) : null
          const inbi = row.inbi != null ? r2(parseFloat(row.inbi)) : null
          const diferenciaFast = fast != null && meta != null ? r2(fast - meta) : null
          const diferenciaInbi = inbi != null && meta != null ? r2(inbi - meta) : null
          const fechaFin = row.fecha_final != null && row.fecha_final !== '' ? row.fecha_final : row.fecha_fin
          const semanaStr = row.semana != null && row.semana !== '' ? String(row.semana) : null
          return {
            label: this.formatearRangoSemana(row.fecha_inicio, fechaFin),
            fechaPeriodo: this.formatearRangoSemana(row.fecha_inicio, fechaFin),
            semana: semanaStr,
            ciclo,
            fast,
            inbi,
            metaInbi: meta,
            metaFast: meta,
            diferenciaFast,
            diferenciaInbi
          }
        })
        const ultimoPorCiclo = {}
        const tendencias = semanas.map(sem => {
          const prev = ultimoPorCiclo[sem.ciclo]
          const calc = (p, c) => p != null && c != null ? (c > p ? 'up' : c < p ? 'down' : 'equal') : null
          const trend = {
            fast: prev ? calc(prev.fast, sem.fast) : null,
            inbi: prev ? calc(prev.inbi, sem.inbi) : null,
            diferenciaFast: prev ? calc(prev.diferenciaFast, sem.diferenciaFast) : null,
            diferenciaInbi: prev ? calc(prev.diferenciaInbi, sem.diferenciaInbi) : null
          }
          ultimoPorCiclo[sem.ciclo] = sem
          return trend
        })
        /* Fila final: mismo avance que la tarjeta %RI (resultadoRi), meta 90. Textos fijos (temporal). */
        const ri = this.resultadoRi
        if (ri && ri.riPlantelesFast && ri.riPlantelesFast.length && ri.riPlantelesInbi && ri.riPlantelesInbi.length) {
          const lastF = ri.riPlantelesFast[ri.riPlantelesFast.length - 1]
          const lastI = ri.riPlantelesInbi[ri.riPlantelesInbi.length - 1]
          const fastAct = lastF.porcentajeAvance != null ? r2(parseFloat(lastF.porcentajeAvance)) : null
          const inbiAct = lastI.porcentajeAvance != null ? r2(parseFloat(lastI.porcentajeAvance)) : null
          const metaTarjeta = 90
          const periodoFijoRI = '28 - 04 Oct'
          const cicloFijoRI = 'CICLO 09_26'
          const semanaFijaRI = '3'
          semanas.push({
            label: periodoFijoRI,
            fechaPeriodo: periodoFijoRI,
            semana: semanaFijaRI,
            ciclo: cicloFijoRI,
            fast: fastAct,
            inbi: inbiAct,
            metaInbi: metaTarjeta,
            metaFast: metaTarjeta,
            diferenciaFast: fastAct != null ? r2(fastAct - metaTarjeta) : null,
            diferenciaInbi: inbiAct != null ? r2(inbiAct - metaTarjeta) : null,
            _esFilaActualRI: true
          })
          tendencias.push({
            fast: null,
            inbi: null,
            metaInbi: null,
            metaFast: null,
            diferenciaFast: null,
            diferenciaInbi: null
          })
        }
        return { _operacionesRIDynamic: true, semanas, tendencias, conceptos, fields, cicloField: 'ciclo' }
      },

      metamoneyComparativaDesdeHistorial(){
        const h = (this.historialMetaMoney || [])
          .filter(row => row && (row.porcentaje_fast != null || row.porcentaje_inbi != null))
          .sort((a, b) => {
            const cicloA = a && a.nombre_ciclo_base ? a.nombre_ciclo_base : ''
            const cicloB = b && b.nombre_ciclo_base ? b.nombre_ciclo_base : ''
            if (cicloA !== cicloB) return cicloA.localeCompare(cicloB)
            const fechaA = String((a && a.fecha_inicio) || '')
            const fechaB = String((b && b.fecha_inicio) || '')
            return fechaA.localeCompare(fechaB)
          })
        const r2 = (n) => n != null && typeof n === 'number' && !isNaN(n) ? Math.round(n * 100) / 100 : null
        const fields = ['inbi', 'metaInbi', 'diferenciaInbi', 'fast', 'metaFast', 'diferenciaFast']
        const conceptos = ['Inbi', 'Meta Inbi', 'Diferencia Inbi', 'Fast', 'Meta Fast', 'Diferencia Fast']
        const semanas = h.map(row => {
          const ciclo = row.nombre_ciclo_base || ''
          const semanaStr = row.semana != null && row.semana !== '' ? String(row.semana) : null
          const inbi = row.porcentaje_inbi != null ? r2(parseFloat(row.porcentaje_inbi)) : null
          const fast = row.porcentaje_fast != null ? r2(parseFloat(row.porcentaje_fast)) : null
          const metaInbi = row.meta_inbi != null ? r2(parseFloat(row.meta_inbi)) : 100
          const metaFast = row.meta_fast != null ? r2(parseFloat(row.meta_fast)) : 100
          /* Misma convención que Op. Inscritos NI: diferencia = avance − meta (≥0 cumple). Si el API manda meta−avance, se ignora al derivar desde inbi/meta. */
          let diferenciaInbi = inbi != null && metaInbi != null ? r2(inbi - metaInbi) : (row.diferencia_inbi != null ? r2(parseFloat(row.diferencia_inbi)) : null)
          let diferenciaFast = fast != null && metaFast != null ? r2(fast - metaFast) : (row.diferencia_fast != null ? r2(parseFloat(row.diferencia_fast)) : null)
          return {
            label: this.formatearRangoSemana(row.fecha_inicio, row.fecha_final || row.fecha_fin),
            semana: semanaStr,
            ciclo,
            inbi,
            fast,
            metaInbi,
            metaFast,
            diferenciaInbi,
            diferenciaFast
          }
        })
        const parsePctKpi = (v) => {
          if (v == null || v === '') return null
          const n = parseFloat(String(v).replace('%', '').replace(',', '.').trim())
          return isNaN(n) ? null : r2(n)
        }
        const m = this.metamoney || {}
        const avF = parsePctKpi(m.avance_fast)
        const avI = parsePctKpi(m.avance_inbi)
        const metaDef = 100
        const metaF = m.metaIngresoFast != null ? r2(parseFloat(m.metaIngresoFast)) : null
        const metaI = m.metaIngresoInbi != null ? r2(parseFloat(m.metaIngresoInbi)) : null
        if (avF != null || avI != null) {
          let cicloAct = ''
          if (this.ciclo) {
            if (typeof this.ciclo === 'object' && this.ciclo.ciclo != null && this.ciclo.ciclo !== '') cicloAct = String(this.ciclo.ciclo)
            else if (typeof this.ciclo === 'string') cicloAct = this.ciclo
          }
          const metaFastRow = metaF != null ? metaF : metaDef
          const metaInbiRow = metaI != null ? metaI : metaDef
          semanas.push({
            label: 'Actual',
            semana: '—',
            ciclo: cicloAct,
            fast: avF,
            inbi: avI,
            metaFast: metaFastRow,
            metaInbi: metaInbiRow,
            diferenciaFast: avF != null ? r2(avF - metaFastRow) : null,
            diferenciaInbi: avI != null ? r2(avI - metaInbiRow) : null
          })
        }
        const ultimoPorCiclo = {}
        const tendencias = semanas.map(sem => {
          const prev = ultimoPorCiclo[sem.ciclo]
          const calc = (p, c) => p != null && c != null ? (c > p ? 'up' : c < p ? 'down' : 'equal') : null
          const trend = {
            inbi: prev ? calc(prev.inbi, sem.inbi) : null,
            metaInbi: prev ? calc(prev.metaInbi, sem.metaInbi) : null,
            diferenciaInbi: prev ? calc(prev.diferenciaInbi, sem.diferenciaInbi) : null,
            fast: prev ? calc(prev.fast, sem.fast) : null,
            metaFast: prev ? calc(prev.metaFast, sem.metaFast) : null,
            diferenciaFast: prev ? calc(prev.diferenciaFast, sem.diferenciaFast) : null
          }
          ultimoPorCiclo[sem.ciclo] = sem
          return trend
        })
        return { _metamoneyDynamic: true, _metamoneyFull: true, semanas, tendencias, conceptos, fields, cicloField: 'ciclo' }
      },

      rhComparativaDesdeHistorial(){
        const h = (this.historialRh || []).filter(row => row && (row.fast != null || row.inbi != null))
        const META_RH = 80
        const actual = {
          fast: parseFloat(this.rhOcupacionFast.percent_ocupacion) || 0,
          inbi: parseFloat(this.rhOcupacionInbi.percent_ocupacion) || 0,
          coorporativo: parseFloat(this.rhOcupacionCorpo.percent_ocupacion) || 0,
          general: parseFloat(this.rhOcupacionTodo.percent_ocupacion) || 0
        }
        const fields = [
          'inbi', 'metaInbi', 'diferenciaInbi',
          'fast', 'metaFast', 'diferenciaFast',
          'coorporativo', 'metaCorpo', 'diferenciaCorpo',
          'general', 'metaGeneral', 'diferenciaGeneral'
        ]
        const conceptos = [
          'Inbi', 'Meta Inbi', 'Diferencia',
          'Fast', 'Meta Fast', 'Diferencia Fast',
          'Corporativo', 'Meta Corpo', 'Diferencia',
          'General', 'Meta General', 'Diferencia'
        ]
        const semanas = h.map(row => {
          const inbi = row.inbi != null ? parseFloat(row.inbi) : null
          const fast = row.fast != null ? parseFloat(row.fast) : null
          const coorporativo = row.coorporativo != null ? parseFloat(row.coorporativo) : null
          const general = row.general != null ? parseFloat(row.general) : null
          return {
            label: this.formatearRangoSemana(row.fecha_inicio, row.fecha_final),
            inbi,
            metaInbi: META_RH,
            diferenciaInbi: inbi != null ? inbi - META_RH : null,
            fast,
            metaFast: META_RH,
            diferenciaFast: fast != null ? fast - META_RH : null,
            coorporativo,
            metaCorpo: META_RH,
            diferenciaCorpo: coorporativo != null ? coorporativo - META_RH : null,
            general,
            metaGeneral: META_RH,
            diferenciaGeneral: general != null ? general - META_RH : null
          }
        })
        semanas.push({
          label: 'Actual',
          inbi: actual.inbi,
          metaInbi: META_RH,
          diferenciaInbi: actual.inbi - META_RH,
          fast: actual.fast,
          metaFast: META_RH,
          diferenciaFast: actual.fast - META_RH,
          coorporativo: actual.coorporativo,
          metaCorpo: META_RH,
          diferenciaCorpo: actual.coorporativo - META_RH,
          general: actual.general,
          metaGeneral: META_RH,
          diferenciaGeneral: actual.general - META_RH
        })
        const tendencias = semanas.map((sem, idx) => {
          if (idx === 0) return {
            inbi: null, metaInbi: null, diferenciaInbi: null,
            fast: null, metaFast: null, diferenciaFast: null,
            coorporativo: null, metaCorpo: null, diferenciaCorpo: null,
            general: null, metaGeneral: null, diferenciaGeneral: null
          }
          const prev = semanas[idx - 1]
          const calc = (a, b) => a != null && b != null ? (b > a ? 'up' : b < a ? 'down' : 'equal') : null
          return {
            inbi: calc(prev.inbi, sem.inbi),
            metaInbi: calc(prev.metaInbi, sem.metaInbi),
            diferenciaInbi: calc(prev.diferenciaInbi, sem.diferenciaInbi),
            fast: calc(prev.fast, sem.fast),
            metaFast: calc(prev.metaFast, sem.metaFast),
            diferenciaFast: calc(prev.diferenciaFast, sem.diferenciaFast),
            coorporativo: calc(prev.coorporativo, sem.coorporativo),
            metaCorpo: calc(prev.metaCorpo, sem.metaCorpo),
            diferenciaCorpo: calc(prev.diferenciaCorpo, sem.diferenciaCorpo),
            general: calc(prev.general, sem.general),
            metaGeneral: calc(prev.metaGeneral, sem.metaGeneral),
            diferenciaGeneral: calc(prev.diferenciaGeneral, sem.diferenciaGeneral)
          }
        })
        return { _rhDynamic: true, semanas, tendencias, conceptos, fields }
      },

      comercialComparativaDesdeHistorial(){
        const META_CONVERSION_COMERCIAL = 10
        const META_BASE_COMERCIAL = 0
        const h = (this.historialComercial || []).filter(row => row && (row.fast != null || row.inbi != null))
        const arrConv = (this.historialComercialConversion && this.historialComercialConversion.historial)
          ? this.historialComercialConversion.historial
          : (Array.isArray(this.historialComercialConversion) ? this.historialComercialConversion : [])
        const normKey = (fi, ff) => (String(fi || '').substr(0, 10)) + '|' + (String(ff || '').substr(0, 10))
        const getConv = (row) => {
          const cFast = row.conversionFast != null ? row.conversionFast : (row.conversion_fast != null ? row.conversion_fast : (row.fast != null ? row.fast : null))
          const cInbi = row.conversionInbi != null ? row.conversionInbi : (row.conversion_inbi != null ? row.conversion_inbi : (row.inbi != null ? row.inbi : null))
          return { conversionFast: cFast != null ? parseFloat(cFast) : null, conversionInbi: cInbi != null ? parseFloat(cInbi) : null }
        }
        const convMap = {}
        arrConv.forEach(row => {
          const hasConv = row && (row.conversionFast != null || row.conversionInbi != null || row.conversion_fast != null || row.conversion_inbi != null || row.fast != null || row.inbi != null)
          if (hasConv) {
            const key = normKey(row.fecha_inicio, row.fecha_final)
            convMap[key] = getConv(row)
          }
        })
        const fields = [
          'inbi', 'metaInbi', 'diferenciaInbi',
          'conversionInbi', 'metaConversionInbi', 'diferenciaConversionInbi',
          'fast', 'metaFast', 'diferenciaFast',
          'conversionFast', 'metaConversionFast', 'diferenciaConversionFast'
        ]
        const conceptos = [
          'Inbi', 'Meta Inbi', 'Diferencia Inbi',
          'Inbi Conversión', 'Meta Inbi Conversión', 'Diferencia Inbi Conversión',
          'Fast', 'Meta Fast', 'Diferencia Fast',
          'Fast Conversión', 'Meta Fast Conversión', 'Diferencia Fast Conversión'
        ]
        const semanas = h.map(row => {
          const key = normKey(row.fecha_inicio, row.fecha_final)
          const conv = convMap[key] || { conversionFast: null, conversionInbi: null }
          const inbi = row.inbi != null ? parseFloat(row.inbi) : null
          const fast = row.fast != null ? parseFloat(row.fast) : null
          const metaInbi = row.meta_inbi != null && row.meta_inbi !== '' ? parseFloat(row.meta_inbi) : META_BASE_COMERCIAL
          const metaFast = row.meta_fast != null && row.meta_fast !== '' ? parseFloat(row.meta_fast) : META_BASE_COMERCIAL
          const ciclo =
            row.nombre_ciclo_base != null && row.nombre_ciclo_base !== ''
              ? String(row.nombre_ciclo_base)
              : row.ciclo != null && row.ciclo !== ''
                ? String(row.ciclo)
                : row.nombre_ciclo != null && row.nombre_ciclo !== ''
                  ? String(row.nombre_ciclo)
                  : ''
          const semanaStr = row.semana != null && row.semana !== '' ? String(row.semana) : null
          return {
            label: this.formatearRangoSemana(row.fecha_inicio, row.fecha_final),
            ciclo,
            semana: semanaStr,
            inbi,
            metaInbi,
            diferenciaInbi: inbi != null ? inbi - metaInbi : null,
            conversionInbi: conv.conversionInbi,
            metaConversionInbi: META_CONVERSION_COMERCIAL,
            diferenciaConversionInbi: conv.conversionInbi != null ? conv.conversionInbi - META_CONVERSION_COMERCIAL : null,
            fast,
            metaFast,
            diferenciaFast: fast != null ? fast - metaFast : null,
            conversionFast: conv.conversionFast,
            metaConversionFast: META_CONVERSION_COMERCIAL,
            diferenciaConversionFast: conv.conversionFast != null ? conv.conversionFast - META_CONVERSION_COMERCIAL : null
          }
        })
        const tendencias = semanas.map((sem, idx) => {
          if (idx === 0) return {
            inbi: null, metaInbi: null, diferenciaInbi: null,
            conversionInbi: null, metaConversionInbi: null, diferenciaConversionInbi: null,
            fast: null, metaFast: null, diferenciaFast: null,
            conversionFast: null, metaConversionFast: null, diferenciaConversionFast: null
          }
          const prev = semanas[idx - 1]
          const calc = (p, c) => p != null && c != null ? (c > p ? 'up' : c < p ? 'down' : 'equal') : null
          return {
            inbi: calc(prev.inbi, sem.inbi),
            metaInbi: calc(prev.metaInbi, sem.metaInbi),
            diferenciaInbi: calc(prev.diferenciaInbi, sem.diferenciaInbi),
            conversionInbi: calc(prev.conversionInbi, sem.conversionInbi),
            metaConversionInbi: calc(prev.metaConversionInbi, sem.metaConversionInbi),
            diferenciaConversionInbi: calc(prev.diferenciaConversionInbi, sem.diferenciaConversionInbi),
            fast: calc(prev.fast, sem.fast),
            metaFast: calc(prev.metaFast, sem.metaFast),
            diferenciaFast: calc(prev.diferenciaFast, sem.diferenciaFast),
            conversionFast: calc(prev.conversionFast, sem.conversionFast),
            metaConversionFast: calc(prev.metaConversionFast, sem.metaConversionFast),
            diferenciaConversionFast: calc(prev.diferenciaConversionFast, sem.diferenciaConversionFast)
          }
        })
        return { _comercialDynamic: true, semanas, tendencias, conceptos, fields, cicloField: 'ciclo' }
      },

      comercialConversionComparativaDesdeHistorial(){
        const h = (this.historialComercialConversion || []).filter(row => row && (row.conversionFast != null || row.conversionInbi != null))
        const fields = ['conversionFast', 'conversionInbi']
        const conceptos = ['Fast', 'Inbi']
        const semanas = h.map(row => ({
          label: this.formatearRangoSemana(row.fecha_inicio, row.fecha_final),
          conversionFast: row.conversionFast != null ? parseFloat(row.conversionFast) : null,
          conversionInbi: row.conversionInbi != null ? parseFloat(row.conversionInbi) : null
        }))
        const tendencias = semanas.map((sem, idx) => {
          if (idx === 0) return { conversionFast: null, conversionInbi: null }
          const prev = semanas[idx - 1]
          return {
            conversionFast: prev.conversionFast != null && sem.conversionFast != null ? (sem.conversionFast > prev.conversionFast ? 'up' : sem.conversionFast < prev.conversionFast ? 'down' : 'equal') : null,
            conversionInbi: prev.conversionInbi != null && sem.conversionInbi != null ? (sem.conversionInbi > prev.conversionInbi ? 'up' : sem.conversionInbi < prev.conversionInbi ? 'down' : 'equal') : null
          }
        })
        return { _comercialConversionDynamic: true, semanas, tendencias, conceptos, fields }
      },

      finanzasComparativaDesdeHistorial(){
        const META_FINANZAS = 100
        const h = (this.finanzas && this.finanzas.finanzas_historial) || []
        const filtrado = h.filter(row => row && (row.fast_ingresos != null || row.inbi_ingresos != null || row.fast_egresos != null || row.inbi_egresos != null))
        const fields = [
          'inbi_ingresos', 'meta_inbi_ingresos', 'comparativa_inbi_ingresos',
          'inbi_egresos', 'meta_inbi_egresos', 'comparativa_inbi_egresos',
          'fast_ingresos', 'meta_fast_ingresos', 'comparativa_fast_ingresos',
          'fast_egresos', 'meta_fast_egresos', 'comparativa_fast_egresos'
        ]
        const conceptos = [
          'Inbi Ingresos', 'Meta Inbi Ingresos', 'Comparativa Inbi Ingresos',
          'Inbi Egresos', 'Meta Inbi Egresos', 'Comparativa Inbi Egresos',
          'Fast Ingresos', 'Meta Fast Ingresos', 'Comparativa Fast Ingresos',
          'Fast Egresos', 'Meta Fast Egresos', 'Comparativa Fast Egresos'
        ]
        const actual = {
          fast_ingresos: this.finanzas && this.finanzas.ingresoValidadoFast != null ? parseFloat(this.finanzas.ingresoValidadoFast) : null,
          inbi_ingresos: this.finanzas && this.finanzas.ingresoValidadoInbi != null ? parseFloat(this.finanzas.ingresoValidadoInbi) : null,
          fast_egresos: this.finanzas && this.finanzas.egresoFast != null ? parseFloat(this.finanzas.egresoFast) : null,
          inbi_egresos: this.finanzas && this.finanzas.egresoInbi != null ? parseFloat(this.finanzas.egresoInbi) : null
        }
        const semanas = filtrado.map(row => {
          const inbiIngresos = row.inbi_ingresos != null ? parseFloat(row.inbi_ingresos) : null
          const inbiEgresos = row.inbi_egresos != null ? parseFloat(row.inbi_egresos) : null
          const fastIngresos = row.fast_ingresos != null ? parseFloat(row.fast_ingresos) : null
          const fastEgresos = row.fast_egresos != null ? parseFloat(row.fast_egresos) : null
          return {
            label: this.formatearRangoSemana(row.fecha_inicio, row.fecha_final),
            inbi_ingresos: inbiIngresos,
            meta_inbi_ingresos: META_FINANZAS,
            comparativa_inbi_ingresos: inbiIngresos != null ? inbiIngresos - META_FINANZAS : null,
            inbi_egresos: inbiEgresos,
            meta_inbi_egresos: META_FINANZAS,
            comparativa_inbi_egresos: inbiEgresos != null ? inbiEgresos - META_FINANZAS : null,
            fast_ingresos: fastIngresos,
            meta_fast_ingresos: META_FINANZAS,
            comparativa_fast_ingresos: fastIngresos != null ? fastIngresos - META_FINANZAS : null,
            fast_egresos: fastEgresos,
            meta_fast_egresos: META_FINANZAS,
            comparativa_fast_egresos: fastEgresos != null ? fastEgresos - META_FINANZAS : null
          }
        })
        semanas.push({
          label: 'Actual',
          inbi_ingresos: actual.inbi_ingresos,
          meta_inbi_ingresos: META_FINANZAS,
          comparativa_inbi_ingresos: actual.inbi_ingresos != null ? actual.inbi_ingresos - META_FINANZAS : null,
          inbi_egresos: actual.inbi_egresos,
          meta_inbi_egresos: META_FINANZAS,
          comparativa_inbi_egresos: actual.inbi_egresos != null ? actual.inbi_egresos - META_FINANZAS : null,
          fast_ingresos: actual.fast_ingresos,
          meta_fast_ingresos: META_FINANZAS,
          comparativa_fast_ingresos: actual.fast_ingresos != null ? actual.fast_ingresos - META_FINANZAS : null,
          fast_egresos: actual.fast_egresos,
          meta_fast_egresos: META_FINANZAS,
          comparativa_fast_egresos: actual.fast_egresos != null ? actual.fast_egresos - META_FINANZAS : null
        })
        const tendencias = semanas.map((sem, idx) => {
          if (idx === 0) return {
            inbi_ingresos: null, meta_inbi_ingresos: null, comparativa_inbi_ingresos: null,
            inbi_egresos: null, meta_inbi_egresos: null, comparativa_inbi_egresos: null,
            fast_ingresos: null, meta_fast_ingresos: null, comparativa_fast_ingresos: null,
            fast_egresos: null, meta_fast_egresos: null, comparativa_fast_egresos: null
          }
          const prev = semanas[idx - 1]
          const calc = (p, c) => p != null && c != null ? (c > p ? 'up' : c < p ? 'down' : 'equal') : null
          return {
            inbi_ingresos: calc(prev.inbi_ingresos, sem.inbi_ingresos),
            meta_inbi_ingresos: calc(prev.meta_inbi_ingresos, sem.meta_inbi_ingresos),
            comparativa_inbi_ingresos: calc(prev.comparativa_inbi_ingresos, sem.comparativa_inbi_ingresos),
            inbi_egresos: calc(prev.inbi_egresos, sem.inbi_egresos),
            meta_inbi_egresos: calc(prev.meta_inbi_egresos, sem.meta_inbi_egresos),
            comparativa_inbi_egresos: calc(prev.comparativa_inbi_egresos, sem.comparativa_inbi_egresos),
            fast_ingresos: calc(prev.fast_ingresos, sem.fast_ingresos),
            meta_fast_ingresos: calc(prev.meta_fast_ingresos, sem.meta_fast_ingresos),
            comparativa_fast_ingresos: calc(prev.comparativa_fast_ingresos, sem.comparativa_fast_ingresos),
            fast_egresos: calc(prev.fast_egresos, sem.fast_egresos),
            meta_fast_egresos: calc(prev.meta_fast_egresos, sem.meta_fast_egresos),
            comparativa_fast_egresos: calc(prev.comparativa_fast_egresos, sem.comparativa_fast_egresos)
          }
        })
        return { _finanzasDynamic: true, semanas, tendencias, conceptos, fields }
      },

      tiComparativaDesdeHistorial(){
        const META_TI_MANT = 90
        const h = (this.historialTI || [])
          .filter(row => row && row.kpi_ti != null)
          .sort((a, b) => {
            const fa = String((a && a.fecha_inicio) || '')
            const fb = String((b && b.fecha_inicio) || '')
            if (fa !== fb) return fa.localeCompare(fb)
            const ffa = String((a && (a.fecha_fin || a.fecha_final)) || '')
            const ffb = String((b && (b.fecha_fin || b.fecha_final)) || '')
            return ffa.localeCompare(ffb)
          })
        const fields = ['kpi_ti', 'meta', 'diferencia']
        const conceptos = ['IUA (KPI)', 'Meta', 'Diferencia']
        const actualVal = this.ti && this.ti.kpi_ti != null ? parseFloat(this.ti.kpi_ti) : null
        const semanas = h.map(row => ({
          label: this.formatearRangoSemana(row.fecha_inicio, row.fecha_fin || row.fecha_final),
          kpi_ti: row.kpi_ti != null ? parseFloat(row.kpi_ti) : null,
          meta: META_TI_MANT,
          diferencia: row.kpi_ti != null ? parseFloat(row.kpi_ti) - META_TI_MANT : null
        }))
        semanas.push({
          label: 'Actual',
          kpi_ti: actualVal,
          meta: META_TI_MANT,
          diferencia: actualVal != null ? actualVal - META_TI_MANT : null
        })
        const tendencias = semanas.map((sem, idx) => {
          if (idx === 0) return { kpi_ti: null, meta: null, diferencia: null }
          const prev = semanas[idx - 1]
          const calc = (a, b) => a != null && b != null ? (b > a ? 'up' : b < a ? 'down' : 'equal') : null
          return {
            kpi_ti: calc(prev.kpi_ti, sem.kpi_ti),
            meta: calc(prev.meta, sem.meta),
            diferencia: calc(prev.diferencia, sem.diferencia)
          }
        })
        return { _tiDynamic: true, semanas, tendencias, conceptos, fields }
      },

      mantenimientoComparativaDesdeHistorial(){
        const META_TI_MANT = 90
        const h = (this.historialMantenimiento || [])
          .filter(row => row && (row.kpi_mantenimiento != null || row.kpi_ti != null))
          .sort((a, b) => {
            const fa = String((a && a.fecha_inicio) || '')
            const fb = String((b && b.fecha_inicio) || '')
            if (fa !== fb) return fa.localeCompare(fb)
            const ffa = String((a && (a.fecha_fin || a.fecha_final)) || '')
            const ffb = String((b && (b.fecha_fin || b.fecha_final)) || '')
            return ffa.localeCompare(ffb)
          })
        const fieldKey = 'kpi_mantenimiento'
        const fields = [fieldKey, 'meta', 'diferencia']
        const conceptos = ['IUA (KPI)', 'Meta', 'Diferencia']
        const actualVal = this.mantenimiento && this.mantenimiento.kpi_mantenimiento != null ? parseFloat(this.mantenimiento.kpi_mantenimiento) : null
        const semanas = h.map(row => {
          const val = row.kpi_mantenimiento != null ? row.kpi_mantenimiento : row.kpi_ti
          const parsedVal = val != null ? parseFloat(val) : null
          return {
            label: this.formatearRangoSemana(row.fecha_inicio, row.fecha_fin || row.fecha_final),
            [fieldKey]: parsedVal,
            meta: META_TI_MANT,
            diferencia: parsedVal != null ? parsedVal - META_TI_MANT : null
          }
        })
        semanas.push({
          label: 'Actual',
          [fieldKey]: actualVal,
          meta: META_TI_MANT,
          diferencia: actualVal != null ? actualVal - META_TI_MANT : null
        })
        const tendencias = semanas.map((sem, idx) => {
          if (idx === 0) return { [fieldKey]: null, meta: null, diferencia: null }
          const prev = semanas[idx - 1]
          const calc = (a, b) => a != null && b != null ? (b > a ? 'up' : b < a ? 'down' : 'equal') : null
          return {
            [fieldKey]: calc(prev[fieldKey], sem[fieldKey]),
            meta: calc(prev.meta, sem.meta),
            diferencia: calc(prev.diferencia, sem.diferencia)
          }
        })
        return { _mantenimientoDynamic: true, semanas, tendencias, conceptos, fields }
      },

      controlInternoComparativaDesdeHistorial(){
        const META_CONTROL_INTERNO = 90
        const h = (this.historialControlInterno || []).filter(row => row && (row.fast != null || row.inbi != null))
        const fields = ['inbi', 'metaInbi', 'comparativaInbi', 'fast', 'metaFast', 'comparativaFast']
        const conceptos = ['Inbi', 'Meta Inbi', 'Comparativa Inbi', 'Fast', 'Meta Fast', 'Comparativa Fast']
        const actual = {
          fast: this.controlInterno && this.controlInterno.fast != null ? parseFloat(this.controlInterno.fast) : null,
          inbi: this.controlInterno && this.controlInterno.inbi != null ? parseFloat(this.controlInterno.inbi) : null
        }
        const semanas = h.map(row => {
          const inbi = row.inbi != null ? parseFloat(row.inbi) : null
          const fast = row.fast != null ? parseFloat(row.fast) : null
          return {
            label: this.formatearRangoSemana(row.fecha_inicio, row.fecha_final || row.fecha_fin),
            inbi,
            metaInbi: META_CONTROL_INTERNO,
            comparativaInbi: inbi != null ? inbi - META_CONTROL_INTERNO : null,
            fast,
            metaFast: META_CONTROL_INTERNO,
            comparativaFast: fast != null ? fast - META_CONTROL_INTERNO : null
          }
        })
        semanas.push({
          label: 'Actual',
          inbi: actual.inbi,
          metaInbi: META_CONTROL_INTERNO,
          comparativaInbi: actual.inbi != null ? actual.inbi - META_CONTROL_INTERNO : null,
          fast: actual.fast,
          metaFast: META_CONTROL_INTERNO,
          comparativaFast: actual.fast != null ? actual.fast - META_CONTROL_INTERNO : null
        })
        const tendencias = semanas.map((sem, idx) => {
          if (idx === 0) return { inbi: null, metaInbi: null, comparativaInbi: null, fast: null, metaFast: null, comparativaFast: null }
          const prev = semanas[idx - 1]
          const calc = (p, c) => p != null && c != null ? (c > p ? 'up' : c < p ? 'down' : 'equal') : null
          return {
            inbi: calc(prev.inbi, sem.inbi),
            metaInbi: calc(prev.metaInbi, sem.metaInbi),
            comparativaInbi: calc(prev.comparativaInbi, sem.comparativaInbi),
            fast: calc(prev.fast, sem.fast),
            metaFast: calc(prev.metaFast, sem.metaFast),
            comparativaFast: calc(prev.comparativaFast, sem.comparativaFast)
          }
        })
        return { _controlInternoDynamic: true, semanas, tendencias, conceptos, fields }
      },

      operacionesClasesComparativaDesdeCalculo () {
        const vacia = { _operacionesClasesDynamic: true, semanas: [], tendencias: [], conceptos: [], fields: [], cicloField: 'ciclo' }
        try {
        /** Meta en la comparativa acumulado «Operaciones - Clases» (solo esta vista). */
        const META_OPERACIONES_CLASES = 100
        const fields = ['inbi', 'metaInbi', 'diferenciaInbi', 'pctCumplimientoInbi', 'fast', 'metaFast', 'diferenciaFast', 'pctCumplimientoFast']
        const conceptos = ['Inbi', 'Meta Inbi', 'Diferencia Inbi', '% cumplimiento Inbi', 'Fast', 'Meta Fast', 'Diferencia Fast', '% cumplimiento Fast']
        const h = (this.historialOperacionesClases || [])
          .filter((row) => row && (row.fast != null || row.inbi != null))
          .sort((a, b) => {
            const fa = String((a && a.fecha_inicio) || '')
            const fb = String((b && b.fecha_inicio) || '')
            if (fa !== fb) return fa.localeCompare(fb)
            const ca = String((a && a.ciclo) || '')
            const cb = String((b && b.ciclo) || '')
            if (ca !== cb) return ca.localeCompare(cb)
            const sa = parseInt(String(a.semana || '0'), 10) || 0
            const sb = parseInt(String(b.semana || '0'), 10) || 0
            return sa - sb
          })
        const pctFila = (idCiclo, semana) => ({
          pctCumplimientoInbi: this.pctMovimientosClases(
            this.movimientosSemanaEscuela(idCiclo, semana, 1),
            this.totalClasesSemanaEscuela(idCiclo, semana, 'inbi')
          ),
          pctCumplimientoFast: this.pctMovimientosClases(
            this.movimientosSemanaEscuela(idCiclo, semana, 2),
            this.totalClasesSemanaEscuela(idCiclo, semana, 'fast')
          )
        })
        const semanas = h.map((row) => {
          const semanaNum = parseInt(String(row.semana || '0'), 10) || 0
          const pct = pctFila(row.id_ciclo, semanaNum)
          return {
            label: this.formatearRangoSemana(row.fecha_inicio, row.fecha_final || row.fecha_fin),
            semana: row.semana != null && row.semana !== '' ? String(row.semana) : null,
            ciclo: row.ciclo != null ? String(row.ciclo) : '',
            inbi: row.inbi != null ? parseFloat(row.inbi) : null,
            metaInbi: META_OPERACIONES_CLASES,
            diferenciaInbi: row.inbi != null ? parseFloat(row.inbi) - META_OPERACIONES_CLASES : null,
            pctCumplimientoInbi: pct.pctCumplimientoInbi,
            fast: row.fast != null ? parseFloat(row.fast) : null,
            metaFast: META_OPERACIONES_CLASES,
            diferenciaFast: row.fast != null ? parseFloat(row.fast) - META_OPERACIONES_CLASES : null,
            pctCumplimientoFast: pct.pctCumplimientoFast
          }
        })
        const actualFast =
          this.clases.porcentaje_correcto_fast != null && this.clases.porcentaje_correcto_fast !== ''
            ? parseFloat(this.clases.porcentaje_correcto_fast)
            : null
        const actualInbi =
          this.clases.porcentaje_correcto_inbi != null && this.clases.porcentaje_correcto_inbi !== ''
            ? parseFloat(this.clases.porcentaje_correcto_inbi)
            : null
        let cicloActualComparativa = ''
        if (this.ciclo && this.ciclo.ciclo) {
          cicloActualComparativa = String(this.ciclo.ciclo)
        } else if (h.length) {
          const hh = h.slice().sort((a, b) =>
            String((a.fecha_final || a.fecha_fin || '')).localeCompare(String((b.fecha_final || b.fecha_fin || '')))
          )
          const ult = hh[hh.length - 1]
          if (ult && ult.ciclo) cicloActualComparativa = String(ult.ciclo)
        }
        const idCicloRol = this.clasesTotalesPorSemana && this.clasesTotalesPorSemana.id_ciclo
        const semActualNum = Number(this.operacionesClasesSemanaActual) || 0
        const pctActualInbi = this.pctMovimientosClases(
          this.movimientosSemanaEscuela(idCicloRol, semActualNum, 1),
          this.clasesInbiTotal
        )
        const pctActualFast = this.pctMovimientosClases(
          this.movimientosSemanaEscuela(idCicloRol, semActualNum, 2),
          this.clasesFastTotal
        )
        semanas.push({
          label: 'Actual',
          semana:
            this.operacionesClasesSemanaActual != null && this.operacionesClasesSemanaActual !== ''
              ? String(this.operacionesClasesSemanaActual)
              : null,
          ciclo: cicloActualComparativa || '',
          inbi: actualInbi,
          metaInbi: META_OPERACIONES_CLASES,
          diferenciaInbi: actualInbi != null ? actualInbi - META_OPERACIONES_CLASES : null,
          pctCumplimientoInbi: pctActualInbi,
          fast: actualFast,
          metaFast: META_OPERACIONES_CLASES,
          diferenciaFast: actualFast != null ? actualFast - META_OPERACIONES_CLASES : null,
          pctCumplimientoFast: pctActualFast
        })
        const calc = (p, c) => (p != null && c != null ? (c > p ? 'up' : c < p ? 'down' : 'equal') : null)
        const vacio = {
          inbi: null, metaInbi: null, diferenciaInbi: null, pctCumplimientoInbi: null,
          fast: null, metaFast: null, diferenciaFast: null, pctCumplimientoFast: null
        }
        const tendencias = semanas.map((sem, idx) => {
          if (idx === 0) return Object.assign({}, vacio)
          const prev = semanas[idx - 1]
          return {
            inbi: calc(prev.inbi, sem.inbi),
            metaInbi: calc(prev.metaInbi, sem.metaInbi),
            diferenciaInbi: calc(prev.diferenciaInbi, sem.diferenciaInbi),
            pctCumplimientoInbi: calc(prev.pctCumplimientoInbi, sem.pctCumplimientoInbi),
            fast: calc(prev.fast, sem.fast),
            metaFast: calc(prev.metaFast, sem.metaFast),
            diferenciaFast: calc(prev.diferenciaFast, sem.diferenciaFast),
            pctCumplimientoFast: calc(prev.pctCumplimientoFast, sem.pctCumplimientoFast)
          }
        })
        return { _operacionesClasesDynamic: true, semanas, tendencias, conceptos, fields, cicloField: 'ciclo' }
        } catch (error) {
          console.log(error)
          return vacia
        }
      },

      abrirDetalleOperacionesClases (escuela) {
        const key = String(escuela || '').toLowerCase() === 'fast' ? 'fast' : 'inbi'
        this.dialogOperacionesClases.escuela = key
        this.dialogOperacionesClases.escuelaLabel = key === 'fast' ? 'Fast' : 'Inbi'
        this.dialogOperacionesClases.detalle = this.clasesDesgloseEscuela[key]
        this.dialogOperacionesClases.estatus = true
      },

      comparativaRowClass (item) {
        if (!item || !this.dialogComparativa || this.dialogComparativa.departamento !== 'Operaciones - %RI') return ''
        return item._esFilaActualRI ? 'fila-actual-ri' : ''
      },

      abrirComparativa(departamento) {
        if (!this.dialogComparativa) return
        this.dialogComparativa.departamento = departamento
        this.dialogComparativa.ciclo = null
        this.dialogComparativaInfo = false
        this.dialogComparativa.estatus = true
      },

      exportarComparativaExcel() {
        const departamento = (this.dialogComparativa && this.dialogComparativa.departamento) ? this.dialogComparativa.departamento : 'comparativa'
        const headers = (this.headersComparativa || []).map(h => ({
          key: h.value,
          label: h.text || h.value
        }))
        const items = this.comparativaTableItems || []

        const dataExport = items.map(item => {
          const row = {}
          headers.forEach(h => {
            let value = item[h.key]
            if (h.key === 'c5' && value && typeof value === 'object' && value.esRI) {
              value = `Fast: ${value.cumpleFast ? 'Sí' : 'No'}, Inbi: ${value.cumpleInbi ? 'Sí' : 'No'}`
            } else if (h.key === 'c6' && value && typeof value === 'object' && value.esMoney) {
              value = `Fast: ${value.cumpleFast ? 'Sí' : 'No'}, Inbi: ${value.cumpleInbi ? 'Sí' : 'No'}`
            } else if (value && typeof value === 'object' && Object.prototype.hasOwnProperty.call(value, 'val')) {
              value = value.val
              if (
                departamento === 'Operaciones - %RI' &&
                (h.key === 'c2' || h.key === 'c4') &&
                value != null &&
                typeof value === 'number'
              ) {
                value = (value > 0 ? '+' : '') + value + '%'
              }
            }
            row[h.label] = value != null ? value : '-'
          })
          return row
        })

        const nombreArchivo = `Comparativa_${departamento}`.replace(/[\\/:*?"<>| ]+/g, '_')
        this.exportarExcelDirecto(dataExport, nombreArchivo)
      },

      abrirFormulaInfo(departamento) {
        const formulas = {
          'Op. Inscritos NI': ['Número de Inscritos (NI) = Cantidad de alumnos inscritos en el ciclo vigente, descontando los cambios de carrera.', 'Se compara contra la meta establecida por escuela (Fast/Inbi).'],
          'Operaciones - %RI': ['% RI = Porcentaje de avance del Recaudo Interno respecto a la meta del ciclo.', 'Meta base: 93%. Se calcula por escuela (Fast/Inbi).'],
          'Operaciones - $$': ['% Avance = Porcentaje de avance de ingresos recaudados respecto a la meta financiera del ciclo.', 'Meta: 100%. Se calcula por escuela (Fast/Inbi).'],
          'RH - %Ocupación': ['% Ocupación = (Vacantes cubiertas / Vacantes totales) × 100.', 'Se muestra por área: Fast, Inbi, Corporativo y General.', 'Meta: ≥ 80% (aceptable), ≥ 70% (medio).'],
          'Comercial': ['Prospectos = Cantidad total de prospectos registrados en el periodo para cada escuela (Fast e Inbi).', 'Es el conteo de prospectos activos.'],
          'Comercial - Conversión': ['% Conversión = (Inscritos / Prospectos) × 100.', 'Indica el porcentaje de prospectos que se convirtieron en inscritos por escuela (Fast/Inbi).'],
          'TI': [
            'Periodo: desde el 1.er ticket activo (estatus 2, 3, 4 o 7) hasta la fecha final del filtro.',
            'IUA = (Resolución × 0.5) + (Velocidad × 0.3) + (Control de Backlog × 0.2)',
            'Resolución = (tickets resueltos / total_tickets) × 100 — resuelto = Respondido (5) o Cerrado (6)',
            'Velocidad = (SLA_objetivo / tiempo_promedio_cierre) × 100, tope 100% — solo Cerrados (6)',
            'Backlog = (1 - (tickets pendientes / total_tickets)) × 100 — pendiente = estatus 2, 3, 4 o 7'
          ],
          'Finanzas': [
            '% Ingresos validados = (suma de ingresos validados ÷ suma de ingresos totales) × 100 (Fast e Inbi).',
            '% Egresos validados = (total validado de egresos ÷ suma de egresos) × 100 (Fast e Inbi).',
            'Los montos y % salen de kpi.finanzas; la comparativa semanal usa el historial del mismo endpoint.'
          ],
          'Operaciones - Clases': [
            '% Cumplimiento = (Clases correctas / Obligaciones) × 100.',
            '% cumplimiento de movimientos = (movimientos guardados en la semana / total de clases de la semana) × 100.',
            'Cada Guardar del rol cuenta como un movimiento, aunque sea permanente.',
            'La comparativa semanal usa el historial guardado (endpoint rol.clases.historial).',
            'La fila «Actual» y la tarjeta usan solo la semana 3 del rol: bloques lu3, ma3, mi3, ju3, vi3 (sin fecha de corte del dashboard).'
          ],
          'Control I. - Procesos': ['% Procesos = Porcentaje de procesos de control interno cumplidos por escuela (Fast/Inbi).'],
          'Mantenimiento': [
            'Periodo: desde el 1.er ticket activo (estatus 2, 3, 4 o 7) hasta la fecha final del filtro.',
            'IUA = (Resolución × 0.5) + (Velocidad × 0.3) + (Control de Backlog × 0.2)',
            'Resolución = (tickets resueltos / total_tickets) × 100 — resuelto = Respondido (5) o Cerrado (6)',
            'Velocidad = (SLA_objetivo / tiempo_promedio_cierre) × 100, tope 100% — solo Cerrados (6)',
            'Backlog = (1 - (tickets pendientes / total_tickets)) × 100 — pendiente = estatus 2, 3, 4 o 7'
          ]
        }
        const items = formulas[departamento] || ['No hay fórmula definida para este departamento.']
        this.dialogFormulaInfo.titulo = departamento
        this.dialogFormulaInfo.items = Array.isArray(items) ? items : [items]
        this.dialogFormulaInfo.estatus = true
      },
      normalizarIngresoFinanzas (registro) {
        if (!registro) return null
        const montoTotal = registro.monto_total != null ? registro.monto_total : registro.total_ingresos
        const montoValido = registro.monto_valido != null ? registro.monto_valido : registro.ingresos_validos
        return {
          id_ciclo: registro.id_ciclo != null ? Number(registro.id_ciclo) : null,
          ciclo: registro.ciclo || '',
          fecha_mas_antigua: registro.fecha_mas_antigua || null,
          monto_total: montoTotal != null ? Number(montoTotal) : 0,
          monto_valido: montoValido != null ? Number(montoValido) : 0,
          porcentaje_validados: registro.porcentaje_validados != null ? Number(registro.porcentaje_validados) : null
        }
      },
      calcularPorcentajeIngresoFinanzas (detalle) {
        if (!detalle) return null
        const total = Number(detalle.monto_total)
        const validos = Number(detalle.monto_valido)
        if (isNaN(total) || isNaN(validos) || total <= 0) return null
        return (validos / total) * 100
      },
      calcularPorcentajeEgresoFinanzas (detalle) {
        if (!detalle) return null
        const total = Number(detalle.egresosTotales)
        const validados = Number(detalle.egresosValidados)
        if (isNaN(total) || isNaN(validados) || total <= 0) return null
        return (validados / total) * 100
      },
      formatearNumero (valor) {
        const n = Number(valor)
        if (isNaN(n)) return '—'
        return n.toLocaleString('es-MX')
      },
      formatearMoneda (valor) {
        const n = Number(valor)
        if (isNaN(n)) return '—'
        return n.toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })
      },
      formatearPorcentaje (valor) {
        const n = Number(valor)
        if (isNaN(n)) return '—'
        return `${n.toFixed(2)}%`
      },
      formatearFechaHora (fecha) {
        if (!fecha) return '—'
        const d = new Date(String(fecha).replace(' ', 'T'))
        if (isNaN(d.getTime())) return String(fecha)
        return d.toLocaleString('es-MX')
      },
      abrirDetalleIngresoFinanzas (escuela) {
        const detalle = escuela === 'Fast'
          ? (this.finanzas && this.finanzas.ingresoDetalleFast)
          : (this.finanzas && this.finanzas.ingresoDetalleInbi)
        this.dialogIngresoFinanzas.escuela = escuela
        this.dialogIngresoFinanzas.detalle = detalle || null
        this.dialogIngresoFinanzas.estatus = true
      },
      abrirDetalleEgresoFinanzas (escuela) {
        const detalle = escuela === 'Fast'
          ? {
              egresosTotales: this.finanzas && this.finanzas.sumaEgresoFast,
              egresosValidados: this.finanzas && this.finanzas.totalValidadoFast
            }
          : {
              egresosTotales: this.finanzas && this.finanzas.sumaEgresoInbi,
              egresosValidados: this.finanzas && this.finanzas.totalValidadoInbi
            }
        this.dialogEgresoFinanzas.escuela = escuela
        this.dialogEgresoFinanzas.detalle = detalle
        this.dialogEgresoFinanzas.estatus = true
      },
      abrirDetalleDiasFinanzas (escuela) {
        const detalle = escuela === 'Fast' ? this.diasTranscurridosFast : this.diasTranscurridosInbi
        this.dialogDiasFinanzas.escuela = escuela
        this.dialogDiasFinanzas.detalle = detalle || null
        this.dialogDiasFinanzas.estatus = true
      },
      async abrirReporteFinanzas () {
        this.dialogReporteFinanzas.estatus = true
        await this.cargarReporteFinanzas()
      },
      async cargarReporteFinanzas () {
        this.dialogReporteFinanzas.cargando = true
        try {
          const response = await this.$http.get('kpi.finanzas.reporte')
          const data = response.data || {}
          const vacio = { detalle: [], totales: {} }
          this.reporteFinanzas = {
            egresos: {
              fast: (data.egresos && data.egresos.fast) || { ...vacio },
              inbi: (data.egresos && data.egresos.inbi) || { ...vacio }
            },
            ingresos: {
              fast: (data.ingresos && data.ingresos.fast) || { ...vacio },
              inbi: (data.ingresos && data.ingresos.inbi) || { ...vacio }
            }
          }
        } catch (error) {
          const msg = (error && error.response && error.response.data && error.response.data.message)
            ? error.response.data.message
            : 'No fue posible cargar el reporte de finanzas.'
          this.validarError(msg)
        } finally {
          this.dialogReporteFinanzas.cargando = false
        }
      },

      initializeComercial(){

        const payload = {
          fechaini: this.fechafin,
          fechafin: this.fechafin,
          escuela : 1
        }

        return this.$http.post("cambiar.prospecto.obtener.prospecto", payload ).then((response) => {
          this.prospectosInbi         = response.data.prospectos;
          this.historialComercial     = response.data.historial || [];
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { })
      },

      initializeComercialFast(){
        const payload = {
          fechaini: this.fechafin,
          fechafin: this.fechafin, // Restarle un día a la fecha de fin
          escuela : 2
        }

        return this.$http.post("cambiar.prospecto.obtener.prospecto", payload ).then((response) => {
          this.prospectosFast         = response.data.prospectos;
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => {  })
      },

      initializeComercialConversion(){
        const payload = {
          fechaini: this.fechafin,
          fechafin: this.fechafin
        }

        return this.$http.post("conversion.comercial.obtener", payload ).then((response) => {
          const d = response.data || {}
          this.comercialConversion = {
            conversionInbi: d.conversionInbi,
            conversionFast: d.conversionFast,
            inscritos_fast: d.inscritos_fast != null ? d.inscritos_fast : d.inscritosFast,
            inscritos_inbi: d.inscritos_inbi != null ? d.inscritos_inbi : d.inscritosInbi
          }
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => {  })
      },

      initializeComercialConversionHistorial(){
        const payload = {
          fechaini: this.fechafin,
          fechafin: this.fechafin
        }

        return this.$http.get("conversion.comercial.semanal", payload ).then((response) => {
          this.historialComercialConversion = response.data.conversionSemanal || [];
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => {  })
      },

      openRhDetalleRequeridos (scope) {
        const map = {
          fast: { alcance: 'Fast', rh: () => this.rhOcupacionFast },
          inbi: { alcance: 'Inbi', rh: () => this.rhOcupacionInbi },
          corpo: { alcance: 'Corporativo', rh: () => this.rhOcupacionCorpo },
          todo: { alcance: 'General', rh: () => this.rhOcupacionTodo }
        }
        const m = map[scope]
        if (!m) return
        const r = m.rh()
        this.vacantes_requeridos = r.desglose || []
        const aut = r.autorizados || []
        const ocu = r.ocupacion || []
        const fal = r.faltantes || []
        this.rhDialogMeta = {
          alcance: m.alcance,
          plazasAutorizadas: aut.length,
          plazasCubiertas: ocu.length,
          plazasSinCubrir: fal.length,
          porcentaje: r.percent_ocupacion
        }
        this.dialogRequeridos = true
      },

      initializeRH(){
        this.vacantesExcelRH = []
        return this.$http.get('organigrama.v2').then(response=>{
          let vacantes = []

        // Obtener las vacantes requeridas
          for( const i in response.data.respuesta ){
            vacantes = vacantes.concat( response.data.respuesta[i].vacantes_requeridos )
          }


          vacantes = vacantes.filter( el => el.plantel )
          

          this.vacantesExcelRH = vacantes
          this.historialRh = response.data.historial


          // rhOcupacionInbi y rhOcupacionFast ( vamos a sacar por el plantel el match para saber si es inbi o fast )
          // Obtener las planteles
          let autorizadosInbi  = vacantes.filter( el => !el.plantel.match('FAST') && el.id_plantel != 13  )
          let autorizadosFast  = vacantes.filter( el => el.plantel.match('FAST') && el.id_plantel != 13 )
          let autorizadosCorpo = vacantes.filter( el => el.id_plantel == 13 )
          let autorizadosTodo = vacantes

          // Ahora scamos los que estan ocupados
          let ocupacionInbi  = vacantes.filter( el => !el.plantel.match('FAST') && el.id_plantel != 13 && el.id_trabajador )
          let ocupacionFast  = vacantes.filter( el => el.plantel.match('FAST') && el.id_plantel != 13 && el.id_trabajador )
          let ocupacionCorpo = vacantes.filter( el => el.id_plantel == 13 && el.id_trabajador )
          let ocupacionTodo = vacantes.filter( el => el.id_trabajador )

          // Ahora sacamos los que faltan
          let faltantesInbi  = vacantes.filter( el => !el.plantel.match('FAST') && el.id_plantel != 13 && !el.id_trabajador )
          let faltantesFast  = vacantes.filter( el => el.plantel.match('FAST') && el.id_plantel != 13 && !el.id_trabajador )
          let faltantesCorpo = vacantes.filter( el => el.id_plantel == 13 && !el.id_trabajador )
          let faltantesTodo = vacantes.filter( el => !el.id_trabajador )

          // ahora sacamos el porcentaje de ocupacion
          let percentOcupacionInbi  = ( ( ocupacionInbi.length / autorizadosInbi.length ) * 100 ).toFixed(2)
          let percentOcupacionFast  = ( ( ocupacionFast.length / autorizadosFast.length ) * 100 ).toFixed(2)
          let percentOcupacionCorpo = ( ( ocupacionCorpo.length / autorizadosCorpo.length ) * 100 ).toFixed(2)
          let percentOcupacionTodo = ( ( ocupacionTodo.length / autorizadosTodo.length ) * 100 ).toFixed(2)

          const buildDesglose = (arr) => {
            const byPuesto = {}
            ;(arr || []).forEach(el => {
              const p = el.puesto || 'Sin puesto'
              if (!byPuesto[p]) byPuesto[p] = { puesto: p, autorizados: 0, activos: 0, vacantes: 0 }
              if (el.requeridos != null && el.activos != null && el.vacantes != null) {
                byPuesto[p].autorizados += Number(el.requeridos)
                byPuesto[p].activos += Number(el.activos)
                byPuesto[p].vacantes += Number(el.vacantes)
              } else {
                byPuesto[p].autorizados += 1
                byPuesto[p].activos += (el.id_trabajador ? 1 : 0)
                byPuesto[p].vacantes += (el.id_trabajador ? 0 : 1)
              }
            })
            return Object.values(byPuesto).map(item => ({
              ...item,
              percent_ocupacion: item.autorizados > 0 ? ((item.activos / item.autorizados) * 100).toFixed(2) : 0
            }))
          }

          this.rhOcupacionInbi  = { percent_ocupacion: percentOcupacionInbi, ocupacion: ocupacionInbi, faltantes: faltantesInbi, autorizados: autorizadosInbi, desglose: buildDesglose(autorizadosInbi) }
          this.rhOcupacionFast  = { percent_ocupacion: percentOcupacionFast, ocupacion: ocupacionFast, faltantes: faltantesFast, autorizados: autorizadosFast, desglose: buildDesglose(autorizadosFast) }
          this.rhOcupacionCorpo = { percent_ocupacion: percentOcupacionCorpo, ocupacion: ocupacionCorpo, faltantes: faltantesCorpo, autorizados: autorizadosCorpo, desglose: buildDesglose(autorizadosCorpo) }
          this.rhOcupacionTodo  = { percent_ocupacion: percentOcupacionTodo, ocupacion: ocupacionTodo, faltantes: faltantesTodo, autorizados: autorizadosTodo, desglose: buildDesglose(autorizadosTodo) }

        }).catch(error=>{
          console.log( error )
          this.validError( error )
        }).finally( () => {  })
      },

      initializeTI(){
        let payload = {
    			fechaini: this.fechafin,
    			fechafin: this.fechafin,
    		}

        return this.$http.post('tickets.ti.reporte', payload).then(response=>{
          const d = response.data || {}
          this.ti = {
            total_tickets: d.total_tickets,
            tickets_resueltos: d.tickets_resueltos,
            tickets_pendientes: d.tickets_pendientes,
            tickets_cerrados: d.tickets_cerrados,
            tickets_abiertos: d.tickets_abiertos,
            sla_objetivo: d.sla_objetivo,
            tiempo_promedio_resolucion: d.tiempo_promedio_resolucion,
            componentes: d.componentes || null,
            periodo: d.periodo || null,
            kpi_ti: d.kpi_ti
          }
          this.historialTI = d.historial || []
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => {  })
      },

      initializeMantenimiento(){
        let payload = {
    			fechaini: this.fechafin,
    			fechafin: this.fechafin,
    		}

        return this.$http.post('tickets.ti.reporte.matenimiento', payload).then(response=>{
          const d = response.data || {}
          this.mantenimiento = {
            total_tickets: d.total_tickets,
            tickets_resueltos: d.tickets_resueltos,
            tickets_pendientes: d.tickets_pendientes,
            tickets_cerrados: d.tickets_cerrados,
            tickets_abiertos: d.tickets_abiertos,
            sla_objetivo: d.sla_objetivo,
            tiempo_promedio_resolucion: d.tiempo_promedio_resolucion,
            componentes: d.componentes || null,
            periodo: d.periodo || null,
            kpi_mantenimiento: d.kpi_mantenimiento != null ? d.kpi_mantenimiento : d.kpi_ti
          }
          this.historialMantenimiento = d.historial || []
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => {  })
      },

    	async initialize(){
        const a = this.kpiAreas
        const tasks = []

        if (a.rh && this.canShowCard('rhOcupacion')) {
          tasks.push(this.runKpiTask('rhOcupacion', async () => {
            await this.initializeRH()
          }))
        }

        if (a.comercial && this.canShowCard('comercialConversion')) {
          tasks.push(this.runKpiTask('comercialConversion', async () => {
            await this.initializeComercial()
            await this.initializeComercialFast()
            await this.initializeComercialConversion()
            await this.initializeComercialConversionHistorial()
          }))
        }

        if (a.ti && this.canShowCard('tiTickets')) {
          tasks.push(this.runKpiTask('tiTickets', async () => {
            await this.initializeTI()
          }))
        }

        if (a.mantenimiento && this.canShowCard('mantenimientoTickets')) {
          tasks.push(this.runKpiTask('mantenimientoTickets', async () => {
            await this.initializeMantenimiento()
          }))
        }

        if (a.finanzas && this.canShowCard('finanzasEgreso')) {
          tasks.push(this.runKpiTask('finanzasEgreso', async () => {
            await this.initializeFinanzas()
            await this.initializeFinanzasDias()
          }))
        }

        if (a.operaciones && this.canShowCard('operacionesMoney')) {
          tasks.push(this.runKpiTask('operacionesMoney', async () => {
            await this.initializeMetamoney()
          }))
        }

        if (a.operaciones && this.canShowCard('operacionesNI')) {
          tasks.push(this.runKpiTask('operacionesNI', async () => {
            await this.initializeOP()
            await this.getHistorialOperacionesNI()
          }))
        }

        if (a.operaciones && this.canShowCard('operacionesRI')) {
          tasks.push(this.runKpiTask('operacionesRI', async () => {
            await this.datosDeRI()
          }))
        }

        if (a.operaciones && this.canShowCard('operacionesClases')) {
          tasks.push(this.runKpiTask('operacionesClases', async () => {
            await this.getHistorialOperacionesClases()
            await this.initializeOperacionesRolClase()
          }))
        }

        if (a.controlInterno && this.canShowCard('controlInternoVentas')) {
          tasks.push(this.runKpiTask('controlInternoVentas', async () => {
            await this.initializeControlInterno()
          }))
        }

        await Promise.all(tasks)
    	},

      async getHistorialOperacionesNI(){
        await this.$http.get('kpi.inscripciones.alumnos.rango.historial').then(response=>{
          this.historialOperacionesNI = response.data || []
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => {  })
      },

      pctMovimientosClases (movimientos, total) {
        const t = Number(total) || 0
        if (!t) return null
        const m = Number(movimientos) || 0
        return Math.round((m / t) * 10000) / 100
      },

      totalClasesSemanaEscuela (idCiclo, semana, escuela) {
        const bag = this.clasesTotalesPorSemana || {}
        if (bag.id_ciclo != null && Number(bag.id_ciclo) === Number(idCiclo)) {
          const sem = Number(semana)
          const escuelaBag = bag[escuela] || {}
          const delCicloActual = Number(escuelaBag[sem]) || 0
          if (delCicloActual) return delCicloActual
        }
        const porCiclo = this.clasesTotalesPorCiclo || {}
        const item = porCiclo[Number(idCiclo)]
        if (!item) return 0
        return Number(item[escuela]) || 0
      },

      movimientosSemanaEscuela (idCiclo, semana, escuelaNum) {
        const rows = this.movimientosRolSemana || []
        for (let i = 0; i < rows.length; i++) {
          const r = rows[i]
          if (Number(r.id_ciclo) === Number(idCiclo) && Number(r.semana) === Number(semana) && Number(r.escuela) === Number(escuelaNum)) {
            return Number(r.total_cambios) || 0
          }
        }
        return 0
      },

      textoCeldaComparativaC5 (item) {
        if (!item || !item.c5 || item.c5.val == null) return '-'
        const dep = this.dialogComparativa && this.dialogComparativa.departamento
        const val = item.c5.val
        if (dep === 'Operaciones - Clases') return Number(val).toFixed(2) + '%'
        if (dep === 'RH - %Ocupación' || dep === 'Finanzas' || dep === 'Control I. - Procesos' || dep === 'Comercial') {
          return Number(val).toFixed(2) + (this.comparativaEsPorcentaje ? '%' : '')
        }
        return val
      },

      cargarMovimientosRolSemana () {
        this.$http.post('rol.kpi.cambios.semana', {}).then(response=>{
          const data = response && response.data
          this.movimientosRolSemana = Array.isArray(data) ? data : []
        }).catch(() => {
          this.movimientosRolSemana = []
        })
      },

      cargarTotalesClasesPorCiclo () {
        this.$http.get('rol.kpi.clases.totales').then(response=>{
          const data = response && response.data
          const rows = Array.isArray(data) ? data : []
          const map = {}
          for (let i = 0; i < rows.length; i++) {
            const row = rows[i]
            map[Number(row.id_ciclo)] = {
              fast: Number(row.fast) || 0,
              inbi: Number(row.inbi) || 0
            }
          }
          this.clasesTotalesPorCiclo = map
        }).catch(() => {
          this.clasesTotalesPorCiclo = {}
        })
      },

      async getHistorialOperacionesClases(){
        this.cargarMovimientosRolSemana()
        this.cargarTotalesClasesPorCiclo()
        await this.$http.get('rol.clases.historial').then(response=>{
          this.historialOperacionesClases = response.data || []
        }).catch( error =>{
          let msg = 'No se pudo cargar el historial de clases'
          if (error && error.response && error.response.data && error.response.data.message) {
            msg = error.response.data.message
          }
          this.validarError(msg)
        }).finally( () => {  })
      },


      async initializeFinanzasDias(){
        await this.$http.get('kpi.ciclos.abiertos').then(response=>{
          const data = response.data || {}
          const ciclosInbi = Array.isArray(data.diasInbi) ? data.diasInbi : []
          const ciclosFast = Array.isArray(data.diasFast) ? data.diasFast : []
          const cicloInbi = ciclosInbi.length ? ciclosInbi[0] : null
          const cicloFast = ciclosFast.length ? ciclosFast[0] : null
          // Compatibilidad temporal con respuesta anterior (arreglo con escuela = 1/2)
          const listaLegacy = Array.isArray(data) ? data : []
          const legacyInbi = listaLegacy.find(el => el.escuela == 1)
          const legacyFast = listaLegacy.find(el => el.escuela == 2)
          this.diasTranscurridosInbi = cicloInbi || legacyInbi || 0
          this.diasTranscurridosFast = cicloFast || legacyFast || 0
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => {  })
      },

      async initializeControlInterno(){
        await this.$http.get('kpi.control.interno').then(response=>{
          this.controlInterno = response.data.respuesta

          this.controlInterno.inbi = this.controlInterno.inbi || 32

          this.historialControlInterno = response.data.historial || []
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => {  })
      },

      async initializeMetamoney(){
        await this.$http.get('kpi.metamoney').then(response=>{
          this.metamoney = response.data

          console.log( this.metamoney )
          this.historialMetaMoney = response.data.historial || []
        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => {  })
      },

      async initializeFinanzas( ){

        try {


          const response    = await this.$http.get('kpi.finanzas');

          const resIngresos = await this.$http.get('kpi.finanzas.ingresos');

          // Conversión a moneda
          const d = response.data || {}
          const ingresosData = (resIngresos && resIngresos.data) ? resIngresos.data : {}
          const ingresoInbi = this.normalizarIngresoFinanzas(ingresosData.avanceInbi || null)
          const ingresoFastRaw = Array.isArray(ingresosData.avanceFast) ? ingresosData.avanceFast[0] : ingresosData.avanceFast
          const ingresoFast = this.normalizarIngresoFinanzas(ingresoFastRaw || null)

          this.finanzas = {
            egresoInbi: d.egresoValidadoInbi,
            egresoFast: d.egresoValidadoFast,
            finanzas_historial: d.historial || [],
            totalValidadoInbi: d.totalValidadoInbi,
            sumaEgresoInbi: d.sumaEgresoInbi,
            totalValidadoFast: d.totalValidadoFast,
            sumaEgresoFast: d.sumaEgresoFast,
            sumaIngresosValidadosInbi: d.sumaIngresosValidadosInbi,
            sumaIngresoInbi: d.sumaIngresoInbi,
            sumaIngresosValidadosFast: d.sumaIngresosValidadosFast,
            sumaIngresoFast: d.sumaIngresoFast,
            ingresoValidadoInbi: ingresoInbi && ingresoInbi.porcentaje_validados != null ? `${ingresoInbi.porcentaje_validados}%` : d.ingresoValidadoInbi,
            ingresoValidadoFast: ingresoFast && ingresoFast.porcentaje_validados != null ? `${ingresoFast.porcentaje_validados}%` : d.ingresoValidadoFast,
            ingresoDetalleInbi: ingresoInbi,
            ingresoDetalleFast: ingresoFast
          }

        } catch (error) {
          // 🔹 8. Manejo seguro del error (sin optional chaining)
          let msg = 'Ocurrió un error al procesar el archivo. Intente de nuevo.';

          if (
            error &&
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            msg = error.response.data.message;
          }

          this.validarError(msg);

        } finally {
          // 🔹 9. Apagamos el loader siempre
          // this.cargar = false;
        }

      },

      // Conversión a moneda mexicana
      convertirMoneda( monto ){
        return monto.toLocaleString('es-MX', { style: 'currency', currency: 'MXN' })
      },

      async initializeOperaciones(){
        await this.getSemanaCicloActualYProximo()
        await this.initializeOP()
        await this.datosDeRI( )
      },

      initializeOP () {
        var payload = { fechaini: this.fechafin, escuela: 1 }

        return this.$http.post('kpi.ventasmomento.reporte', payload ).then(response=>{
          this.metas                  = response.data.metas
          this.id_ciclo               = response.data.id_ciclo
          this.id_ciclo_relacionado   = response.data.id_ciclo_relacionado
          this.ciclo                  = response.data.ciclo
         
          /*this.cargar = false*/
          this.getInscritos( )


        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => { /*this.cargar = false*/ })
      },

      async datosDeRI() {

        const payload = {"cicloPre":{"id_ciclo":461,"ciclo":"CICLO 08_26","fecha_inicio_ciclo":"2026-08-17 00:00:00","fecha_fin_ciclo":"2026-09-13 00:00:00","comentarios":"","fecha_alta":"2026-05-15 18:03:08","activo_sn":1,"fecha_baja":null,"id_usuario_ultimo_cambio":28,"fecha_ultimo_cambio":"2026-09-09 17:06:59","ciclo_abierto_sn":1,"id_ciclo_relacionado":462,"activo_ventas":0,"costo_adultos":0,"costo_online":0,"meta":null,"fecha_cierre":null,"abierto":1,"semana1":1.54,"semana2":15.6,"semana3":21.87,"semana4":33.3,"semana5":27.7,"semana6":null},"cicloAct":{"id_ciclo":463,"ciclo":"CICLO 09_26","fecha_inicio_ciclo":"2026-09-14 00:00:00","fecha_fin_ciclo":"2026-10-11 00:00:00","comentarios":"","fecha_alta":"2026-05-15 18:06:02","activo_sn":1,"fecha_baja":null,"id_usuario_ultimo_cambio":3110,"fecha_ultimo_cambio":"2026-09-26 11:28:07","ciclo_abierto_sn":1,"id_ciclo_relacionado":464,"activo_ventas":0,"costo_adultos":0,"costo_online":0,"meta":null,"fecha_cierre":null,"abierto":1,"semana1":1.54,"semana2":15.6,"semana3":27.87,"semana4":33.3,"semana5":27.7,"semana6":null},"cicloSig":{"id_ciclo":465,"ciclo":"CICLO 10_26","fecha_inicio_ciclo":"2026-10-12 00:00:00","fecha_fin_ciclo":"2026-11-08 00:00:00","comentarios":"","fecha_alta":"2026-05-15 18:08:51","activo_sn":1,"fecha_baja":null,"id_usuario_ultimo_cambio":28,"fecha_ultimo_cambio":"2026-05-29 12:34:58","ciclo_abierto_sn":1,"id_ciclo_relacionado":466,"activo_ventas":1,"costo_adultos":0,"costo_online":0,"meta":null,"fecha_cierre":null,"abierto":1,"semana1":null,"semana2":null,"semana3":null,"semana4":null,"semana5":null,"semana6":null}}

        await this.$http.post('kpi.cantactual', payload ).then(response=>{
          const d = response.data || {}
          this.resultadoRi = d
          this.resultadoRiFiltro = this.resultadoRi.riPlantelesInbi
          this.historialInscripciones = Array.isArray(d.historialInscripciones) ? d.historialInscripciones : []

        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => {  })
      },

      async initializeOperacionesRolClase(){
        const historial = Array.isArray(this.historialOperacionesClases) ? this.historialOperacionesClases : []
        const historialOrdenado = [...historial].sort((a, b) =>
          String((a && (a.fecha_final || a.fecha_fin)) || '').localeCompare(String((b && (b.fecha_final || b.fecha_fin)) || ''))
        )
        const ultimoHistorial = historialOrdenado.length ? historialOrdenado[historialOrdenado.length - 1] : null
        const idCicloPayload = 463
        let payload = {"id_ciclo":463,"ciclo":"CICLO 09_26","fecha_inicio_ciclo":"2026-09-14 00:00:00","fecha_fin_ciclo":"2026-10-11 00:00:00","comentarios":"","fecha_alta":"2026-05-15 18:06:02","activo_sn":1,"fecha_baja":null,"id_usuario_ultimo_cambio":3110,"fecha_ultimo_cambio":"2026-09-26 11:28:07","ciclo_abierto_sn":1,"id_ciclo_relacionado":464,"activo_ventas":0,"costo_adultos":0,"costo_online":0,"meta":null,"fecha_cierre":null,"abierto":1,"semana1":1.54,"semana2":15.6,"semana3":27.87,"semana4":33.3,"semana5":27.7,"semana6":null}

        await this.$http.post('rol.clases', payload ).then(response=>{
          const rol = (response.data && response.data.respuesta) ? response.data.respuesta : []

          console.log(rol.map((registro) => { return registro.grupo }))
          /** Solo semana 3 (lu3, ma3, mi3, ju3, vi3). No se usa fechafin ni fechaCorte. */
          const SEMANA_KPI_CLASES = 3

          const baseEscuela = () => ({
            semanal: {
              1: { total: 0, faltas: 0 },
              2: { total: 0, faltas: 0 },
              3: { total: 0, faltas: 0 },
              4: { total: 0, faltas: 0 }
            },
            detalleSemana3: {
              entreSemana: { total: 0, online: 0, teens: 0, adultos: 0 },
              sabatinas: 0,
              dominicales: 0,
              totalContabilizadas: 0,
              correctas: 0,
              incorrectas: 0,
              omitidos: {
                total: 0,
                grupos: []
              }
            }
          })
          const acum = { fast: baseEscuela(), inbi: baseEscuela() }
          const toPctCumplimiento = (faltas, total) => {
            if (!total) return 0
            const correctas = total - faltas
            return Number(((correctas / total) * 100).toFixed(2))
          }
          /**
           * FAST vs Inbi (KPI Operaciones - Clases): solo el texto de `grupo` del rol.
           * Si contiene "FAST" → fast; el resto → inbi. No se usa unidad_negocio (no viene en este endpoint).
           */
          const escuelaFromRow = (row) => {
            return row.grupo.match('FAST') ? 'fast' : 'inbi'
          }
          const tipoEntreSemana = (grupo) => {
            const nombre = String(grupo || '').toUpperCase()
            if (nombre.includes('ONLINE')) return 'online'
            if (nombre.includes('TEENS')) return 'teens'
            return 'adultos'
          }
          /** Grupos de apoyo no entran al KPI Operaciones - Clases. */
          const esGrupoApoyo = (row) => /APOYO/i.test(String((row && row.grupo) || ''))

          this.operacionesClasesSemanaActual = SEMANA_KPI_CLASES

          const debugClases = {
            payload: { id_ciclo: idCicloPayload },
            totalFilasRol: rol.length,
            porIdUnidadNegocio: {},
            filasPorEscuela: { fast: 0, inbi: 0, sinClasificar: 0 },
            fastBloquesPorSemana: { 1: 0, 2: 0, 3: 0, 4: 0 },
            fastBloquesSinOficial: 0,
            fastMuestraGrupos: [],
            inbiMuestraUnidadDistinta: []
          }
          for (const row of rol) {
            if (!row || row.deleted == 1) continue
            if (esGrupoApoyo(row)) continue
            const rawU = row.id_unidad_negocio != null && row.id_unidad_negocio !== ''
              ? row.id_unidad_negocio
              : row.unidad_negocio
            const keyU = rawU == null || rawU === '' ? '(vacío)' : String(rawU)
            debugClases.porIdUnidadNegocio[keyU] = (debugClases.porIdUnidadNegocio[keyU] || 0) + 1
          }

          for (const row of rol) {
            if (!row || row.deleted == 1) continue
            if (esGrupoApoyo(row)) continue
            const escuela = escuelaFromRow(row)
            console.log( escuela )
            if (!escuela) {
              debugClases.filasPorEscuela.sinClasificar++
              continue
            }
            debugClases.filasPorEscuela[escuela]++
            if (escuela === 'fast' && debugClases.fastMuestraGrupos.length < 8) {
              debugClases.fastMuestraGrupos.push({
                grupo: row.grupo,
                plantel: row.plantel,
                id_unidad_negocio: row.id_unidad_negocio,
                unidad_negocio: row.unidad_negocio,
                id_escuela: row.id_escuela != null ? row.id_escuela : row.escuela
              })
            }
            if (escuela === 'inbi' && debugClases.inbiMuestraUnidadDistinta.length < 5) {
              const u = row.id_unidad_negocio != null && row.id_unidad_negocio !== '' ? row.id_unidad_negocio : row.unidad_negocio
              if (u != null && u !== '' && u != 1 && String(u) !== '1') {
                debugClases.inbiMuestraUnidadDistinta.push({
                  grupo: (row.grupo || '').toString().slice(0, 60),
                  id_unidad_negocio: row.id_unidad_negocio,
                  unidad_negocio: row.unidad_negocio
                })
              }
            }
            const checks = construirChequeosOficialesKpi(row)
            const bloques = agruparChequeosSabDomNoTeensKpi(row, checks)
            const estadoClase = {
              sabado: { aplica: false, falta: false },
              domingo: { aplica: false, falta: false }
            }
            const detalleEscuela = acum[escuela].detalleSemana3
            const tipo = tipoEntreSemana(row.grupo)
            const bloquesSemana3 = bloques.filter((b) => {
              const semanaBloque = b.modo === 'single' ? semanaDesdeSlotKpi(b.slot) : Number(b.semana)
              return semanaBloque === SEMANA_KPI_CLASES
            })
            const bloquesPorDia = { lunes: [], martes: [], miercoles: [], jueves: [], viernes: [], sabado: [], domingo: [] }
            for (const b of bloquesSemana3) {
              if (bloquesPorDia[b.dia]) bloquesPorDia[b.dia].push(b)
              if (escuela === 'fast') debugClases.fastBloquesPorSemana[SEMANA_KPI_CLASES]++
            }
            const claseEsIncorrecta = (bloquesDia) => {
              if (!Array.isArray(bloquesDia) || !bloquesDia.length) return true
              return bloquesDia.some((b) => {
                const oficial = campoOficialKpi(row, b.tf)
                if (!oficial) {
                  if (escuela === 'fast') debugClases.fastBloquesSinOficial++
                  return true
                }
                if (b.modo === 'single') return idNumKpi(row[b.slot]) !== oficial
                return (b.slots || []).some((slot) => idNumKpi(row[slot]) !== oficial)
              })
            }
            const registrarClase = (esIncorrecta, tipoDia) => {
              detalleEscuela.totalContabilizadas += 1
              acum[escuela].semanal[SEMANA_KPI_CLASES].total += 1
              if (tipoDia === 'entreSemana') {
                detalleEscuela.entreSemana.total += 1
                detalleEscuela.entreSemana[tipo] += 1
              } else if (tipoDia === 'sabado') {
                detalleEscuela.sabatinas += 1
              } else if (tipoDia === 'domingo') {
                detalleEscuela.dominicales += 1
              }
              if (esIncorrecta) {
                acum[escuela].semanal[SEMANA_KPI_CLASES].faltas += 1
                detalleEscuela.incorrectas += 1
              } else {
                detalleEscuela.correctas += 1
              }
            }

            if (row.lunes == 1) registrarClase(claseEsIncorrecta(bloquesPorDia.lunes), 'entreSemana')
            if (row.martes == 1) registrarClase(claseEsIncorrecta(bloquesPorDia.martes), 'entreSemana')
            if (row.miercoles == 1) registrarClase(claseEsIncorrecta(bloquesPorDia.miercoles), 'entreSemana')
            if (row.jueves == 1) registrarClase(claseEsIncorrecta(bloquesPorDia.jueves), 'entreSemana')
            if (row.viernes == 1) registrarClase(claseEsIncorrecta(bloquesPorDia.viernes), 'entreSemana')
            if (row.sabado == 1) registrarClase(claseEsIncorrecta(bloquesPorDia.sabado), 'sabado')
            if (row.domingo == 1) registrarClase(claseEsIncorrecta(bloquesPorDia.domingo), 'domingo')
          }

          console.log('[KPI Operaciones Clases] DEBUG clasificación + bloques (semana KPI = %s)', SEMANA_KPI_CLASES, debugClases)
          console.log('[KPI Operaciones Clases] DEBUG acum semana 3 (solo conteo KPI)', {
            fast: acum.fast.semanal[SEMANA_KPI_CLASES],
            inbi: acum.inbi.semanal[SEMANA_KPI_CLASES],
            pctFast: toPctCumplimiento(acum.fast.semanal[SEMANA_KPI_CLASES].faltas, acum.fast.semanal[SEMANA_KPI_CLASES].total)
          })
          this.clasesComparativaSemanal = {
            fast: {
              1: toPctCumplimiento(acum.fast.semanal[1].faltas, acum.fast.semanal[1].total),
              2: toPctCumplimiento(acum.fast.semanal[2].faltas, acum.fast.semanal[2].total),
              3: toPctCumplimiento(acum.fast.semanal[3].faltas, acum.fast.semanal[3].total),
              4: toPctCumplimiento(acum.fast.semanal[4].faltas, acum.fast.semanal[4].total)
            },
            inbi: {
              1: toPctCumplimiento(acum.inbi.semanal[1].faltas, acum.inbi.semanal[1].total),
              2: toPctCumplimiento(acum.inbi.semanal[2].faltas, acum.inbi.semanal[2].total),
              3: toPctCumplimiento(acum.inbi.semanal[3].faltas, acum.inbi.semanal[3].total),
              4: toPctCumplimiento(acum.inbi.semanal[4].faltas, acum.inbi.semanal[4].total)
            }
          }
          this.clasesFastTotal = acum.fast.semanal[SEMANA_KPI_CLASES].total
          this.clasesInbiTotal = acum.inbi.semanal[SEMANA_KPI_CLASES].total
          const totalFastSemana = this.clasesFastTotal
          const totalInbiSemana = this.clasesInbiTotal
          this.clasesTotalesPorSemana = {
            id_ciclo: idCicloPayload,
            fast: { 1: totalFastSemana, 2: totalFastSemana, 3: totalFastSemana, 4: totalFastSemana },
            inbi: { 1: totalInbiSemana, 2: totalInbiSemana, 3: totalInbiSemana, 4: totalInbiSemana }
          }
          this.clasesFastCorrectas = acum.fast.semanal[SEMANA_KPI_CLASES].total - acum.fast.semanal[SEMANA_KPI_CLASES].faltas
          this.clasesInbiCorrectas = acum.inbi.semanal[SEMANA_KPI_CLASES].total - acum.inbi.semanal[SEMANA_KPI_CLASES].faltas
          this.clases.porcentaje_correcto_fast = toPctCumplimiento(acum.fast.semanal[SEMANA_KPI_CLASES].faltas, acum.fast.semanal[SEMANA_KPI_CLASES].total)
          this.clases.porcentaje_correcto_inbi = toPctCumplimiento(acum.inbi.semanal[SEMANA_KPI_CLASES].faltas, acum.inbi.semanal[SEMANA_KPI_CLASES].total)
          this.clasesDesgloseEscuela.fast = { ...acum.fast.detalleSemana3 }
          this.clasesDesgloseEscuela.inbi = { ...acum.inbi.detalleSemana3 }

        }).catch( error =>{
          this.validarError( error.response.data.message )
        }).finally( () => {  })
      },

      async getSemanaCicloActualYProximo () {
        this.dialogCarga = true
        await this.$http.get('kpi.dias.restantes.para.inscribirse')
        .then(response=>{

          this.segundaSemanaCicloActual   = this.sumarDias( response.data.inicio_ciclo_actual, 7 )
          this.segundoDomingoCicloProximo =  this.sumarDias( response.data.inicio_ciclo_siguiente, 7 )

          this.dialogCarga = false
        }).catch(error=>{console.log(error)})
      },

      sumarDias(fecha, dias) {
        const f = new Date(fecha);         // convertir a Date
        f.setDate(f.getDate() + dias);     // sumar los días
        return f;                          // devuelve un objeto Date
      },

      formatFecha(fecha) {
        if (!fecha) return '';

        const meses = [
          'enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio',
          'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'
        ];

        const f = new Date(fecha);
        const dia = f.getDate().toString().padStart(2, '0');
        const mes = meses[f.getMonth()];

        return `${dia} de ${mes}`;
      },

      diasFaltantes(fechaObjetivo) {
        const hoy = new Date();
        const objetivo = new Date(fechaObjetivo);

        const diffMs = objetivo - hoy; // diferencia en milisegundos
        const dias = Math.ceil(diffMs / (1000 * 60 * 60 * 24));

        return dias;
      },

      getInscritos () {
        this.dialogCarga = true
        this.$http.get('kpi.inscripciones.total.fast/' + this.id_ciclo_relacionado).then(response=>{
          this.dataTablaFastUno = response.data
          
          let metaTotal = 0
          let hayFast = 0
          let totalContactos = 0
          let total_completos = 0
          let total_incompletos = 0
          let total_merca = 0
          let total_sucursal = 0

          for( const i in this.dataTablaFastUno ){

            const { id_plantel, total } = this.dataTablaFastUno[i]

            const existeMeta = this.metas.find( el => el.id_plantel == id_plantel )

            let meta = existeMeta ? existeMeta.meta : 0

            metaTotal += meta
            hayFast   += total

            let faltan = meta - total
            this.dataTablaFastUno[i]['faltan'] = faltan
            this.dataTablaFastUno[i]['meta'] = meta

          }

          // Ordenar el arreglo por la propiedad 'total' de forma descendente (mayor a menor)
          this.dataTablaFastUno.sort((a, b) => b.total - a.total);

          // Asignar una posición ('rank') a cada plantel basada en su posición en el arreglo ordenado
          this.dataTablaFastUno.forEach((plantel, index) => {
            plantel.position = index + 1; // La posición comienza en 1
            totalContactos += plantel.totalContactos
            total_completos += plantel.total_completos
            total_incompletos += plantel.total_incompletos
            total_merca += plantel.total_merca
            total_sucursal += plantel.total_sucursal
          });


          var payload = {
            plantel: 'Total',
            total: 0,
            total_fuera_ciclo: 0,
            total_completos: 0,
            total_incompletos: 0,
            total_sucursal: 0,
            total_merca: 0,
            prospectos: [],
            vendedoras: [],
            completos: [],
            incompletos: [],
            merca: [],
            sucursal: [],
          }

          // console.clear()

          let vendedorasCompletas = []

          for(const i in this.dataTablaFastUno){

            const { vendedoras } = this.dataTablaFastUno[i]

            vendedorasCompletas = vendedorasCompletas.concat( vendedoras )

            let total_fuera_ciclo = 0
            if( this.dataTablaFastUno[i].quienVendio ){

              // Sumar total quien vendio
              this.dataTablaFastUno[i].quienVendio.map( q => {
                total_fuera_ciclo += +q.total_registros_diferente_ciclo
              })
              
              this.dataTablaFastUno[i].total_fuera_ciclo= total_fuera_ciclo

            }
            
            payload.total += this.dataTablaFastUno[i].total
            payload.total_fuera_ciclo += +total_fuera_ciclo
            payload.total_completos += this.dataTablaFastUno[i].total_completos
            payload.total_incompletos += this.dataTablaFastUno[i].total_incompletos
            payload.total_sucursal += this.dataTablaFastUno[i].total_sucursal
            payload.total_merca += this.dataTablaFastUno[i].total_merca
            payload.prospectos.push( ...this.dataTablaFastUno[i].prospectos )
            // payload.vendedoras.push( this.dataTablaFastUno[i].vendedoras )
            payload.completos.push( ...this.dataTablaFastUno[i].completos )
            payload.incompletos.push( ...this.dataTablaFastUno[i].incompletos )
            payload.merca.push( ...this.dataTablaFastUno[i].merca )
            payload.sucursal.push( ...this.dataTablaFastUno[i].sucursal )
          }

          // Sacar vendedoras unicas y retornar un arreglo de objetos con el nombre_completo y el total_contactos, y luegoooo el campo total_contactos, se debe ir sumando por vendedora
          const vendedorasUnicas = [...new Set(vendedorasCompletas.map(v => v.nombre_completo))]
          let vendedorasUnicasObjetos = []
          for( const i in vendedorasUnicas ){
            vendedorasUnicasObjetos.push({ 
              nombre_completo: vendedorasUnicas[i], 
              total_contactos: vendedorasCompletas.filter(v => v.nombre_completo == vendedorasUnicas[i]).reduce((prev, curr) => prev + curr.total_contactos, 0), 
              usuario_asignado: vendedorasCompletas.find(v => v.nombre_completo == vendedorasUnicas[i]).usuario_asignado
            })
          }

          // this.totalFast =  payload.total
          this.dataTablaFastUno.push({...payload,
            totalContactos,
            total_completos,
            total_incompletos,
            total_merca,
            total_sucursal,
            faltan: metaTotal - hayFast,
            meta: metaTotal,
            vendedoras: vendedorasUnicasObjetos
          })
          
            

          totalContactos = 0;
          total_completos=0
          total_incompletos=0
          total_merca=0
          total_sucursal=0

          this.$http.get('kpi.inscripciones.total.inbi/' + this.id_ciclo).then(response=>{

            this.dataTablaInbiUno = response.data

            let metaTotalI = 0
            let faltanTotalI = 0
            let hayFastI = 0
            let vendedorasCompletasInbi = []

            for( const i in this.dataTablaInbiUno ){

              const { id_plantel, total } = this.dataTablaInbiUno[i]

              const existeMeta = this.metas.find( el => el.id_plantel == id_plantel )

              let meta = existeMeta ? existeMeta.meta : 0

              metaTotalI += meta
              hayFastI   += total

              let faltan = meta - total
              this.dataTablaInbiUno[i]['faltan'] = faltan
              this.dataTablaInbiUno[i]['meta'] = meta
            }

            // Ordenar el arreglo por la propiedad 'total' de forma descendente (mayor a menor)
            this.dataTablaInbiUno.sort((a, b) => b.total - a.total);

            // Asignar una posición ('rank') a cada plantel basada en su posición en el arreglo ordenado
            this.dataTablaInbiUno.forEach((plantel, index) => {
              plantel.position = index + 1; // La posición comienza en 1
              totalContactos += plantel.totalContactos
              total_completos += plantel.total_completos
              total_incompletos += plantel.total_incompletos
              total_merca += plantel.total_merca
              total_sucursal += plantel.total_sucursal
            });


            var payload = {
              plantel: 'Total',
              total:0,
              total_fuera_ciclo: 0,
              total_completos:0,
              total_incompletos:0,
              total_sucursal: 0,
              total_merca: 0,
              prospectos: [],
              completos: [],
              incompletos: [],
              merca: [],
              sucursal: [],
            }
            for(const i in this.dataTablaInbiUno){

              const { vendedoras } = this.dataTablaInbiUno[i]

              vendedorasCompletasInbi = vendedorasCompletasInbi.concat( vendedoras )

              let total_fuera_ciclo = 0
              if( this.dataTablaInbiUno[i].quienVendio ){

                // Sumar total quien vendio
                this.dataTablaInbiUno[i].quienVendio.map( q => {
                  total_fuera_ciclo += +q.total_registros_diferente_ciclo
                })
                
                this.dataTablaInbiUno[i].total_fuera_ciclo= total_fuera_ciclo

              }


              payload.total += this.dataTablaInbiUno[i].total
              payload.total_fuera_ciclo += +total_fuera_ciclo
              payload.total_completos += this.dataTablaInbiUno[i].total_completos
              payload.total_incompletos += this.dataTablaInbiUno[i].total_incompletos
              payload.total_sucursal += this.dataTablaInbiUno[i].total_sucursal
              payload.total_merca += this.dataTablaInbiUno[i].total_merca
              payload.prospectos.push( ...this.dataTablaInbiUno[i].prospectos )
              payload.completos.push( ...this.dataTablaInbiUno[i].completos )
              payload.incompletos.push( ...this.dataTablaInbiUno[i].incompletos )
              payload.merca.push( ...this.dataTablaInbiUno[i].merca )
              payload.sucursal.push( ...this.dataTablaInbiUno[i].sucursal )
            }

            // Sacar vendedoras unicas y retornar un arreglo de objetos con el nombre_completo y el total_contactos, y luegoooo el campo total_contactos, se debe ir sumando por vendedora
            const vendedorasUnicasInbi = [...new Set(vendedorasCompletasInbi.map(v => v.nombre_completo))]
            let vendedorasUnicasObjetosInbi = []
            for( const i in vendedorasUnicasInbi ){
              vendedorasUnicasObjetosInbi.push({ 
                nombre_completo: vendedorasUnicasInbi[i], 
                total_contactos: vendedorasCompletasInbi.filter(v => v.nombre_completo == vendedorasUnicasInbi[i]).reduce((prev, curr) => prev + curr.total_contactos, 0), 
                usuario_asignado: vendedorasCompletasInbi.find(v => v.nombre_completo == vendedorasUnicasInbi[i]).usuario_asignado
              })
            }
            // this.totalInbi =  payload.total
            this.dataTablaInbiUno.push({...payload,
              totalContactos,
              total_completos,
              total_incompletos,
              total_merca,
              total_sucursal,
              faltan: metaTotalI - hayFastI, meta: metaTotalI,
              vendedoras: vendedorasUnicasObjetosInbi
            })
            this.dialogCarga = false
          }).catch(error=>{console.log(error)})
        }).catch(error=>{console.log(error)})
      },

      abrirDialog( value ){
        this.alumnos = value
        this.dialogAlumnos = true
      },

      exportar(){
        this.exportarData()
      },

      s2ab2(s) {
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
        return buf;
      },

    },
  }
</script>

<style scoped>
.reporte-finanzas-tabla th {
  white-space: nowrap;
  font-weight: 700;
  background-color: #f5f5f5;
}
.reporte-finanzas-tabla td {
  white-space: nowrap;
  font-size: 0.8rem;
}
.reporte-finanzas-total td {
  background-color: #e8eaf6;
  border-top: 2px solid #3949ab;
}
.card-title-responsive {
  font-size: clamp(0.75rem, 2.5vw + 0.5rem, 1.35rem);
  line-height: 1.5;
  white-space: normal;
  word-break: break-word;
  text-align: center;
  display: inline-flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: center;
  gap: 4px;
}
.card-title-responsive .v-icon {
  flex-shrink: 0;
}
.v-system-bar.card-system-bar {
  flex-wrap: wrap;
  padding: 8px 12px;
  align-items: center;
  justify-content: center;
  min-height: 44px;
  height: auto !important;
}
.v-system-bar.card-system-bar .card-title-responsive {
  max-width: 100%;
}
.ocupacion-card {
  width: 100%;
  max-width: 100%;
  aspect-ratio: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
.ocupacion-row {
  width: 70%;
  max-width: 80%;
}
.ocupacion-col {
  padding: 10px !important;
}
.ocupacion-label {
  margin-top: 6px;
  font-size: 0.85rem;
  white-space: nowrap;
  text-align: center;
  min-height: 1.2em;
}
.kpi-spacer-placeholder {
  visibility: hidden;
  line-height: 0;
}
.ti-kpi-pct-y-semaforo {
  width: 100%;
  gap: 14px;
}
/* Card del % compacta (no ocupa todo el ancho de la KPI). */
.ti-kpi-pct-card {
  flex: 0 1 auto;
  width: fit-content;
  max-width: min(220px, 72%);
  min-width: 7.5rem;
}
.ti-semaforo-fila {
  gap: 12px;
  margin-top: 12px;
  flex-wrap: nowrap;
}
/* Semáforo TI al costado de la card: tres luces en columna (rojo → amarillo → verde). */
.ti-semaforo-columna--lateral {
  flex-shrink: 0;
  gap: 10px;
}
.ti-semaforo-dot {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  opacity: 0.35;
  transition: opacity 0.2s, transform 0.2s;
  flex-shrink: 0;
}
.ti-semaforo-dot--activo {
  opacity: 1;
  transform: scale(1.12);
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.4);
}
/* Semáforo horizontal (debajo del indicador en cada columna). */
.kpi-semaforo-h {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 10px;
  flex-wrap: nowrap;
  width: 100%;
}
.kpi-semaforo-h__dot {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  opacity: 1;
  background-color: #9e9e9e !important;
  transition: transform 0.2s, box-shadow 0.2s, background-color 0.2s;
  flex-shrink: 0;
}
.kpi-semaforo-h__dot--activo {
  opacity: 1;
  transform: scale(1.16);
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.45);
}

/* Solo el foco activo conserva color; los demás permanecen en gris */
.kpi-semaforo-h__dot--activo:nth-child(1) {
  background-color: #ff1f1f !important;
}
.kpi-semaforo-h__dot--activo:nth-child(2) {
  background-color: #ffd400 !important;
}
.kpi-semaforo-h__dot--activo:nth-child(3) {
  background-color: #00c853 !important;
}
.kpi-semaforo-h--placeholder .kpi-semaforo-h__dot {
  opacity: 0.45;
}
/* Pie de mini-card (Op. Inscritos NI, Operaciones - %RI, Operaciones - $$): semáforo bajo los textos. */
.kpi-card-semaforo-actions {
  margin-top: auto;
  padding-top: 12px;
  margin-bottom: 0;
  border-top: thin solid rgba(0, 0, 0, 0.08);
}
/* RH / Comercial / Finanzas: una fila con 2 semáforos (Fast | Inbi) al pie del bloque de métricas. */
.kpi-dept-semaforo-row {
  margin-top: 4px;
  padding-top: 10px;
  border-top: thin solid rgba(0, 0, 0, 0.08);
}
/* Operaciones - Clases, Control I., Mantenimiento: semáforo debajo del texto de la métrica. */
.kpi-mini-semaforo-bajo-texto {
  margin-top: 8px;
  padding-top: 8px;
  width: 100%;
  justify-content: center;
  border-top: thin solid rgba(0, 0, 0, 0.06);
}
.gauge-markers-wrap {
  position: relative;
  width: 160px;
  height: 160px;
  margin: 0 auto;
}
.gauge-marker {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 5px;
  height: 15px;
  background-color: #1e88e5;
  border-radius: 999px;
  z-index: 4;
  pointer-events: none;
}

.comparativa-ni-inbi,
.comparativa-ni-fast {
  display: inline-flex;
  align-items: center;
  gap: 2px;
}

/* Op. Inscritos NI: Inbi + Meta Inbi + Diferencia Inbi = azul; Fast + Meta Fast + Diferencia Fast = rojo
   Orden de columnas: Periodo(1), Ciclo(2), Semana(3), Inbi(4), Meta Inbi(5), Dif. Inbi(6), Fast(7), Meta Fast(8), Dif. Fast(9) */
.comparativa-ni-color-celdas ::v-deep thead th:nth-child(4),
.comparativa-ni-color-celdas ::v-deep thead th:nth-child(5),
.comparativa-ni-color-celdas ::v-deep thead th:nth-child(6),
.comparativa-ni-color-celdas ::v-deep tbody td:nth-child(4),
.comparativa-ni-color-celdas ::v-deep tbody td:nth-child(5),
.comparativa-ni-color-celdas ::v-deep tbody td:nth-child(6) {
  background-color: #e3f2fd;
}

.comparativa-ni-color-celdas ::v-deep thead th:nth-child(7),
.comparativa-ni-color-celdas ::v-deep thead th:nth-child(8),
.comparativa-ni-color-celdas ::v-deep thead th:nth-child(9),
.comparativa-ni-color-celdas ::v-deep tbody td:nth-child(7),
.comparativa-ni-color-celdas ::v-deep tbody td:nth-child(8),
.comparativa-ni-color-celdas ::v-deep tbody td:nth-child(9) {
  background-color: #ffebee;
}

/* Operaciones - %RI: Periodo(1), Ciclo(2), Semana(3), Inbi(4)+Meta(5)+Dif(6)=azul; Fast(7)+Meta(8)+Dif(9)=rojo */
.comparativa-ri-color-celdas ::v-deep thead th:nth-child(1),
.comparativa-ri-color-celdas ::v-deep thead th:nth-child(2),
.comparativa-ri-color-celdas ::v-deep thead th:nth-child(3),
.comparativa-ri-color-celdas ::v-deep tbody td:nth-child(1),
.comparativa-ri-color-celdas ::v-deep tbody td:nth-child(2),
.comparativa-ri-color-celdas ::v-deep tbody td:nth-child(3) {
  background-color: #ffffff;
}
.comparativa-ri-color-celdas ::v-deep thead th:nth-child(4),
.comparativa-ri-color-celdas ::v-deep thead th:nth-child(5),
.comparativa-ri-color-celdas ::v-deep thead th:nth-child(6),
.comparativa-ri-color-celdas ::v-deep tbody td:nth-child(4),
.comparativa-ri-color-celdas ::v-deep tbody td:nth-child(5),
.comparativa-ri-color-celdas ::v-deep tbody td:nth-child(6) {
  background-color: #e3f2fd;
}
.comparativa-ri-color-celdas ::v-deep thead th:nth-child(7),
.comparativa-ri-color-celdas ::v-deep thead th:nth-child(8),
.comparativa-ri-color-celdas ::v-deep thead th:nth-child(9),
.comparativa-ri-color-celdas ::v-deep tbody td:nth-child(7),
.comparativa-ri-color-celdas ::v-deep tbody td:nth-child(8),
.comparativa-ri-color-celdas ::v-deep tbody td:nth-child(9) {
  background-color: #ffebee;
}

.comparativa-ri-color-celdas ::v-deep tr.fila-actual-ri td {
  font-weight: 600;
  border-top: thin solid rgba(0, 0, 0, 0.12);
}

/* RH - %Ocupación: Inbi + Meta Inbi + Diferencia en azul; Fast + Meta Fast + Diferencia Fast en rojo */
.comparativa-rh-color-celdas ::v-deep thead th:nth-child(2),
.comparativa-rh-color-celdas ::v-deep thead th:nth-child(3),
.comparativa-rh-color-celdas ::v-deep thead th:nth-child(4),
.comparativa-rh-color-celdas ::v-deep tbody td:nth-child(2),
.comparativa-rh-color-celdas ::v-deep tbody td:nth-child(3),
.comparativa-rh-color-celdas ::v-deep tbody td:nth-child(4) {
  background-color: #e3f2fd;
}
.comparativa-rh-color-celdas ::v-deep thead th:nth-child(5),
.comparativa-rh-color-celdas ::v-deep thead th:nth-child(6),
.comparativa-rh-color-celdas ::v-deep thead th:nth-child(7),
.comparativa-rh-color-celdas ::v-deep tbody td:nth-child(5),
.comparativa-rh-color-celdas ::v-deep tbody td:nth-child(6),
.comparativa-rh-color-celdas ::v-deep tbody td:nth-child(7) {
  background-color: #ffebee;
}
.comparativa-rh-color-celdas ::v-deep thead th:nth-child(8),
.comparativa-rh-color-celdas ::v-deep thead th:nth-child(9),
.comparativa-rh-color-celdas ::v-deep thead th:nth-child(10),
.comparativa-rh-color-celdas ::v-deep tbody td:nth-child(8),
.comparativa-rh-color-celdas ::v-deep tbody td:nth-child(9),
.comparativa-rh-color-celdas ::v-deep tbody td:nth-child(10) {
  background-color: #eeeeee;
}

/* Finanzas: primero Inbi (azul), después Fast (rojo) */
.comparativa-fin-color-celdas ::v-deep thead th:nth-child(2),
.comparativa-fin-color-celdas ::v-deep thead th:nth-child(3),
.comparativa-fin-color-celdas ::v-deep thead th:nth-child(4),
.comparativa-fin-color-celdas ::v-deep thead th:nth-child(5),
.comparativa-fin-color-celdas ::v-deep thead th:nth-child(6),
.comparativa-fin-color-celdas ::v-deep thead th:nth-child(7),
.comparativa-fin-color-celdas ::v-deep tbody td:nth-child(2),
.comparativa-fin-color-celdas ::v-deep tbody td:nth-child(3),
.comparativa-fin-color-celdas ::v-deep tbody td:nth-child(4),
.comparativa-fin-color-celdas ::v-deep tbody td:nth-child(5),
.comparativa-fin-color-celdas ::v-deep tbody td:nth-child(6),
.comparativa-fin-color-celdas ::v-deep tbody td:nth-child(7) {
  background-color: #e3f2fd;
}
.comparativa-fin-color-celdas ::v-deep thead th:nth-child(8),
.comparativa-fin-color-celdas ::v-deep thead th:nth-child(9),
.comparativa-fin-color-celdas ::v-deep thead th:nth-child(10),
.comparativa-fin-color-celdas ::v-deep thead th:nth-child(11),
.comparativa-fin-color-celdas ::v-deep thead th:nth-child(12),
.comparativa-fin-color-celdas ::v-deep thead th:nth-child(13),
.comparativa-fin-color-celdas ::v-deep tbody td:nth-child(8),
.comparativa-fin-color-celdas ::v-deep tbody td:nth-child(9),
.comparativa-fin-color-celdas ::v-deep tbody td:nth-child(10),
.comparativa-fin-color-celdas ::v-deep tbody td:nth-child(11),
.comparativa-fin-color-celdas ::v-deep tbody td:nth-child(12),
.comparativa-fin-color-celdas ::v-deep tbody td:nth-child(13) {
  background-color: #ffebee;
}
/* Finanzas (tono tenue): Inbi Egresos + Meta + Comparativa */
.comparativa-fin-color-celdas ::v-deep thead th:nth-child(5),
.comparativa-fin-color-celdas ::v-deep thead th:nth-child(6),
.comparativa-fin-color-celdas ::v-deep thead th:nth-child(7),
.comparativa-fin-color-celdas ::v-deep tbody td:nth-child(5),
.comparativa-fin-color-celdas ::v-deep tbody td:nth-child(6),
.comparativa-fin-color-celdas ::v-deep tbody td:nth-child(7) {
  background-color: #eef7ff;
}
/* Finanzas (tono tenue): Fast Egresos + Meta + Comparativa */
.comparativa-fin-color-celdas ::v-deep thead th:nth-child(11),
.comparativa-fin-color-celdas ::v-deep thead th:nth-child(12),
.comparativa-fin-color-celdas ::v-deep thead th:nth-child(13),
.comparativa-fin-color-celdas ::v-deep tbody td:nth-child(11),
.comparativa-fin-color-celdas ::v-deep tbody td:nth-child(12),
.comparativa-fin-color-celdas ::v-deep tbody td:nth-child(13) {
  background-color: #fff3f4;
}

/* Operaciones - Clases: Periodo(1), Ciclo(2), Semana(3), Inbi+Meta+Dif+% (4-7)=azul; Fast+Meta+Dif+% (8-11)=rojo */
.comparativa-oclases-color-celdas ::v-deep thead th:nth-child(4),
.comparativa-oclases-color-celdas ::v-deep thead th:nth-child(5),
.comparativa-oclases-color-celdas ::v-deep thead th:nth-child(6),
.comparativa-oclases-color-celdas ::v-deep thead th:nth-child(7),
.comparativa-oclases-color-celdas ::v-deep tbody td:nth-child(4),
.comparativa-oclases-color-celdas ::v-deep tbody td:nth-child(5),
.comparativa-oclases-color-celdas ::v-deep tbody td:nth-child(6),
.comparativa-oclases-color-celdas ::v-deep tbody td:nth-child(7) {
  background-color: #e3f2fd;
}
.comparativa-oclases-color-celdas ::v-deep thead th:nth-child(8),
.comparativa-oclases-color-celdas ::v-deep thead th:nth-child(9),
.comparativa-oclases-color-celdas ::v-deep thead th:nth-child(10),
.comparativa-oclases-color-celdas ::v-deep thead th:nth-child(11),
.comparativa-oclases-color-celdas ::v-deep tbody td:nth-child(8),
.comparativa-oclases-color-celdas ::v-deep tbody td:nth-child(9),
.comparativa-oclases-color-celdas ::v-deep tbody td:nth-child(10),
.comparativa-oclases-color-celdas ::v-deep tbody td:nth-child(11) {
  background-color: #ffebee;
}

/* Control I. - Procesos: Inbi + Meta + Comparativa en azul; Fast + Meta + Comparativa en rojo */
.comparativa-ci-color-celdas ::v-deep thead th:nth-child(2),
.comparativa-ci-color-celdas ::v-deep thead th:nth-child(3),
.comparativa-ci-color-celdas ::v-deep thead th:nth-child(4),
.comparativa-ci-color-celdas ::v-deep tbody td:nth-child(2),
.comparativa-ci-color-celdas ::v-deep tbody td:nth-child(3),
.comparativa-ci-color-celdas ::v-deep tbody td:nth-child(4) {
  background-color: #e3f2fd;
}
.comparativa-ci-color-celdas ::v-deep thead th:nth-child(5),
.comparativa-ci-color-celdas ::v-deep thead th:nth-child(6),
.comparativa-ci-color-celdas ::v-deep thead th:nth-child(7),
.comparativa-ci-color-celdas ::v-deep tbody td:nth-child(5),
.comparativa-ci-color-celdas ::v-deep tbody td:nth-child(6),
.comparativa-ci-color-celdas ::v-deep tbody td:nth-child(7) {
  background-color: #ffebee;
}

/* Comercial: Periodo(1), Ciclo(2), Semana(3), Inbi(4)+Meta(5)+Dif(6)=azul; Inbi Conv(7)+Meta(8)+Dif(9)=azul tenue;
   Fast(10)+Meta(11)+Dif(12)=rojo; Fast Conv(13)+Meta(14)+Dif(15)=rojo tenue */
.comparativa-com-color-celdas ::v-deep thead th:nth-child(4),
.comparativa-com-color-celdas ::v-deep thead th:nth-child(5),
.comparativa-com-color-celdas ::v-deep thead th:nth-child(6),
.comparativa-com-color-celdas ::v-deep tbody td:nth-child(4),
.comparativa-com-color-celdas ::v-deep tbody td:nth-child(5),
.comparativa-com-color-celdas ::v-deep tbody td:nth-child(6) {
  background-color: #e3f2fd;
}
.comparativa-com-color-celdas ::v-deep thead th:nth-child(7),
.comparativa-com-color-celdas ::v-deep thead th:nth-child(8),
.comparativa-com-color-celdas ::v-deep thead th:nth-child(9),
.comparativa-com-color-celdas ::v-deep tbody td:nth-child(7),
.comparativa-com-color-celdas ::v-deep tbody td:nth-child(8),
.comparativa-com-color-celdas ::v-deep tbody td:nth-child(9) {
  background-color: #eef7ff;
}
.comparativa-com-color-celdas ::v-deep thead th:nth-child(10),
.comparativa-com-color-celdas ::v-deep thead th:nth-child(11),
.comparativa-com-color-celdas ::v-deep thead th:nth-child(12),
.comparativa-com-color-celdas ::v-deep tbody td:nth-child(10),
.comparativa-com-color-celdas ::v-deep tbody td:nth-child(11),
.comparativa-com-color-celdas ::v-deep tbody td:nth-child(12) {
  background-color: #ffebee;
}
.comparativa-com-color-celdas ::v-deep thead th:nth-child(13),
.comparativa-com-color-celdas ::v-deep thead th:nth-child(14),
.comparativa-com-color-celdas ::v-deep thead th:nth-child(15),
.comparativa-com-color-celdas ::v-deep tbody td:nth-child(13),
.comparativa-com-color-celdas ::v-deep tbody td:nth-child(14),
.comparativa-com-color-celdas ::v-deep tbody td:nth-child(15) {
  background-color: #fff3f4;
}

/* Operaciones - $$: Periodo(1), Ciclo(2), Semana(3), Inbi(4)+Meta(5)+Dif(6)=azul; Fast(7)+Meta(8)+Dif(9)=rojo */
.comparativa-mm-color-celdas ::v-deep thead th:nth-child(4),
.comparativa-mm-color-celdas ::v-deep thead th:nth-child(5),
.comparativa-mm-color-celdas ::v-deep thead th:nth-child(6),
.comparativa-mm-color-celdas ::v-deep tbody td:nth-child(4),
.comparativa-mm-color-celdas ::v-deep tbody td:nth-child(5),
.comparativa-mm-color-celdas ::v-deep tbody td:nth-child(6) {
  background-color: #e3f2fd;
}

.comparativa-mm-color-celdas ::v-deep thead th:nth-child(7),
.comparativa-mm-color-celdas ::v-deep thead th:nth-child(8),
.comparativa-mm-color-celdas ::v-deep thead th:nth-child(9),
.comparativa-mm-color-celdas ::v-deep tbody td:nth-child(7),
.comparativa-mm-color-celdas ::v-deep tbody td:nth-child(8),
.comparativa-mm-color-celdas ::v-deep tbody td:nth-child(9) {
  background-color: #ffebee;
}
</style>